/* hub-popup-cal-all 2026-10-01 */
/**
 * Extracted from workshop-booking.js initWorkshopBooking.
 * Init passes a scope object S; this file rebinds those names so the moved
 * body stays byte-for-byte the same. Loaded (defer) before workshop-booking.js.
 */
(function (global) {
  if (global.WorkshopBookingLocation) return;
  global.WorkshopBookingLocation = {
    attach: function (S) {
      if (!S) return;
      var wbUrlHasWizardDeepLink = S.wbUrlHasWizardDeepLink;
      var __WB_WAITLIST_API_URL__ = S.__WB_WAITLIST_API_URL__;
      var wbDiag = S.wbDiag;
      var __WBU = S.__WBU;
      var wbNormalizeEventStatus = S.wbNormalizeEventStatus;
      var wbEventCapacityRemaining = S.wbEventCapacityRemaining;
      var wbGetEventStatus = S.wbGetEventStatus;
      var wbExtractEventStatusRaw = S.wbExtractEventStatusRaw;
      var wbEventLookupKeys = S.wbEventLookupKeys;
      var wbBuildEventStatusLookup = S.wbBuildEventStatusLookup;
      var wbLookupEventStatus = S.wbLookupEventStatus;
      var wbIsDisplayStatusBookable = S.wbIsDisplayStatusBookable;
      var wbResolveEventStatus = S.wbResolveEventStatus;
      var wbIsEventSoldOut = S.wbIsEventSoldOut;
      var showSoldOutCapacityModal = S.showSoldOutCapacityModal;
      var wbIsEventBookable = S.wbIsEventBookable;
      var wbShouldHideEvent = S.wbShouldHideEvent;
      var wbPerf = S.wbPerf;
      function wbTracePush(evt) {
        try {
          if (global.WBSessionTrace && typeof global.WBSessionTrace.push === 'function') {
            global.WBSessionTrace.push(evt);
          }
        } catch (_) {}
      }
      function wbTraceFlush(reason) {
        try {
          if (global.WBSessionTrace && typeof global.WBSessionTrace.flush === 'function') {
            global.WBSessionTrace.flush(reason);
          }
        } catch (_) {}
      }
      function wbTraceContext(partial) {
        try {
          if (global.WBSessionTrace && typeof global.WBSessionTrace.setContext === 'function') {
            global.WBSessionTrace.setContext(partial);
          }
        } catch (_) {}
      }
      var __WB_lastHandledPlaceFp = S.__WB_lastHandledPlaceFp;
      var STATE_NAME_TO_CODE = S.STATE_NAME_TO_CODE;
      var normalizeStateCode = S.normalizeStateCode;
      var WB_CATALOG_REGION_NAME_TO_CODE = S.WB_CATALOG_REGION_NAME_TO_CODE;
      var parseCityStateFromFormattedAddress = S.parseCityStateFromFormattedAddress;
      var getPlaceDisplayLabel = S.getPlaceDisplayLabel;
      var _lastPlaceSelectMs = S._lastPlaceSelectMs;
      var onPlaceSelect = S.onPlaceSelect;
      var ensureDocPlaceListeners = S.ensureDocPlaceListeners;
      var applyWizardPlaceAutocompleteChrome = S.applyWizardPlaceAutocompleteChrome;
      var applyPlaceAutocompleteLightTheme = S.applyPlaceAutocompleteLightTheme;
      var ensurePlaceListeners = S.ensurePlaceListeners;
      var wbSheetBodyEl = S.wbSheetBodyEl;
      var bookingCandidates = S.bookingCandidates;
      var wizardBooking = S.wizardBooking;
      var booking = S.booking;
      var proxyFromRoot = S.proxyFromRoot;
      var PROXY_BASE = S.PROXY_BASE;
      var PROXY_BASE_FALLBACK = S.PROXY_BASE_FALLBACK;
      var eventsPathAttr = S.eventsPathAttr;
      var EVENTS_PATH = S.EVENTS_PATH;
      var venueListSortAttr = S.venueListSortAttr;
      var VENUE_LIST_SORT_MODE = S.VENUE_LIST_SORT_MODE;
      var DEV_MODE = S.DEV_MODE;
      var __wbEvents = S.__wbEvents;
      var joinProxyPath = S.joinProxyPath;
      var fetchWorkshopEvents = S.fetchWorkshopEvents;
      var logBackendRidIfPresent = S.logBackendRidIfPresent;
      var stateInput = S.stateInput;
      var cityInput = S.cityInput;
      var variantSelect = S.variantSelect;
      var variantFilterActive = S.variantFilterActive;
      var eventsRoot = S.eventsRoot;
      var eventsPlaceholder = S.eventsPlaceholder;
      var wbwDispatchVenueReset = S.wbwDispatchVenueReset;
      var showWorkshopFetchError = S.showWorkshopFetchError;
      var setLoading = S.setLoading;
      var variantWrap = S.variantWrap;
      var eventsPayloadScript = S.eventsPayloadScript;
      var productGid = S.productGid;
      var useLocationFirst = S.useLocationFirst;
      var googleKeyEl = S.googleKeyEl;
      var googleKey = S.googleKey;
      var bookingBox = S.bookingBox;
      var bookingHint = S.bookingHint;
      var panelScopeRoot = S.panelScopeRoot;
      var panelTitle = S.panelTitle;
      var panelHintEl = S.panelHintEl;
      var selectedSummary = S.selectedSummary;
      var selectedEventIdInput = S.selectedEventIdInput;
      var lastPriceEl = S.lastPriceEl;
      var selectedItemsWrap = S.selectedItemsWrap;
      var selectedItemsList = S.selectedItemsList;
      var selectedItemsTotal = S.selectedItemsTotal;
      var bookNowBtn = S.bookNowBtn;
      var addToCartBtn = S.addToCartBtn;
      var __wbLive = S.__wbLive || { variantFilterActive: false, lockedVenueRefId: '', lockedVenueGroupKey: '' };
      var summaryVenue = S.summaryVenue;
      var summaryVenueDetails = S.summaryVenueDetails;
      var summaryDatetime = S.summaryDatetime;
      var summaryCapacity = S.summaryCapacity;
      var summaryStatus = S.summaryStatus;
      var normalize = S.normalize;
      var normKey = S.normKey;
      var formatMoney = S.formatMoney;
      var setLastPriceElDisplay = S.setLastPriceElDisplay;
      var readJsonScriptInBooking = S.readJsonScriptInBooking;
      var WB_PRICE_DEBUG = S.WB_PRICE_DEBUG;
      var locationRules = S.locationRules;
      var venueOverrides = S.venueOverrides;
      var eventTimeOverrides = S.eventTimeOverrides;
      var getSelections = S.getSelections;
      var getSelectedVariantPriceCents = S.getSelectedVariantPriceCents;
      var getSelectedVariantId = S.getSelectedVariantId;
      var wstUpdate = S.wstUpdate;
      var wstFormatDateKey = S.wstFormatDateKey;
      var wstValues = S.wstValues;
      var wstValuesWithQty = S.wstValuesWithQty;
      var wstGetVariantNameFromButton = S.wstGetVariantNameFromButton;
      var wstGetActiveVariantName = S.wstGetActiveVariantName;
      var wstGetCurrentBookingFacts = S.wstGetCurrentBookingFacts;
      var normalizeEventIdForMatch = S.normalizeEventIdForMatch;
      var extractNumericEventIdForUrl = S.extractNumericEventIdForUrl;
      var getEventIdFromUrl = S.getEventIdFromUrl;
      var updateUrlForEventId = S.updateUrlForEventId;
      var __wbPricing = S.__wbPricing;
      var resolvePriceCents = S.resolvePriceCents;
      var diagnosticRun = S.diagnosticRun;
      var updateSelectedEventPrices = S.updateSelectedEventPrices;
      var setLastPriceFromVariant = S.setLastPriceFromVariant;
      var updateAllVariantCardPrices = S.updateAllVariantCardPrices;
      var parseVariantIdFromGid = S.parseVariantIdFromGid;
      var motionTriggerVariantById = S.motionTriggerVariantById;
      var pickCapacityFields = S.pickCapacityFields;
      var getRemainingCapacityFromCard = S.getRemainingCapacityFromCard;
      var wbRenderCapacityBadge = S.wbRenderCapacityBadge;
      var wbOpenStickyPanel = S.wbOpenStickyPanel;
      var validateSeatSelection = S.validateSeatSelection;
      var showPreviewPrice = S.showPreviewPrice;
      var buildSelectionDetailFromCard = S.buildSelectionDetailFromCard;
      var wbDispatchSelection = S.wbDispatchSelection;
      var wbApplyEventsStepHeading = S.wbApplyEventsStepHeading;
      var wbGetFirstBookableVenueCardInOpenGroup = S.wbGetFirstBookableVenueCardInOpenGroup;
      var wbLockVenueContextFromCard = S.wbLockVenueContextFromCard;
      var wbRestoreVenueContext = S.wbRestoreVenueContext;
      var wbRefreshBookingGuideUi = S.wbRefreshBookingGuideUi;
      var clearEventSelection = S.clearEventSelection;
      var getAvailableVariantIdsFromCard = S.getAvailableVariantIdsFromCard;
      var applyVariantCardVisibility = S.applyVariantCardVisibility;
      var ensureVariantUiSyncedFromSelect = S.ensureVariantUiSyncedFromSelect;
      var showSoldOutItemWarning = S.showSoldOutItemWarning;
      var setEventSelectionFromCard = S.setEventSelectionFromCard;
      var syncInCardSummaryForVenueCard = S.syncInCardSummaryForVenueCard;
      var applyFilters = S.applyFilters;
      var sortVisibleByStartsAt = S.sortVisibleByStartsAt;
      var allEventsPayload = S.allEventsPayload;
      var wbInitEventStatusLookup = S.wbInitEventStatusLookup;
      var setWbState = S.setWbState;
      var getLatLngFromPlace = S.getLatLngFromPlace || (typeof window !== 'undefined' ? window.getLatLngFromPlace : null);
      var getCityStateFromPlace = S.getCityStateFromPlace || (typeof window !== 'undefined' ? window.getCityStateFromPlace : null);
      try {
        const payloadEl = eventsPayloadScript;
        allEventsPayload = JSON.parse(payloadEl.textContent || '[]');
        window.__WB_EVENT_STATUS_LOOKUP__ = wbBuildEventStatusLookup(allEventsPayload);
      } catch (_) {
        allEventsPayload = [];
      }

      const GOOGLE_PLACES_TIMEOUT_MS = 8000;
      let googlePlacesLoadPromise = null;
      let gmapsLastError = null;
      function ensureGooglePlacesLoaded(key) {
        if (!key || !String(key).trim()) {
          gmapsLastError = '[WB] No Google key';
          return Promise.reject(new Error(gmapsLastError));
        }
        if (typeof window !== 'undefined' && window.google && window.google.maps && window.google.maps.places) return Promise.resolve();
        if (googlePlacesLoadPromise) return googlePlacesLoadPromise;
        const scriptEl = document.querySelector('script[src*="maps.googleapis.com"]');
        if (scriptEl) {
          googlePlacesLoadPromise = new Promise((resolve, reject) => {
            const start = Date.now();
            const check = () => {
              if (window.google && window.google.maps && window.google.maps.places) { googlePlacesLoadPromise = null; resolve(); return; }
              if (Date.now() - start > GOOGLE_PLACES_TIMEOUT_MS) {
                googlePlacesLoadPromise = null;
                gmapsLastError = '[WB] Google Places load timeout';
                reject(new Error(gmapsLastError));
                return;
              }
              setTimeout(check, 100);
            };
            check();
          });
          return googlePlacesLoadPromise;
        }
        googlePlacesLoadPromise = new Promise((resolve, reject) => {
          const timeout = setTimeout(() => {
            googlePlacesLoadPromise = null;
            gmapsLastError = '[WB] Google Places load timeout';
            if (window.__WB_DIAG__) console.warn(gmapsLastError + ' (blocked?)');
            reject(new Error(gmapsLastError));
          }, GOOGLE_PLACES_TIMEOUT_MS);
          const cbName = '__WB_GMAPS_READY_' + Date.now();
          window[cbName] = function () {
            clearTimeout(timeout);
            delete window[cbName];
            if (!window.google || !window.google.maps) {
              googlePlacesLoadPromise = null;
              gmapsLastError = '[WB] Google Places not available after load';
              reject(new Error(gmapsLastError));
              return;
            }
            const imp = window.google.maps.importLibrary;
            if (typeof imp === 'function') {
              imp('places').then(() => { googlePlacesLoadPromise = null; resolve(); }).catch((e) => {
                googlePlacesLoadPromise = null;
                gmapsLastError = (e && e.message) || '[WB] Google Places load failed';
                if (window.__WB_DIAG__) console.warn(gmapsLastError + ' (blocked?)');
                reject(e || new Error(gmapsLastError));
              });
            } else {
              if (window.google.maps.places) { googlePlacesLoadPromise = null; resolve(); }
              else { googlePlacesLoadPromise = null; gmapsLastError = '[WB] Google Places not available after load'; reject(new Error(gmapsLastError)); }
            }
          };
          const s = document.createElement('script');
          s.async = true;
          s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) + '&libraries=places&v=weekly&callback=' + cbName;
          s.onerror = () => {
            clearTimeout(timeout);
            delete window[cbName];
            googlePlacesLoadPromise = null;
            gmapsLastError = '[WB] Google Places script failed (blocked?)';
            if (window.__WB_DIAG__) console.warn(gmapsLastError);
            reject(new Error(gmapsLastError));
          };
          document.head.appendChild(s);
        });
        return googlePlacesLoadPromise;
      }

    const locInput = document.getElementById('workshop-location-input');
    const locSummary = booking.querySelector('[data-workshop-location-summary]');
    const useLocBtn = booking.querySelector('[data-workshop-use-location]');
    const retryBtn = document.getElementById('workshop-retry-location');
    const WB_THEME_DEFAULT_LAT = 39.833333;
    const WB_THEME_DEFAULT_LNG = -98.583333;
    const WB_THEME_DEFAULT_RADIUS_KM = 2650;
    const initialFetchLatRaw = (booking.dataset.wbInitialFetchLat || '').trim();
    const initialFetchLngRaw = (booking.dataset.wbInitialFetchLng || '').trim();
    const initialFetchRadiusRaw = (booking.dataset.wbInitialFetchRadiusKm || '').trim();
    let initialFetchLat = Number(initialFetchLatRaw);
    let initialFetchLng = Number(initialFetchLngRaw);
    let initialFetchRadiusKm = Number(initialFetchRadiusRaw);
    if (!Number.isFinite(initialFetchLat)) initialFetchLat = WB_THEME_DEFAULT_LAT;
    if (!Number.isFinite(initialFetchLng)) initialFetchLng = WB_THEME_DEFAULT_LNG;
    if (!Number.isFinite(initialFetchRadiusKm) || initialFetchRadiusKm <= 0) initialFetchRadiusKm = WB_THEME_DEFAULT_RADIUS_KM;

    var WB_DEFAULT_LOCATION_LABEL = '';
    if (typeof window !== 'undefined') window.__WB_USER_CHOSEN_LOCATION__ = false;

    /**
     * Single UI location writer. Only this function sets location input/summary text.
     * @param {{ label?: string, isDefault?: boolean, clear?: boolean }} opts - Use isDefault: true for default; clear: true to empty input; otherwise label for user selection.
     */
    function wbSetLocationUi(opts) {
      if (opts && opts.clear) {
        var label = '';
      } else {
        var displayLabel = (opts && opts.isDefault) ? WB_DEFAULT_LOCATION_LABEL : (opts && opts.label);
        if (displayLabel == null || String(displayLabel).trim() === '') displayLabel = WB_DEFAULT_LOCATION_LABEL;
        var label = String(displayLabel).trim();
      }
      if (
        !(opts && opts.clear) &&
        locInput &&
        document.activeElement === locInput
      ) {
        var typedNow = String(locInput.value || '').trim();
        if (typedNow && typedNow.toLowerCase() !== String(label || '').trim().toLowerCase()) {
          return;
        }
      }
      if (locSummary) locSummary.textContent = label;
      if (locInput) locInput.value = label;
      if (typeof booking.__wbWizardSyncSearchReel === 'function') booking.__wbWizardSyncSearchReel();
      if (typeof booking.__wbWizardSyncSearchClearBtn === 'function') booking.__wbWizardSyncSearchClearBtn();
      var placeEl = document.querySelector('#workshop-location-place-autocomplete,[data-workshop-place-autocomplete]');
      if (placeEl) {
        try {
          if (typeof placeEl.value !== 'undefined') placeEl.value = label;
          var innerInput = placeEl.shadowRoot && placeEl.shadowRoot.querySelector('input');
          if (innerInput) innerInput.value = label;
        } catch (_) {}
      }
      var hiddenInput = document.getElementById('workshop-location-input');
      if (hiddenInput) hiddenInput.value = label;
      var byAttr = document.querySelector('[data-workshop-location-input]');
      if (byAttr && byAttr !== placeEl) byAttr.value = label;
    }

    /** Google Place Details cache: place_id -> normalized ResolvedLocation. TTL optional. */
    const googlePlaceCache = Object.create(null);
    const GOOGLE_CACHE_TTL_MS = 24 * 60 * 60 * 1000;

    function renderEventsList(nearbyCityKeys, resolvedLat, resolvedLng) {
      const Flow = window.WorkshopLocationFlow;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const todayStr = today.toISOString().slice(0, 10);
      const end30 = new Date(today);
      end30.setDate(end30.getDate() + 30);
      const end30Str = end30.toISOString().slice(0, 10);
      const end60 = new Date(today);
      end60.setDate(end60.getDate() + 60);
      const end60Str = end60.toISOString().slice(0, 10);

      let filtered;
      if (Flow) {
        const deriveEventCityKey = Flow.deriveEventCityKey;
        const getDistanceBucketIndex = Flow.getDistanceBucketIndex;
        const distanceKm = Flow.distanceKm;

        function getEventCityKey(ev) {
          if (ev.city_key && String(ev.city_key).trim()) return String(ev.city_key).trim();
          return deriveEventCityKey(ev.state_code || ev.state, ev.city);
        }

        const nearbySet = new Set(nearbyCityKeys || []);

        if (window.__WB_DIAG__ && allEventsPayload.length > 0) {
          const sample = allEventsPayload[0];
          console.debug('[WORKSHOP] sample event', { city: sample.city, state: sample.state, state_code: sample.state_code, city_key: sample.city_key });
          console.debug('[WORKSHOP] nearby city_keys count', (nearbyCityKeys || []).length, 'first 10', (nearbyCityKeys || []).slice(0, 10));
        }

        let excludeReasons = { product: 0, status: 0, cityKey: 0, date: 0 };
        filtered = allEventsPayload.filter((ev) => {
          const ph = (ev.product_handle || '').trim().toLowerCase();
          if (ph !== productHandle) { excludeReasons.product++; return false; }
          const st = (ev.status || '').toLowerCase().replace(/\s/g, '_');
          if (st !== 'active' && st !== 'sold_out') { excludeReasons.status++; return false; }
          const evCityKey = getEventCityKey(ev);
          if (!evCityKey || !nearbySet.has(evCityKey)) { excludeReasons.cityKey++; return false; }
          const dk = ev.date_key || '';
          if (dk < todayStr) { excludeReasons.date++; return false; }
          if (dk <= end30Str) return true;
          return dk <= end60Str;
        });

        if (window.__WB_DIAG__) {
          console.debug('[WORKSHOP] filtered events count', filtered.length, 'exclusions', excludeReasons);
        }

        const N_EXPAND = 8;
        if (filtered.length < N_EXPAND) {
          filtered = allEventsPayload.filter((ev) => {
            const ph = (ev.product_handle || '').trim().toLowerCase();
            if (ph !== productHandle) return false;
            const st = (ev.status || '').toLowerCase().replace(/\s/g, '_');
            if (st !== 'active' && st !== 'sold_out') return false;
            const evCityKey = getEventCityKey(ev);
            if (!evCityKey || !nearbySet.has(evCityKey)) return false;
            const dk = ev.date_key || '';
            if (dk < todayStr) return false;
            return dk <= end60Str;
          });
        }
      } else {
        filtered = [];
      }

      var normalizedList = (filtered || []).map(function (ev) { return normalizeApiEvent(ev); }).filter(Boolean);
      // Venue-centric rendering
      var venueList = buildVenueListFromEvents(normalizedList, resolvedLat, resolvedLng);
      window.__WORKSHOP_VENUE_LIST__ = venueList;
      if (eventsPlaceholder) eventsPlaceholder.classList.add('pdp-wb-hidden');
      renderVenueCentricList(venueList);
      trySelectEventFromUrl();
    }

    function escapeHtml(s) {
      const div = document.createElement('div');
      div.textContent = s;
      return div.innerHTML;
    }

    let workshopFetchRequestId = 0;
    var workshopPerfCycleId = 0;
    var cityAbortController = null;
    var stateAbortController = null;
    var latLngAbortController = null;
    var WORKSHOP_CACHE_TTL_MS = 3 * 60 * 1000;
    var workshopEventsCache = Object.create(null);
    var workshopCacheShop = (typeof window !== 'undefined' && window.Shopify && window.Shopify.shop) ? String(window.Shopify.shop) : '';

    /** Cache key for lat/lng (rounded so same area hits cache). */
    function locationKey(lat, lng) {
      if (lat == null || lng == null || !Number.isFinite(Number(lat)) || !Number.isFinite(Number(lng))) return '';
      var a = Math.round(Number(lat) * 100000) / 100000;
      var b = Math.round(Number(lng) * 100000) / 100000;
      return workshopCacheShop + '|' + (productGid || '') + '|latlng:' + a + ',' + b;
    }
    var defaultRadiusRaw = Number((booking.dataset.wbDefaultRadiusKm || '').trim());
    var WB_DEFAULT_RADIUS = Number.isFinite(defaultRadiusRaw) && defaultRadiusRaw > 0 ? defaultRadiusRaw : WB_THEME_DEFAULT_RADIUS_KM;
    /**
     * Single source of truth for radius from theme settings.
     * @param {Element} root — the booking component root (containerEl).
     * @returns {number} — radius in km; falls back to configured default.
     */
    function getRadiusKm(root) {
      var fromRoot = root ? Number((root.dataset.wbDefaultRadiusKm || '').trim()) : NaN;
      if (Number.isFinite(fromRoot) && fromRoot > 0) return fromRoot;
      if (DEV_MODE) console.warn('[WB_RADIUS] missing configured default radius, using fallback=' + WB_DEFAULT_RADIUS);
      return WB_DEFAULT_RADIUS;
    }
    /** Cache key includes the radius that was computed for this action (passed in, not re-read). */
    function cacheKeyWithRadius(lat, lng, radiusKm) { var k = locationKey(lat, lng); return k ? k + '|r' + radiusKm + '|wbv1|discovery' : ''; }

    /** @deprecated Local workshop-locations JSON removed; distances use API venue coords only. */
    function getCityList() {
      return [];
    }

    // Domain libs (SRP): geo / calendar-window / venue-model. Loaded before this file.
    var Geo = window.WorkshopBookingGeo || {};
    var CalWin = window.WorkshopBookingCalendarWindow || {};
    var VenueModel = window.WorkshopBookingVenueModel || {};
    var venueSort = VenueModel.create ? VenueModel.create({ sortMode: VENUE_LIST_SORT_MODE }) : {};
    var getDisplayCity = VenueModel.getDisplayCity;
    var toNum = Geo.toNum;
    var isValidCoord = Geo.isValidCoord;
    var haversineKm = Geo.haversineKm;
    var wbParseCoord = Geo.parseCoord;
    var wbFirstCoord = Geo.firstCoord;
    var wbVenueGroupKey = VenueModel.venueGroupKey;
    var wbVenueGroupLabel = VenueModel.venueGroupLabel;
    var wbHaversineKm = Geo.haversineKmSafe;
    var wbVenueHasEventsFlag = VenueModel.venueHasEventsFlag;
    var wbVenueIsWaitlistFromApi = VenueModel.venueIsWaitlistFromApi;
    var wbVenueHasScheduledEvents = VenueModel.venueHasScheduledEvents;
    var wbVenueHasBookableEvents = VenueModel.venueHasBookableEvents;
    var wbPad2 = CalWin.pad2;
    var wbYmKey = CalWin.ymKey;
    var wbShiftYm = CalWin.shiftYm;
    var wbMonthDateBounds = CalWin.monthDateBounds;
    var wbWindowDateBounds = CalWin.windowDateBounds;
    var wbNormalizeVenueRefKey = VenueModel.normalizeVenueRefKey;
    var wbCatalogRegisterRef = VenueModel.catalogRegisterRef;
    var wbMarkRefInSet = VenueModel.markRefInSet;
    var wbRefInSet = VenueModel.refInSet;

    function wbWizardFlatVenueDistance(entry) {
      var d = toNum(entry.venue && entry.venue.distance_km);
      if (d != null && Number.isFinite(d)) return d;
      d = toNum(entry.grpDist);
      if (d != null && Number.isFinite(d)) return d;
      return Infinity;
    }

    function wbDedupeWizardFlatVenueEntries(entries) {
      var byKey = Object.create(null);
      var ordered = [];
      for (var di = 0; di < entries.length; di++) {
        var e = entries[di];
        var k = e.dedupeKey;
        if (!k) {
          ordered.push(e);
          continue;
        }
        if (!byKey[k]) {
          byKey[k] = e;
          ordered.push(e);
          continue;
        }
        var prev = byKey[k];
        wbMergeVenueImageIfMissing(prev.venue, e.venue);
        wbMergeVenueImageIfMissing(e.venue, prev.venue);
        if (!prev.flatHasBookable && e.flatHasBookable) {
          var idx = ordered.indexOf(prev);
          if (idx >= 0) ordered[idx] = e;
          byKey[k] = e;
        } else if (prev.flatHasBookable && !e.flatHasBookable) {
          wbMergeVenueImageIfMissing(prev.venue, e.venue);
        }
      }
      return ordered;
    }

    function wbSortWizardFlatVenueEntries(entries) {
      // Coral hub already sorted (pin → nearest event → waitlist A–Z). Do not re-order by distance.
      if (booking && booking.__wbCoralHub) return entries;
      entries.sort(function (a, b) {
        var ea = a.flatHasBookable ? 1 : 0;
        var eb = b.flatHasBookable ? 1 : 0;
        if (ea !== eb) return eb - ea;
        var sa = wbVenueHasScheduledEvents(a.venue) ? 1 : 0;
        var sb = wbVenueHasScheduledEvents(b.venue) ? 1 : 0;
        if (sa !== sb) return sb - sa;
        return wbWizardFlatVenueDistance(a) - wbWizardFlatVenueDistance(b);
      });
      return entries;
    }

    /** Accordion group has any venue with scheduled events. */
    var wbGroupHasScheduledEvents = VenueModel.groupHasScheduledEvents;
    var wbCmpDistanceKmProp = Geo.cmpDistanceKmProp;
    var wbSortVenuesInGroup = venueSort.sortVenuesInGroup;
    var wbNormalizeSearchCityToken = VenueModel.normalizeSearchCityToken;
    var wbGroupExactCityMatch = VenueModel.groupExactCityMatch;
    var wbSortVenueGroups = venueSort.sortVenueGroups;

    /** Single source for user location. Only window.__wbUserLoc is set here. */
    function wbSetUserLoc(lat, lng) {
      if (lat == null && lng == null) {
        window.__wbUserLoc = null;
        return;
      }
      if (Number.isFinite(Number(lat)) && Number.isFinite(Number(lng))) {
        window.__wbUserLoc = { lat: Number(lat), lng: Number(lng) };
      }
    }

    /** Build venue list from already-normalized events (used when timing normalize separately). */
    function buildVenueListFromEventsNormalized(list, userLat, userLng) {
      list = (Array.isArray(list) ? list : []).filter(Boolean);
      var cityList = getCityList();
      var cityByKey = Object.create(null);
      cityList.forEach(function (loc) {
        var k = (loc.city_key || '').toString().trim().toLowerCase();
        if (k) cityByKey[k] = loc;
      });
      var venuesByRef = Object.create(null);
      list.forEach(function (ev) {
        var vref = (ev.venue_ref_id || '').toString().trim() || ('v_' + (ev.venue_name || '').toString().trim());
        if (!vref) return;
        if (!venuesByRef[vref]) {
          var first = ev;
          var vlat = wbFirstCoord(first.venue_lat, first.lat);
          var vlng = wbFirstCoord(first.venue_lng, first.lng);
          var ck = (ev.city_key || '').toString().trim();
          var cityLoc = ck ? cityByKey[ck.toLowerCase()] : null;
          var userLoc = (typeof userLat === 'number' && typeof userLng === 'number') ? { lat: userLat, lng: userLng } : (typeof window !== 'undefined' && window.__wbUserLoc) || null;
          var ulat = userLoc ? toNum(userLoc.lat) : null;
          var ulng = userLoc ? toNum(userLoc.lng) : null;
          var distKm = null;
          if (ulat != null && ulng != null && Number.isFinite(ulat) && Number.isFinite(ulng)) {
            if (vlat != null && vlng != null) {
              distKm = wbHaversineKm(ulat, ulng, vlat, vlng);
            } else if (cityLoc && isValidCoord(toNum(cityLoc.lat), toNum(cityLoc.lng))) {
              distKm = wbHaversineKm(ulat, ulng, toNum(cityLoc.lat), toNum(cityLoc.lng));
            }
          }
          if (distKm != null && !Number.isFinite(distKm)) distKm = null;
          if (window.__WB_DEBUG__) console.debug('[WB BUILD] venue', { label: first.city_name || first.venue_name, venueLat: vlat, venueLng: vlng, userLat: ulat, userLng: ulng, cityKey: ck, cityLocLat: cityLoc ? cityLoc.lat : null, cityLocLng: cityLoc ? cityLoc.lng : null, distKm: distKm });
          var cityName = (first.city_name || first.city || '').toString().trim();
          venuesByRef[vref] = {
            venue_ref_id: vref,
            venue_name: (ev.venue_name || '').toString().trim(),
            venue_address: (ev.venue_address || '').toString().trim(),
            venue_phone: (ev.venue_phone || '').toString().trim(),
            venue_work_hours: (ev.venue_work_hours || '').toString().trim(),
            venue_tags: Array.isArray(ev.venue_tags) ? ev.venue_tags.slice() : [],
            city_key: ck,
            city_name: cityName,
            venue_lat: vlat,
            venue_lng: vlng,
            lat: vlat,
            lng: vlng,
            distance_km: distKm,
            venue_image: wbVenueImageFromApiEvent(first),
            events: []
          };
          wbAssignVenueFacilityFields(venuesByRef[vref], first);
        }
        venuesByRef[vref].events.push(ev);
        var evImgW = wbVenueImageFromApiEvent(ev);
        if (evImgW && !venuesByRef[vref].venue_image) venuesByRef[vref].venue_image = evImgW;
        if (
          (!venuesByRef[vref].facility_options || !venuesByRef[vref].facility_options.length) &&
          ((Array.isArray(ev.facility_options) && ev.facility_options.length) ||
            (Array.isArray(ev.facilities) && ev.facilities.length))
        ) {
          wbAssignVenueFacilityFields(venuesByRef[vref], ev);
        }
      });
      var groupsByCity = Object.create(null);
      Object.keys(venuesByRef).forEach(function (vref) {
        var v = venuesByRef[vref];
        var groupKey = wbVenueGroupKey(v);
        if (!groupsByCity[groupKey]) {
          var firstEvent = (v.events && v.events[0]) || {};
          var ckLower = (v.city_key || '').toString().trim().toLowerCase();
          var cityLoc = ckLower ? cityByKey[ckLower] : null;
          var cityLabel = wbVenueGroupLabel(v);
          if (!cityLabel) cityLabel = (cityLoc && cityLoc.city) ? cityLoc.city : getDisplayCity(firstEvent);
          var userLoc = (typeof userLat === 'number' && typeof userLng === 'number') ? { lat: userLat, lng: userLng } : (typeof window !== 'undefined' && window.__wbUserLoc) || null;
          var ulat = toNum(userLoc && userLoc.lat);
          var ulng = toNum(userLoc && userLoc.lng);
          var vlat = toNum(v.venue_lat);
          var vlng = toNum(v.venue_lng);
          var distanceKm = null;
          if (ulat != null && ulng != null && Number.isFinite(ulat) && Number.isFinite(ulng)) {
            if (vlat != null && vlng != null && Number.isFinite(vlat) && Number.isFinite(vlng)) {
              distanceKm = wbHaversineKm(ulat, ulng, vlat, vlng);
            } else if (cityLoc && isValidCoord(toNum(cityLoc.lat), toNum(cityLoc.lng))) {
              distanceKm = wbHaversineKm(ulat, ulng, toNum(cityLoc.lat), toNum(cityLoc.lng));
            }
          }
          if (window.__WB_DEBUG__) console.debug('[WB BUILD] group', { label: cityLabel, groupKey: groupKey, city_key: ckLower, vlat: vlat, vlng: vlng, cityLocLat: cityLoc ? cityLoc.lat : null, cityLocLng: cityLoc ? cityLoc.lng : null, ulat: ulat, ulng: ulng, distKm: distanceKm });
          groupsByCity[groupKey] = {
            city_key: (v.city_key || '').toString().trim(),
            group_key: groupKey,
            city_label: cityLabel,
            distance_km: distanceKm,
            venues: []
          };
        }
        groupsByCity[groupKey].venues.push(v);
        var vDist = toNum(v.distance_km);
        if (vDist != null && Number.isFinite(vDist) && (groupsByCity[groupKey].distance_km == null || vDist < groupsByCity[groupKey].distance_km)) {
          groupsByCity[groupKey].distance_km = vDist;
        }
      });
      var groups = Object.keys(groupsByCity).map(function (k) { return groupsByCity[k]; });
      groups.forEach(function (g) {
        wbSortVenuesInGroup(g.venues);
      });
      wbSortVenueGroups(groups);
      return { groups: groups };
    }

    /** Build __WORKSHOP_VENUE_LIST__ from API events: groups by city_key or lat/lng when city_key missing, distances from user lat/lng. */
    function buildVenueListFromEvents(events, userLat, userLng) {
      var list = (Array.isArray(events) ? events : []).map(normalizeApiEvent).filter(Boolean);
      var cityList = getCityList();
      var cityByKey = Object.create(null);
      cityList.forEach(function (loc) {
        var k = (loc.city_key || '').toString().trim().toLowerCase();
        if (k) cityByKey[k] = loc;
      });

      var venuesByRef = Object.create(null);
      list.forEach(function (ev) {
        var vref = (ev.venue_ref_id || '').toString().trim() || ('v_' + (ev.venue_name || '').toString().trim());
        if (!vref) return;
        if (!venuesByRef[vref]) {
          var first = ev;
          var vlat = wbFirstCoord(first.venue_lat, first.lat);
          var vlng = wbFirstCoord(first.venue_lng, first.lng);
          var ck = (ev.city_key || '').toString().trim();
          var cityLoc = ck ? cityByKey[ck.toLowerCase()] : null;
          var userLoc = (typeof userLat === 'number' && typeof userLng === 'number') ? { lat: userLat, lng: userLng } : (typeof window !== 'undefined' && window.__wbUserLoc) || null;
          var ulat = userLoc ? toNum(userLoc.lat) : null;
          var ulng = userLoc ? toNum(userLoc.lng) : null;
          var distKm = null;
          if (ulat != null && ulng != null && Number.isFinite(ulat) && Number.isFinite(ulng)) {
            if (vlat != null && vlng != null) {
              distKm = wbHaversineKm(ulat, ulng, vlat, vlng);
            } else if (cityLoc && isValidCoord(toNum(cityLoc.lat), toNum(cityLoc.lng))) {
              distKm = wbHaversineKm(ulat, ulng, toNum(cityLoc.lat), toNum(cityLoc.lng));
            }
          }
          if (distKm != null && !Number.isFinite(distKm)) distKm = null;
          if (window.__WB_DEBUG__) console.debug('[WB BUILD] venue', { label: first.city_name || first.venue_name, venueLat: vlat, venueLng: vlng, userLat: ulat, userLng: ulng, cityKey: ck, cityLocLat: cityLoc ? cityLoc.lat : null, cityLocLng: cityLoc ? cityLoc.lng : null, distKm: distKm });
          var cityName = (first.city_name || first.city || '').toString().trim();
          venuesByRef[vref] = {
            venue_ref_id: vref,
            venue_name: (ev.venue_name || '').toString().trim(),
            venue_address: (ev.venue_address || '').toString().trim(),
            venue_phone: (ev.venue_phone || '').toString().trim(),
            venue_work_hours: (ev.venue_work_hours || '').toString().trim(),
            venue_tags: Array.isArray(ev.venue_tags) ? ev.venue_tags.slice() : [],
            city_key: ck,
            city_name: cityName,
            venue_lat: vlat,
            venue_lng: vlng,
            lat: vlat,
            lng: vlng,
            distance_km: distKm,
            venue_image: wbVenueImageFromApiEvent(first),
            events: []
          };
          wbAssignVenueFacilityFields(venuesByRef[vref], first);
        }
        venuesByRef[vref].events.push(ev);
        var evImgW2 = wbVenueImageFromApiEvent(ev);
        if (evImgW2 && !venuesByRef[vref].venue_image) venuesByRef[vref].venue_image = evImgW2;
        if (
          (!venuesByRef[vref].facility_options || !venuesByRef[vref].facility_options.length) &&
          ((Array.isArray(ev.facility_options) && ev.facility_options.length) ||
            (Array.isArray(ev.facilities) && ev.facilities.length))
        ) {
          wbAssignVenueFacilityFields(venuesByRef[vref], ev);
        }
      });

      var groupsByCity = Object.create(null);
      Object.keys(venuesByRef).forEach(function (vref) {
        var v = venuesByRef[vref];
        var groupKey = wbVenueGroupKey(v);
        if (!groupsByCity[groupKey]) {
          var firstEvent = (v.events && v.events[0]) || {};
          var ckLower = (v.city_key || '').toString().trim().toLowerCase();
          var cityLoc = ckLower ? cityByKey[ckLower] : null;
          var cityLabel = wbVenueGroupLabel(v);
          if (!cityLabel) cityLabel = (cityLoc && cityLoc.city) ? cityLoc.city : getDisplayCity(firstEvent);
          var userLoc = (typeof userLat === 'number' && typeof userLng === 'number') ? { lat: userLat, lng: userLng } : (typeof window !== 'undefined' && window.__wbUserLoc) || null;
          var ulat = toNum(userLoc && userLoc.lat);
          var ulng = toNum(userLoc && userLoc.lng);
          var vlat = toNum(v.venue_lat);
          var vlng = toNum(v.venue_lng);
          var distanceKm = null;
          if (ulat != null && ulng != null && Number.isFinite(ulat) && Number.isFinite(ulng)) {
            if (vlat != null && vlng != null && Number.isFinite(vlat) && Number.isFinite(vlng)) {
              distanceKm = wbHaversineKm(ulat, ulng, vlat, vlng);
            } else if (cityLoc && isValidCoord(toNum(cityLoc.lat), toNum(cityLoc.lng))) {
              distanceKm = wbHaversineKm(ulat, ulng, toNum(cityLoc.lat), toNum(cityLoc.lng));
            }
          }
          if (window.__WB_DEBUG__) console.debug('[WB BUILD] group', { label: cityLabel, groupKey: groupKey, city_key: ckLower, vlat: vlat, vlng: vlng, cityLocLat: cityLoc ? cityLoc.lat : null, cityLocLng: cityLoc ? cityLoc.lng : null, ulat: ulat, ulng: ulng, distKm: distanceKm });
          groupsByCity[groupKey] = {
            city_key: (v.city_key || '').toString().trim(),
            group_key: groupKey,
            city_label: cityLabel,
            distance_km: distanceKm,
            venues: []
          };
        }
        groupsByCity[groupKey].venues.push(v);
        var vDist = toNum(v.distance_km);
        if (vDist != null && Number.isFinite(vDist) && (groupsByCity[groupKey].distance_km == null || vDist < groupsByCity[groupKey].distance_km)) {
          groupsByCity[groupKey].distance_km = vDist;
        }
      });

      var groups = Object.keys(groupsByCity).map(function (k) { return groupsByCity[k]; });
      groups.forEach(function (g) {
        wbSortVenuesInGroup(g.venues);
      });
      wbSortVenueGroups(groups);

      return { groups: groups };
    }

    /**
     * Copy facility_options (+ optional accessibility flags) from API/catalog venue onto list stubs.
     * Good to Know (product-info-card) listens to wbw:venue-selected which reads these fields.
     */
    function wbNormalizeFacilityOptionLabel(item) {
      if (item == null) return '';
      if (typeof item === 'string' || typeof item === 'number') return String(item).trim();
      if (typeof item === 'object') {
        var label = item.label || item.name || item.title || item.value || item.handle || '';
        return String(label == null ? '' : label).trim();
      }
      return String(item).trim();
    }

    function wbExtractVenueFacilityFields(src) {
      var out = {
        facility_options: [],
        wheelchair_accessible: false,
        accessible_toilets: false,
        ground_level: false,
        accessible_parking: false,
        lift_to_all_floors: false,
      };
      if (!src || typeof src !== 'object') return out;
      var raw =
        Array.isArray(src.facility_options) && src.facility_options.length
          ? src.facility_options
          : Array.isArray(src.facilities)
            ? src.facilities
            : [];
      var seen = Object.create(null);
      for (var i = 0; i < raw.length; i++) {
        var t = wbNormalizeFacilityOptionLabel(raw[i]);
        if (!t) continue;
        var k = t.toLowerCase();
        if (seen[k]) continue;
        seen[k] = true;
        out.facility_options.push(t);
      }
      out.wheelchair_accessible = src.wheelchair_accessible === true;
      out.accessible_toilets = src.accessible_toilets === true;
      out.ground_level = src.ground_level === true;
      out.accessible_parking =
        src.accessible_parking === true || src.accessible_parking_spot === true;
      out.lift_to_all_floors = src.lift_to_all_floors === true;
      return out;
    }

    function wbAssignVenueFacilityFields(target, src) {
      if (!target || typeof target !== 'object') return target;
      var fields = wbExtractVenueFacilityFields(src);
      target.facility_options = fields.facility_options;
      target.facilities = fields.facility_options.slice();
      target.wheelchair_accessible = fields.wheelchair_accessible;
      target.accessible_toilets = fields.accessible_toilets;
      target.ground_level = fields.ground_level;
      target.accessible_parking = fields.accessible_parking;
      target.lift_to_all_floors = fields.lift_to_all_floors;
      return target;
    }

    /**
     * Discovery / groups payload → venue list (thin Step 1: has_events, optional stub events).
     * Bookable: has_events === true (events may be []). Waitlist: has_events === false or empty stub.
     */
    function buildVenueListFromApiGroups(apiGroups, userLat, userLng) {
      var venueList = { groups: [] };
      var apiGroupsResolved = Array.isArray(apiGroups) ? apiGroups : [];
      var cityList = getCityList();
      var cityByKey = Object.create(null);
      cityList.forEach(function (loc) {
        var k = (loc.city_key || '').toString().trim().toLowerCase();
        if (k) cityByKey[k] = loc;
      });
      var seenRef = Object.create(null);
      for (var gix = 0; gix < apiGroupsResolved.length; gix++) {
        var g = apiGroupsResolved[gix];
        if (!g || !Array.isArray(g.venues)) continue;
        for (var vix = 0; vix < g.venues.length; vix++) {
          var v = g.venues[vix];
          if (!v || typeof v !== 'object') continue;
          var hasFlag = wbVenueHasEventsFlag(v);
          if (hasFlag == null) {
            throw new Error('discovery venue missing has_events');
          }
          var vref =
            v.venue_ref_id != null && String(v.venue_ref_id).trim() !== ''
              ? String(v.venue_ref_id).trim()
              : '';
          if (!vref) {
            throw new Error('discovery venue missing venue_ref_id');
          }
          if (wbRefInSet(seenRef, vref)) continue;
          wbMarkRefInSet(seenRef, vref);
          var isWaitlistVenue = hasFlag === false;
          var vname = (v.venue_name || v.name || '').toString().trim();
          var vlat = wbFirstCoord(v.lat, v.latitude, v.venue_lat);
          var vlng = wbFirstCoord(v.lng, v.longitude, v.venue_lng);
          var ck = ((v.city_key != null && String(v.city_key).trim()) ? String(v.city_key).trim() : (g.city_key != null && String(g.city_key).trim()) ? String(g.city_key).trim() : '');
          var cityLoc = ck ? cityByKey[ck.toLowerCase()] : null;
          var userLoc = (typeof userLat === 'number' && typeof userLng === 'number') ? { lat: userLat, lng: userLng } : (typeof window !== 'undefined' && window.__wbUserLoc) || null;
          var ulat = userLoc ? toNum(userLoc.lat) : null;
          var ulng = userLoc ? toNum(userLoc.lng) : null;
          var distKm = null;
          if (ulat != null && ulng != null && Number.isFinite(ulat) && Number.isFinite(ulng)) {
            if (vlat != null && vlng != null) {
              distKm = wbHaversineKm(ulat, ulng, vlat, vlng);
            } else if (cityLoc && isValidCoord(toNum(cityLoc.lat), toNum(cityLoc.lng))) {
              distKm = wbHaversineKm(ulat, ulng, toNum(cityLoc.lat), toNum(cityLoc.lng));
            }
          }
          var cityName = (v.city_name || v.city || g.city_name || g.city || '').toString().trim() || vname;
          var regionCode = String(v.region_code || v.state_code || '').trim().toUpperCase();
          if (regionCode && !/^[A-Z]{2}$/.test(regionCode)) regionCode = '';
          var addr = (v.venue_address || v.address || '').toString().trim();
          if (!regionCode) regionCode = wbRegionCodeFromAddress(addr);
          var rawEvents = Array.isArray(v.events) ? v.events : [];
          var normalizedEvents = [];
          if (!isWaitlistVenue && rawEvents.length) {
            for (var ei = 0; ei < rawEvents.length; ei++) {
              var nev = normalizeApiEvent(rawEvents[ei]);
              if (nev) normalizedEvents.push(nev);
            }
          }
          var venueObj = {
            venue_ref_id: vref,
            venue_api_id: (v.id != null ? v.id : vref),
            venue_name: vname,
            venue_handle: (v.venue_handle || v.handle || '').toString().trim(),
            venue_address: addr,
            address: addr,
            venue_phone: (v.phone || '').toString().trim(),
            venue_work_hours: (v.work_hours || '').toString().trim(),
            venue_tags: Array.isArray(v.tags) ? v.tags.map(function (x) { return String(x); }) : [],
            city_key: ck,
            city_name: cityName,
            region_code: regionCode,
            state_code: regionCode,
            venue_lat: vlat,
            venue_lng: vlng,
            lat: vlat,
            lng: vlng,
            distance_km: distKm,
            venue_image: wbVenueImageFromStub(v),
            has_events: hasFlag,
            next_date_key: v.next_date_key != null ? String(v.next_date_key).trim() : '',
            events_count: v.events_count != null ? Number(v.events_count) : normalizedEvents.length,
            events: normalizedEvents,
            _wbLoadedMonths: Object.create(null)
          };
          wbAssignVenueFacilityFields(venueObj, v);
          if (normalizedEvents.length) wbMarkMonthsFromEventList(venueObj, normalizedEvents);
          if (isWaitlistVenue) venueObj._wbWaitlistVenue = true;
          var groupKey = wbVenueGroupKey(venueObj);
          var targetGroup = null;
          for (var gi = 0; gi < venueList.groups.length; gi++) {
            if (venueList.groups[gi].group_key === groupKey) {
              targetGroup = venueList.groups[gi];
              break;
            }
          }
          if (!targetGroup) {
            var ckLower = (venueObj.city_key || '').toString().trim().toLowerCase();
            var cLoc = ckLower ? cityByKey[ckLower] : null;
            var cityLabel = wbVenueGroupLabel(venueObj);
            if (!cityLabel) cityLabel = (cLoc && cLoc.city) ? cLoc.city : getDisplayCity({ city: g.city, city_key: g.city_key, venue_name: venueObj.venue_name, venue_handle: v.handle });
            targetGroup = {
              city_key: ck,
              group_key: groupKey,
              city_label: cityLabel,
              distance_km: distKm,
              venues: []
            };
            venueList.groups.push(targetGroup);
          }
          targetGroup.venues.push(venueObj);
          var vDist = toNum(venueObj.distance_km);
          if (vDist != null && Number.isFinite(vDist) && (targetGroup.distance_km == null || vDist < targetGroup.distance_km)) {
            targetGroup.distance_km = vDist;
          }
        }
      }
      venueList.groups.forEach(function (gg) {
        if (!gg.venues) return;
        wbSortVenuesInGroup(gg.venues);
      });
      wbSortVenueGroups(venueList.groups);
      return venueList;
    }

    /**
     * Append venues from API groups that have no bookable events (include_empty_venues).
     * Mutates venueList.groups in place; re-sorts groups and venues by distance.
     *
     * Empty-venue pipeline (has_events === false, or missing flag + empty events):
     * 1) Here: each API venue becomes a venue stub with _wbWaitlistVenue: true, venue_name from v.venue_name, lat/lng from API.
     * 2) renderVenueCentricList: iterates venueList.groups[].venues[]; for each stub builds a .workshop-venue-card with
     *    h4.wb-venue-name (venue title) + Join Waitlist; see isWaitlistOnly branch (~line 4425+).
     */
    function mergeEmptyVenuesFromApi(venueList, apiGroups, userLat, userLng) {
      if (!venueList || !Array.isArray(venueList.groups)) return;
      var apiGroupsResolved = Array.isArray(apiGroups) ? apiGroups : [];
      var cityList = getCityList();
      var cityByKey = Object.create(null);
      cityList.forEach(function (loc) {
        var k = (loc.city_key || '').toString().trim().toLowerCase();
        if (k) cityByKey[k] = loc;
      });
      var seenRef = Object.create(null);
      venueList.groups.forEach(function (g) {
        (g.venues || []).forEach(function (v) {
          var r = (v.venue_ref_id || v.id || '').toString().trim();
          if (r) wbMarkRefInSet(seenRef, r);
        });
      });
      for (var gix = 0; gix < apiGroupsResolved.length; gix++) {
        var g = apiGroupsResolved[gix];
        if (!g || !Array.isArray(g.venues)) continue;
        var apiVenues = g.venues;
        for (var vix = 0; vix < apiVenues.length; vix++) {
          var v = apiVenues[vix];
          if (!v || typeof v !== 'object') continue;
          var isWaitlistVenue = wbVenueIsWaitlistFromApi(v);
          if (!isWaitlistVenue) continue;
          var vname = (v.venue_name || v.name || v.title || '').toString().trim();
          var vlat = wbFirstCoord(v.lat, v.latitude, v.venue_lat);
          var vlng = wbFirstCoord(v.lng, v.longitude, v.venue_lng);
          var vref =
            (v.venue_ref_id != null && String(v.venue_ref_id).trim() !== '')
              ? String(v.venue_ref_id).trim()
              : (v.id != null && String(v.id).trim() !== '')
                ? String(v.id).trim()
              : (v.handle != null && String(v.handle).trim() !== '')
                ? String(v.handle).trim()
                : 'v_waitlist_' + gix + '_' + vix + '_' + (vname ? String(vname).replace(/\W+/g, '-').replace(/^-|-$/g, '').toLowerCase().slice(0, 80) : 'venue');
          if (!vref || wbRefInSet(seenRef, vref)) continue;
          wbMarkRefInSet(seenRef, vref);
          var ck = ((v.city_key != null && String(v.city_key).trim()) ? String(v.city_key).trim() : (g.city_key != null && String(g.city_key).trim()) ? String(g.city_key).trim() : '');
          var cityLoc = ck ? cityByKey[ck.toLowerCase()] : null;
          var userLoc = (typeof userLat === 'number' && typeof userLng === 'number') ? { lat: userLat, lng: userLng } : (typeof window !== 'undefined' && window.__wbUserLoc) || null;
          var ulat = userLoc ? toNum(userLoc.lat) : null;
          var ulng = userLoc ? toNum(userLoc.lng) : null;
          var distKm = null;
          if (ulat != null && ulng != null && Number.isFinite(ulat) && Number.isFinite(ulng)) {
            if (vlat != null && vlng != null) {
              distKm = wbHaversineKm(ulat, ulng, vlat, vlng);
            } else if (cityLoc && isValidCoord(toNum(cityLoc.lat), toNum(cityLoc.lng))) {
              distKm = wbHaversineKm(ulat, ulng, toNum(cityLoc.lat), toNum(cityLoc.lng));
            }
          }
          var cityName = (v.city_name || v.city || g.city_name || g.city || '').toString().trim() || vname;
          var regionCode = String(v.region_code || v.state_code || '').trim().toUpperCase();
          if (regionCode && !/^[A-Z]{2}$/.test(regionCode)) regionCode = '';
          var addr = (v.venue_address || v.address || '').toString().trim();
          if (!regionCode) regionCode = wbRegionCodeFromAddress(addr);
          var venueStub = {
            venue_ref_id: vref,
            venue_api_id: (v.id != null ? v.id : vref),
            venue_name: vname,
            venue_handle: (v.venue_handle || v.handle || '').toString().trim(),
            venue_address: addr,
            address: addr,
            venue_phone: (v.phone || '').toString().trim(),
            venue_work_hours: (v.work_hours || '').toString().trim(),
            venue_tags: Array.isArray(v.tags) ? v.tags.map(function (x) { return String(x); }) : [],
            city_key: ck,
            city_name: cityName,
            region_code: regionCode,
            state_code: regionCode,
            venue_lat: vlat,
            venue_lng: vlng,
            lat: vlat,
            lng: vlng,
            distance_km: distKm,
            venue_image: wbVenueImageFromStub(v),
            events: [],
            _wbWaitlistVenue: true
          };
          wbAssignVenueFacilityFields(venueStub, v);
          var groupKey = wbVenueGroupKey(venueStub);
          var targetGroup = null;
          for (var gi = 0; gi < venueList.groups.length; gi++) {
            if (venueList.groups[gi].group_key === groupKey) {
              targetGroup = venueList.groups[gi];
              break;
            }
          }
          if (!targetGroup) {
            var ckLower = (venueStub.city_key || '').toString().trim().toLowerCase();
            var cLoc = ckLower ? cityByKey[ckLower] : null;
            var cityLabel = wbVenueGroupLabel(venueStub);
            if (!cityLabel) cityLabel = (cLoc && cLoc.city) ? cLoc.city : getDisplayCity({ city: g.city, city_key: g.city_key, venue_name: venueStub.venue_name, venue_handle: v.handle });
            targetGroup = {
              city_key: ck,
              group_key: groupKey,
              city_label: cityLabel,
              distance_km: distKm,
              venues: []
            };
            venueList.groups.push(targetGroup);
          }
          targetGroup.venues.push(venueStub);
          var vDist = toNum(venueStub.distance_km);
          if (vDist != null && Number.isFinite(vDist) && (targetGroup.distance_km == null || vDist < targetGroup.distance_km)) {
            targetGroup.distance_km = vDist;
          }
        }
      }
      venueList.groups.forEach(function (g) {
        if (!g.venues) return;
        wbSortVenuesInGroup(g.venues);
      });
      wbSortVenueGroups(venueList.groups);
    }

    /**
     * App Proxy often returns only venues that already have events. Shop `venue` metaobjects
     * (Liquid: shop.metaobjects.venue.values → data-wb-venues-waitlist-catalog)
     * fill gaps. Wizard: include the full catalog (no radius cut) so every registered venue
     * appears and new metaobjects show up on next load. Non-wizard: keep radius filter.
     */
    function mergeShopCatalogVenuesForWaitlist(venueList, bookingRoot, userLat, userLng, radiusKm) {
      if (!venueList || !Array.isArray(venueList.groups) || !bookingRoot) return;
      var isWizard = !!(bookingRoot.classList && bookingRoot.classList.contains('wb-wizard'));
      if (
        !isWizard &&
        (userLat == null ||
          userLng == null ||
          !Number.isFinite(Number(userLat)) ||
          !Number.isFinite(Number(userLng)))
      ) {
        return;
      }
      var rKm = Number(radiusKm);
      if (!isWizard && (!Number.isFinite(rKm) || rKm <= 0)) return;
      var el = bookingRoot.querySelector('script[type="application/json"][data-wb-venues-waitlist-catalog]');
      if (!el || !el.textContent) return;
      var rows;
      try {
        rows = JSON.parse(el.textContent);
      } catch (e) {
        return;
      }
      if (!Array.isArray(rows) || !rows.length) return;

      /** Skip any venue already in the list (with or without events) — avoid radius-only / dup gaps. */
      var refsAlreadyListed = Object.create(null);
      var namesWithSessions = Object.create(null);
      venueList.groups.forEach(function (g) {
        (g.venues || []).forEach(function (v) {
          var er = (v.venue_ref_id || v.id || '').toString().trim();
          if (er) wbMarkRefInSet(refsAlreadyListed, er);
          if (wbVenueHasScheduledEvents(v) || wbVenueHasBookableEvents(v)) {
            var nk = wbNormalizeVenueNameKey(v.venue_name || v.name || v.city_name || v.city || '');
            if (nk) namesWithSessions[nk] = true;
          }
        });
      });

      var synthetic = [];
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        if (!row || typeof row !== 'object') continue;
        var vref =
          row.venue_ref_id != null && String(row.venue_ref_id).trim()
            ? String(row.venue_ref_id).trim()
            : '';
        if (!vref) continue;

        /* Already listed (often API id ≠ catalog GID): still copy image/region onto matches. */
        if (wbRefInSet(refsAlreadyListed, vref)) {
          wbApplyCatalogRowToVenueList(venueList, row);
          continue;
        }

        var catName =
          row.venue_name != null && String(row.venue_name).trim()
            ? String(row.venue_name).trim()
            : 'Venue';
        var catNameKey = wbNormalizeVenueNameKey(catName);
        /* Same city/venue already returned with sessions under a different ref — never waitlist it. */
        if (catNameKey && namesWithSessions[catNameKey]) {
          wbApplyCatalogRowToVenueList(venueList, row);
          wbMarkRefInSet(refsAlreadyListed, vref);
          continue;
        }

        var catalogStub = {
          venue_name: catName,
          name: catName,
          city_name: catName,
          city: row.city != null ? String(row.city).trim() : catName,
          city_key: row.city_key != null ? String(row.city_key).trim() : '',
          venue_handle:
            row.venue_handle != null && String(row.venue_handle).trim()
              ? String(row.venue_handle).trim()
              : '',
          handle:
            row.venue_handle != null && String(row.venue_handle).trim()
              ? String(row.venue_handle).trim()
              : '',
          venue_ref_id: vref,
        };
        if (!wbWizardVenueAllowedForProduct(catalogStub, bookingRoot)) continue;

        var vlat = row.lat != null && row.lat !== '' ? Number(row.lat) : NaN;
        var vlng = row.lng != null && row.lng !== '' ? Number(row.lng) : NaN;
        var hasCoords = Number.isFinite(vlat) && Number.isFinite(vlng);
        if (!isWizard) {
          if (!hasCoords) continue;
          var distKm = wbHaversineKm(Number(userLat), Number(userLng), vlat, vlng);
          if (distKm == null || !Number.isFinite(distKm) || distKm > rKm) continue;
        }
        var catAddr =
          row.venue_address != null && String(row.venue_address).trim()
            ? String(row.venue_address).trim()
            : '';
        var catRegion = wbResolveCatalogRegionCode(row);
        var catalogSynthetic = {
          id: vref,
          venue_name: catName,
          venue_ref_id: vref,
          venue_handle:
            row.venue_handle != null && String(row.venue_handle).trim()
              ? String(row.venue_handle).trim()
              : '',
          address: catAddr,
          venue_address: catAddr,
          lat: hasCoords ? vlat : null,
          lng: hasCoords ? vlng : null,
          city_name: catName,
          region_code: catRegion || '',
          state_code: catRegion || '',
          venue_image: wbCoerceImageUrl(row.venue_image != null ? row.venue_image : ''),
          events: [],
          has_events: false,
          _wbWaitlistVenue: true
        };
        wbAssignVenueFacilityFields(catalogSynthetic, row);
        synthetic.push(catalogSynthetic);
        wbMarkRefInSet(refsAlreadyListed, vref);
      }
      if (synthetic.length) {
        mergeEmptyVenuesFromApi(venueList, [{ city_key: '', city_name: '', venues: synthetic }], userLat, userLng);
      }
      /* API venues with mismatched refs still get catalog image/region by name. */
      for (var ri = 0; ri < rows.length; ri++) {
        if (rows[ri]) wbApplyCatalogRowToVenueList(venueList, rows[ri]);
      }
    }

    function wbVenueMatchesCatalogRow(venue, row) {
      if (!venue || !row) return false;
      var rowRef = String(row.venue_ref_id || '').trim();
      var venueRef = String(venue.venue_ref_id || venue.id || '').trim();
      if (rowRef && venueRef) {
        if (rowRef === venueRef || wbNormalizeVenueRefKey(rowRef) === wbNormalizeVenueRefKey(venueRef)) {
          return true;
        }
        var rowNum = rowRef.match(/(\d+)$/);
        var venueNum = venueRef.match(/(\d+)$/);
        if (rowNum && venueNum && rowNum[1] === venueNum[1]) return true;
      }
      var rowHandle = String(row.venue_handle || '').trim().toLowerCase();
      var venueHandle = String(venue.venue_handle || venue.handle || '').trim().toLowerCase();
      if (rowHandle && venueHandle && rowHandle === venueHandle) return true;
      var rowName = wbNormalizeVenueNameKey(row.venue_name);
      if (!rowName) return false;
      var names = [venue.venue_name, venue.name, venue.city_name, venue.city];
      for (var ni = 0; ni < names.length; ni++) {
        var probe = wbNormalizeVenueNameKey(names[ni]);
        if (probe && (probe === rowName || wbVenueNameKeysMatch(probe, rowName))) return true;
      }
      return false;
    }

    function wbApplyCatalogRowToVenueList(venueList, row) {
      if (!venueList || !row || !Array.isArray(venueList.groups)) return;
      var img = wbCoerceImageUrl(row.venue_image != null ? row.venue_image : '');
      var code = wbResolveCatalogRegionCode(row);
      var addr =
        row.venue_address != null && String(row.venue_address).trim()
          ? String(row.venue_address).trim()
          : '';
      venueList.groups.forEach(function (g) {
        (g.venues || []).forEach(function (v) {
          if (!wbVenueMatchesCatalogRow(v, row)) return;
          if (wbIsValidImageUrl(img) && !wbIsValidImageUrl(wbVenueImageFromStub(v))) {
            v.venue_image = img;
          }
          if (code) {
            if (!v.region_code) v.region_code = code;
            if (!v.state_code) v.state_code = code;
          }
          if (addr) {
            if (!v.address) v.address = addr;
            if (!v.venue_address) v.venue_address = addr;
          }
          if (row.venue_handle && !v.venue_handle) {
            v.venue_handle = String(row.venue_handle).trim();
          }
          if (row.venue_ref_id && !v.venue_ref_id) {
            v.venue_ref_id = String(row.venue_ref_id).trim();
          }
          if (
            (!v.facility_options || !v.facility_options.length) &&
            ((Array.isArray(row.facility_options) && row.facility_options.length) ||
              (Array.isArray(row.facilities) && row.facilities.length))
          ) {
            wbAssignVenueFacilityFields(v, row);
          }
        });
      });
    }

    function getShopMyshopifyDomain() {
      return (typeof window !== 'undefined' && window.Shopify && window.Shopify.shop) ? String(window.Shopify.shop).trim() : '';
    }

    function resolveWorkshopTypeFromProductTags() {
      if (window.__WB_WORKSHOP_TYPE_PROMISE) return window.__WB_WORKSHOP_TYPE_PROMISE;
      window.__WB_WORKSHOP_TYPE_PROMISE = new Promise(function (resolve) {
        if (window.__WB_WORKSHOP_TYPE_RESOLVED != null) {
          resolve(window.__WB_WORKSHOP_TYPE_RESOLVED);
          return;
        }
        var handle = (booking.dataset && booking.dataset.productHandle) ? String(booking.dataset.productHandle).trim() : '';
        if (!handle) {
          window.__WB_WORKSHOP_TYPE_RESOLVED = '';
          resolve('');
          return;
        }
        fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            var tags = [];
            if (p && p.tags) {
              if (Array.isArray(p.tags)) tags = p.tags;
              else tags = String(p.tags).split(',').map(function (t) { return String(t).trim(); }).filter(Boolean);
            }
            var types = ['mosaic', 'resin', 'ceramic', 'flower'];
            var found = '';
            for (var ti = 0; ti < tags.length; ti++) {
              var raw = String(tags[ti]).toLowerCase().trim();
              for (var ui = 0; ui < types.length; ui++) {
                if (raw === types[ui] || raw.indexOf(types[ui]) !== -1) {
                  found = types[ui];
                  break;
                }
              }
              if (found) break;
            }
            window.__WB_WORKSHOP_TYPE_RESOLVED = found;
            resolve(found);
          })
          .catch(function () {
            window.__WB_WORKSHOP_TYPE_RESOLVED = '';
            resolve('');
          });
      });
      return window.__WB_WORKSHOP_TYPE_PROMISE;
    }

    /** Session-scoped HTTP response cache (sessionStorage); used as a quick first paint, then refreshed from events-v. TTL 8m. */
    var WB_EVENTS_SS_TTL_MS = 8 * 60 * 1000;

    /**
     * Key for sessionStorage events cache: ~1km grid + radius + product + discovery mode.
     * Example: wb_events_v1_-36.86_174.76_100_gid…_discovery
     */
    function eventsSessionStorageKey(lat, lng, radiusKm) {
      if (lat == null || lng == null || !Number.isFinite(Number(lat)) || !Number.isFinite(Number(lng))) return '';
      var la = Math.round(Number(lat) * 100) / 100;
      var ln = Math.round(Number(lng) * 100) / 100;
      var r = Number(radiusKm);
      if (!Number.isFinite(r)) return '';
      var base = 'wb_events_v1_' + la + '_' + ln + '_' + r;
      if (productGid) base += '_' + String(productGid).replace(/[^a-zA-Z0-9_-]/g, '_');
      base += '_discovery';
      return base;
    }

    /** True when API payload has venues or events (discovery stubs count). Never cache empty OK responses. */
    function isEventsPayloadCacheable(data) {
      if (!data || data.ok !== true) return false;
      if (Array.isArray(data.events) && data.events.length > 0) return true;
      if (Array.isArray(data.groups)) {
        for (var gi = 0; gi < data.groups.length; gi++) {
          var g = data.groups[gi];
          if (!g || !Array.isArray(g.venues) || !g.venues.length) continue;
          return true;
        }
      }
      if (Array.isArray(data.waitlist_venues) && data.waitlist_venues.length > 0) return true;
      return false;
    }

    function readEventsCache(key) {
      if (!key) return null;
      try {
        var raw = sessionStorage.getItem(key);
        if (!raw) return null;
        var entry = JSON.parse(raw);
        if (!entry || typeof entry.cachedAt !== 'number' || entry.payload == null) return null;
        if (Date.now() - entry.cachedAt >= WB_EVENTS_SS_TTL_MS) return null;
        if (!isEventsPayloadCacheable(entry.payload)) return null;
        return entry;
      } catch (_) {
        return null;
      }
    }

    function shouldBypassEventsCache(mode) {
      return mode === 'refresh' || mode === 'refresh_user' || mode === 'network';
    }

    function writeEventsCache(key, payload) {
      if (!key || !payload || !isEventsPayloadCacheable(payload)) return;
      try {
        sessionStorage.setItem(key, JSON.stringify({ cachedAt: Date.now(), payload: payload }));
      } catch (_) {}
    }

    function wbFetchEventsFromResolvedCoords(lat, lng, presetLabel, fetchSource) {
      var locationLabel = presetLabel || 'Current location';
      var source = fetchSource || 'geolocation';
      if (DEV_MODE) {
        console.log(
          '[WB_RADIUS] location resolved lat=' + lat + ' lng=' + lng + ' source=' + source + ' radius=' + getRadiusKm(booking)
        );
      }
      if (window.__WB_DIAG__) console.log('[WB_DIAG] coords → lat/lng fetch', { lat: lat, lng: lng, source: source });
      var REVERSE_GEOCODE_TIMEOUT_MS = 2500;
      var done = false;
      function doFetch() {
        if (done) return;
        done = true;
        wbSetLocationUi({ label: locationLabel });
        fetchEventsByLatLng(booking, lat, lng, getRadiusKm(booking), { source: source, label: locationLabel });
      }
      if (presetLabel || source === 'ip_geolocation') {
        doFetch();
        return;
      }
      var rgeoKey =
        'wb_rgeo:' + (Math.round(Number(lat) * 100) / 100) + ',' + (Math.round(Number(lng) * 100) / 100);
      try {
        var cachedLabel = sessionStorage.getItem(rgeoKey);
        if (cachedLabel) {
          locationLabel = cachedLabel;
          doFetch();
          return;
        }
      } catch (_) {}
      if (window.google && window.google.maps && window.google.maps.Geocoder) {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({ location: { lat: lat, lng: lng } }, function (results, status) {
          if (done) return;
          if (status === 'OK' && results && results[0]) {
            var city = '';
            var state = '';
            (results[0].address_components || []).forEach(function (comp) {
              if (comp.types.includes('locality')) city = comp.long_name;
              else if (!city && comp.types.includes('sublocality_level_1')) city = comp.long_name;
              else if (!city && comp.types.includes('postal_town')) city = comp.long_name;
              if (comp.types.includes('administrative_area_level_1')) state = comp.short_name;
            });
            var resolvedLabel = [city, state].filter(Boolean).join(', ');
            if (resolvedLabel) {
              locationLabel = resolvedLabel;
              try {
                sessionStorage.setItem(rgeoKey, resolvedLabel);
              } catch (_) {}
            }
            if (window.__WB_DIAG__) console.log('[WB_DIAG] Reverse geocode resolved:', locationLabel);
          }
          doFetch();
        });
        setTimeout(function () {
          doFetch();
        }, REVERSE_GEOCODE_TIMEOUT_MS);
      } else {
        doFetch();
      }
    }

    function wbWizardHasRenderableVenueList(venueList) {
      var groups = venueList && venueList.groups;
      if (!Array.isArray(groups) || !groups.length) return false;
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].venues && groups[i].venues.length) return true;
      }
      return false;
    }

    /** Bookable Step-1 venues only (has_events === true). Catalog waitlist stubs do not count. */
    function wbVenueListRefFingerprint(venueList) {
      var refs = [];
      var groups = venueList && venueList.groups;
      if (!Array.isArray(groups)) return '';
      for (var i = 0; i < groups.length; i++) {
        var venues = groups[i] && groups[i].venues;
        if (!Array.isArray(venues)) continue;
        for (var j = 0; j < venues.length; j++) {
          var v = venues[j];
          if (!v) continue;
          refs.push(String(v.venue_ref_id || v.venue_id || ''));
        }
      }
      return refs.sort().join('|');
    }

    function wbVenueListHasBookableVenue(venueList) {
      var groups = venueList && venueList.groups;
      if (!Array.isArray(groups) || !groups.length) return false;
      for (var i = 0; i < groups.length; i++) {
        var venues = groups[i] && groups[i].venues;
        if (!Array.isArray(venues)) continue;
        for (var j = 0; j < venues.length; j++) {
          if (venues[j] && venues[j].has_events === true) return true;
        }
      }
      return false;
    }

    function wbWizardStoreInitialVenueList(venueList) {
      if (!booking.classList || !booking.classList.contains('wb-wizard')) return;
      if (!wbWizardHasRenderableVenueList(venueList)) return;
      /* Waitlist-only catalog floods must never become the restore snapshot. */
      if (!wbVenueListHasBookableVenue(venueList)) return;
      try {
        booking.__wbWizardInitialVenueList = JSON.parse(JSON.stringify(venueList));
        booking.__wbWizardInitialLocation = window.__WORKSHOP_LOCATION__
          ? Object.assign({}, window.__WORKSHOP_LOCATION__)
          : null;
      } catch (_) {}
    }

    function wbWizardRestoreInitialVenueListIfEmpty(ph) {
      if (!booking.classList || !booking.classList.contains('wb-wizard')) return false;
      var snapshot = booking.__wbWizardInitialVenueList;
      if (!wbWizardHasRenderableVenueList(snapshot)) return false;
      window.__WORKSHOP_VENUE_LIST__ = snapshot;
      if (booking.__wbWizardInitialLocation) {
        window.__WORKSHOP_LOCATION__ = Object.assign({}, booking.__wbWizardInitialLocation);
        wbSetUserLoc(booking.__wbWizardInitialLocation.lat, booking.__wbWizardInitialLocation.lng);
        wbSetLocationUi({ isDefault: true });
      }
      if (typeof window !== 'undefined') window.__WB_USER_CHOSEN_LOCATION__ = false;
      renderVenueCentricList(snapshot);
      if (ph) ph.classList.add('pdp-wb-hidden');
      try {
        wbRefreshBookingGuideUi();
      } catch (_) {}
      return true;
    }

    /**
     * Wizard venue search: typed query stays as-is.
     * Dropdown = Google cities on top, matching loaded venues/events below.
     * Grid updates only after the shopper picks a row.
     */
    function wbWizardInventorySearchActive() {
      return !!(booking && booking.classList && booking.classList.contains('wb-wizard'));
    }

    function wbWizardGetInventoryVenueList() {
      if (wbWizardHasRenderableVenueList(booking.__wbWizardInitialVenueList)) {
        return booking.__wbWizardInitialVenueList;
      }
      if (wbWizardHasRenderableVenueList(window.__WORKSHOP_VENUE_LIST__)) {
        return window.__WORKSHOP_VENUE_LIST__;
      }
      return null;
    }

    function wbWizardVenueSearchCityLabel(venue, group) {
      var city = '';
      if (venue) {
        city = String(venue.city_name || venue.city || '').trim();
      }
      if (!city && group) {
        city = String(group.city_label || group.city_name || '').trim();
        if (city && /^us-[a-z]{2}-/i.test(city)) city = '';
      }
      if (!city && venue) {
        city = String(venue.venue_name || venue.name || '').trim();
      }
      return city;
    }

    function wbWizardFormatVenueSearchLabel(venue, group) {
      var city = wbWizardVenueSearchCityLabel(venue, group);
      var region = wbResolveVenueRegionCode(venue, city, booking);
      if (city && region) return wbWizardVenueLabelWithRegionCode(city, region);
      if (city) return city;
      if (venue && venue.venue_name) return String(venue.venue_name).trim();
      return '';
    }

    function wbWizardVenueSearchHaystack(venue, group, label) {
      if (!venue) return '';
      /* City + state/region only — do not search street/hotel address (e.g. "me" → Homewood/Melrose). */
      var parts = [
        venue.venue_name,
        venue.name,
        venue.city_name,
        venue.city,
        venue.state,
        venue.state_code,
        venue.region,
        venue.region_code,
        venue.region_name,
        group && group.city_label,
        group && group.city_name,
        group && group.state,
        group && group.state_code,
        label,
        wbLookupRegionCodeFromCatalog(venue, label, booking)
      ];
      return parts
        .filter(function (p) {
          return p != null && String(p).trim() !== '';
        })
        .join(' ')
        .toLowerCase();
    }

    function wbWizardFlattenInventoryVenues(venueList) {
      var rows = [];
      var groups = venueList && venueList.groups;
      if (!Array.isArray(groups)) return rows;
      for (var gi = 0; gi < groups.length; gi++) {
        var grp = groups[gi];
        var venues = (grp && grp.venues) || [];
        for (var vi = 0; vi < venues.length; vi++) {
          var venue = venues[vi];
          if (!venue) continue;
          var label = wbWizardFormatVenueSearchLabel(venue, grp);
          rows.push({
            venue: venue,
            group: grp,
            label: label,
            refId: String(venue.venue_ref_id || '').trim()
          });
        }
      }
      return rows;
    }

    function wbWizardFilterInventoryByQuery(rows, query) {
      var q = String(query == null ? '' : query)
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ');
      if (!q || !Array.isArray(rows)) return [];
      var tokens = q.split(' ').filter(Boolean);
      var scored = [];
      rows.forEach(function (row) {
        var venue = row.venue;
        var label = String(row.label || '').toLowerCase();
        var city = wbWizardVenueSearchCityLabel(venue, row.group).toLowerCase();
        var name = venue && venue.venue_name != null ? String(venue.venue_name).trim().toLowerCase() : '';
        var hay = wbWizardVenueSearchHaystack(venue, row.group, row.label);
        if (!hay) return;
        var allMatch = tokens.every(function (t) {
          return hay.indexOf(t) !== -1;
        });
        if (!allMatch) return;
        var score = Math.max(
          wbWizardMatchScore(city, q),
          wbWizardMatchScore(name, q),
          wbWizardMatchScore(label, q)
        );
        if (score < 40) score = 50;
        scored.push({ venue: venue, group: row.group, score: score, label: row.label, refId: row.refId });
      });
      scored.sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        var aBook = wbVenueHasBookableEvents(a.venue) ? 1 : 0;
        var bBook = wbVenueHasBookableEvents(b.venue) ? 1 : 0;
        if (bBook !== aBook) return bBook - aBook;
        return String(a.label).localeCompare(String(b.label), undefined, { sensitivity: 'base' });
      });
      return scored;
    }

    function wbWizardBuildFilteredVenueList(snapshot, scored) {
      if (!snapshot || !Array.isArray(snapshot.groups)) return { groups: [] };
      var allow = Object.create(null);
      if (Array.isArray(scored)) {
        scored.forEach(function (row) {
          var id = String((row && (row.refId || (row.venue && row.venue.venue_ref_id))) || '').trim();
          if (id) allow[id] = true;
        });
      }
      var outGroups = [];
      snapshot.groups.forEach(function (grp) {
        var kept = [];
        (grp.venues || []).forEach(function (v) {
          var id = String((v && v.venue_ref_id) || '').trim();
          if (id && allow[id]) kept.push(v);
        });
        if (!kept.length) return;
        var copy = Object.assign({}, grp);
        copy.venues = kept;
        outGroups.push(copy);
      });
      return { groups: outGroups };
    }

    function wbWizardVenueCoords(venue) {
      if (!venue || typeof venue !== 'object') return null;
      var lat = wbFirstCoord(venue.venue_lat, venue.lat, venue.latitude);
      var lng = wbFirstCoord(venue.venue_lng, venue.lng, venue.longitude);
      if (lat == null || lng == null || !Number.isFinite(lat) || !Number.isFinite(lng)) return null;
      return { lat: lat, lng: lng };
    }

    function wbWizardPickInventorySearchRecenter(scored) {
      if (!Array.isArray(scored) || !scored.length) return null;
      for (var bi = 0; bi < scored.length; bi++) {
        if (wbVenueHasBookableEvents(scored[bi] && scored[bi].venue)) return null;
      }
      for (var i = 0; i < scored.length; i++) {
        var row = scored[i];
        var venue = row && row.venue;
        if (!venue) continue;
        var coords = wbWizardVenueCoords(venue);
        if (!coords) continue;
        var ref = String(venue.venue_ref_id || venue.id || row.refId || '').trim();
        var label =
          (row.label && String(row.label).trim()) ||
          String(venue.venue_name || venue.city_name || venue.name || 'Venue').trim();
        return { lat: coords.lat, lng: coords.lng, ref: ref, label: label };
      }
      return null;
    }

    function wbWizardMaybeRecenterInventorySearch(query, scored) {
      if (!wbWizardInventorySearchActive()) return;
      var q = String(query == null ? '' : query).trim();
      if (q.length < 3) return;
      var target = wbWizardPickInventorySearchRecenter(scored);
      if (!target) return;
      var key = String(target.ref || target.lat + ',' + target.lng);
      if (booking.__wbWizardSearchRecenterKey === key) return;
      booking.__wbWizardSearchRecenterKey = key;
      booking.__wbWizardPendingInventoryQuery = q;
      if (DEV_MODE) {
        console.log('[WB] inventory search recenter', target.label, target.lat, target.lng);
      }
      fetchEventsByLatLng(booking, target.lat, target.lng, 250, {
        source: 'inventory_search',
        label: target.label
      });
    }

    function wbWizardMergeVenueListIntoInitial(venueList) {
      if (!venueList || !Array.isArray(venueList.groups)) return;
      var base = booking.__wbWizardInitialVenueList;
      if (!wbWizardHasRenderableVenueList(base)) {
        wbWizardStoreInitialVenueList(venueList);
        return;
      }
      venueList.groups.forEach(function (g) {
        (g.venues || []).forEach(function (v) {
          if (!v) return;
          var id = String(v.venue_ref_id || '').trim();
          if (!id) return;
          if (!wbVenueHasBookableEvents(v) && !wbVenueHasScheduledEvents(v)) return;
          var replaced = false;
          base.groups.forEach(function (bg) {
            if (!bg.venues) return;
            for (var i = 0; i < bg.venues.length; i++) {
              var bv = bg.venues[i];
              if (String((bv && bv.venue_ref_id) || '').trim() !== id) continue;
              bg.venues[i] = v;
              replaced = true;
            }
          });
          if (!replaced) {
            base.groups.push(Object.assign({}, g, { venues: [v] }));
          }
        });
      });
      base.groups = base.groups.filter(function (g) {
        return g && Array.isArray(g.venues) && g.venues.length > 0;
      });
    }

    function wbWizardApplyInventoryFilter(query) {
      var snapshot = wbWizardGetInventoryVenueList();
      if (!snapshot) return false;
      var q = String(query == null ? '' : query).trim();
      booking.__wbWizardInventoryFilterActive = !!q;
      var nextList = snapshot;
      var scored = null;
      if (q) {
        scored = wbWizardFilterInventoryByQuery(wbWizardFlattenInventoryVenues(snapshot), q);
        nextList = wbWizardBuildFilteredVenueList(snapshot, scored);
      } else {
        booking.__wbWizardSearchRecenterKey = '';
        booking.__wbWizardPendingInventoryQuery = '';
      }
      window.__WORKSHOP_VENUE_LIST__ = nextList;
      renderVenueCentricList(nextList);
      try {
        wbRefreshBookingGuideUi();
      } catch (_) {}
      if (q && scored) wbWizardMaybeRecenterInventorySearch(q, scored);
      return true;
    }

    function wbWizardCurrentVenueMatches(query) {
      /** Coral hub: match ALL type-collection city products (search index), not only painted page. */
      if (booking.__wbCoralHub && Array.isArray(booking.__wbCoralSearchCatalog) && booking.__wbCoralSearchCatalog.length) {
        var coralSnap = {
          groups: [{ key: 'coral-hub', label: 'Venues', venues: booking.__wbCoralSearchCatalog }],
        };
        return wbWizardFilterInventoryByQuery(wbWizardFlattenInventoryVenues(coralSnap), query).slice(0, 8);
      }
      var snapshot = wbWizardGetInventoryVenueList();
      if (!snapshot) return [];
      return wbWizardFilterInventoryByQuery(wbWizardFlattenInventoryVenues(snapshot), query).slice(0, 6);
    }

    function wbWizardMatchScore(text, query) {
      var t = String(text || '')
        .trim()
        .toLowerCase();
      var q = String(query || '')
        .trim()
        .toLowerCase();
      if (!t || !q) return 0;
      if (t === q) return 400;
      if (t.indexOf(q) === 0) return Math.max(220, 320 - Math.min(90, (t.length - q.length) * 6));
      var idx = t.indexOf(q);
      if (idx > 0) return Math.max(80, 160 - Math.min(60, idx * 8));
      return 0;
    }

    function wbWizardCoralAvailabilityUnknown(venue) {
      return !!(venue && venue._coral_hub === true && venue._wbAvailabilityKnown !== true);
    }

    function wbWizardVenueIsWaitlist(venue) {
      if (wbWizardCoralAvailabilityUnknown(venue)) return false;
      return !!(venue && (venue._wbWaitlistVenue === true || !wbVenueHasBookableEvents(venue)));
    }

    function wbWizardFormatLongDate(dateKey) {
      var raw = String(dateKey || '').trim();
      var parts = raw.split('-').map(Number);
      if (parts.length < 3 || !parts[0] || !parts[1] || !parts[2]) return '';
      var months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ];
      var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      try {
        var utcDate = new Date(Date.UTC(parts[0], parts[1] - 1, parts[2]));
        return days[utcDate.getUTCDay()] + ', ' + months[parts[1] - 1] + ' ' + parts[2];
      } catch (_) {
        return raw;
      }
    }

    function wbWizardVenueEventMeta(venue) {
      var empty = { date: '', more: false, waitlist: false };
      if (!venue) return empty;
      if (wbWizardCoralAvailabilityUnknown(venue)) return empty;
      if (wbWizardVenueIsWaitlist(venue)) {
        return { date: 'Join the waitlist', more: false, waitlist: true };
      }
      var now = new Date();
      var today =
        now.getFullYear() +
        '-' +
        wbPad2(now.getMonth() + 1) +
        '-' +
        wbPad2(now.getDate());
      var events = Array.isArray(venue.events) ? venue.events : [];
      var upcoming = [];
      for (var i = 0; i < events.length; i++) {
        var ev = events[i];
        if (!ev || wbShouldHideEvent(ev) || wbIsEventSoldOut(ev)) continue;
        var dk = String(ev.date_key || dayFromStartsAt(ev) || '').trim();
        if (!dk || dk < today) continue;
        if (upcoming.indexOf(dk) === -1) upcoming.push(dk);
      }
      upcoming.sort();
      var nearest = upcoming[0] || String(venue.next_date_key || '').trim();
      var moreCount = upcoming.length;
      if (!moreCount && Number(venue.events_count) > 1) moreCount = Number(venue.events_count);
      return {
        date: nearest ? wbWizardFormatLongDate(nearest) || nearest : 'Sessions available',
        more: moreCount > 1,
        waitlist: false
      };
    }

    function wbWizardRefreshCoralSuggestions(q) {
      if (!locInput || String(locInput.value || '').trim() !== q) return;
      booking.__wbWizardVenueSuggestions = wbWizardCurrentVenueMatches(q);
      wbWizardPaintSearchDropdown();
    }

    /** Full collection index for the dropdown, then presence only on the matched rows. */
    function wbWizardWarmCoralSearch(q) {
      var hub = window.WorkshopBookingCoralHub;
      if (!booking.__wbCoralHub || !hub || typeof hub.warmSearchCatalog !== 'function') return;
      hub.warmSearchCatalog(booking).then(function () {
        wbWizardRefreshCoralSuggestions(q);
        var matches = booking.__wbWizardVenueSuggestions || [];
        var unknown = [];
        for (var i = 0; i < matches.length; i++) {
          var venue = matches[i] && matches[i].venue;
          if (venue && venue._coral_hub === true && venue._wbAvailabilityKnown !== true) unknown.push(venue);
        }
        if (!unknown.length || typeof hub.stampSearchPresence !== 'function') return;
        hub.stampSearchPresence(unknown).then(function () {
          wbWizardRefreshCoralSuggestions(q);
        });
      });
    }

    function wbWizardLiveFilterFromInput() {
      if (!locInput) return;
      var q = (locInput.value || '').trim();
      if (!q) {
        if (booking.__wbWizardPredictTimer) {
          clearTimeout(booking.__wbWizardPredictTimer);
          booking.__wbWizardPredictTimer = null;
        }
        booking.__wbWizardPredictFor = '';
        wbWizardHideGoogleSuggestions();
        if (wbWizardInventorySearchActive() && booking.__wbWizardInventoryFilterActive) {
          wbWizardApplyInventoryFilter('');
        }
        return;
      }
      booking.__wbWizardVenueSuggestions = wbWizardInventorySearchActive()
        ? wbWizardCurrentVenueMatches(q)
        : [];
      if (booking.__wbWizardPredictFor !== q) booking.__wbWizardPredictions = [];
      wbWizardPaintSearchDropdown();
      wbWizardWarmCoralSearch(q);
      if (q.length >= 2) {
        if (booking.__wbWizardPredictTimer) clearTimeout(booking.__wbWizardPredictTimer);
        booking.__wbWizardPredictTimer = setTimeout(function () {
          booking.__wbWizardPredictTimer = null;
          wbWizardRequestGooglePredictions(q);
        }, 140);
      }
    }

    function wbWizardInventorySearchSubmit() {
      if (!locInput) return false;
      var q = locInput ? String(locInput.value || '').trim() : '';
      var firstPlace = booking.__wbWizardPredictions && booking.__wbWizardPredictions[0];
      if (firstPlace && firstPlace.place_id) {
        wbWizardSelectGooglePrediction(firstPlace);
        return true;
      }
      var firstVenue = booking.__wbWizardVenueSuggestions && booking.__wbWizardVenueSuggestions[0];
      if (firstVenue && firstVenue.venue) {
        wbWizardSelectInventoryVenue(firstVenue);
        return true;
      }
      if (q.length >= 3) wbWizardGeocodeAndRecenter(q);
      return true;
    }

    var setupWizardVenueInventorySearch = function () {};
    var setupWizardVenueTitleScroll = function () {};
    var wbWizardHideGoogleSuggestions = function () {};
    var wbWizardPaintSearchDropdown = function () {};
    var wbWizardRequestGooglePredictions = function () {};
    var wbWizardSelectInventoryVenue = function () {};
    var wbWizardSelectGooglePrediction = function () {};
    var wbWizardGeocodeAndRecenter = function () {};
    /* inventory search/maps: workshop-booking-location-search.js */
    /** Wizard step 1: after default prefetch, upgrade list when browser geolocation is allowed. */
    function triggerWizardAutoGeolocation() {
      if (!booking.classList || !booking.classList.contains('wb-wizard')) return;
      if (booking.__wbCoralHub) return;
      if (booking.closest && booking.closest('#wb-sheet-body')) return;
      if (wbUrlHasWizardDeepLink()) return;
      if (typeof window !== 'undefined' && window.__WB_USER_CHOSEN_LOCATION__) return;
      if (typeof window !== 'undefined' && window.__WB_WIZARD_AUTO_GEO_TRIED__) return;
      if (!navigator.geolocation) return;
      window.__WB_WIZARD_AUTO_GEO_TRIED__ = true;
      navigator.geolocation.getCurrentPosition(
        function (pos) {
          /* Do not wipe Step 1 after the shopper already picked a venue / moved on. */
          if (booking.__wbWizardVenueChosen) return;
          var wizRoot =
            (booking.closest && booking.closest('[data-workshop-booking-wizard]')) ||
            (booking.parentElement &&
              booking.parentElement.closest &&
              booking.parentElement.closest('[data-workshop-booking-wizard]'));
          if (wizRoot) {
            var branch = String(wizRoot.getAttribute('data-wbw-branch') || '').trim();
            if (branch && branch !== 'venue') return;
          }
          if (typeof window !== 'undefined') window.__WB_USER_CHOSEN_LOCATION__ = true;
          if (eventsRoot) eventsRoot.innerHTML = '';
          window.__WORKSHOP_VENUE_LIST__ = null;
          setLoading(booking, true);
          wbFetchEventsFromResolvedCoords(pos.coords.latitude, pos.coords.longitude, null, 'geolocation');
        },
        function (err) {
          if (DEV_MODE) console.log('[WB] wizard auto geolocation skipped', err && err.code);
        },
        { enableHighAccuracy: false, timeout: 20000, maximumAge: 300000 }
      );
    }

    /**
     * Normalize/render workshop events API payload (shared by network fetch and sessionStorage replay).
     * @param {object} [opts] Pass { fromSessionCache: true } when serving from readEventsCache (skips re-write).
     */
    function applyEventsByLatLngPayload(data, lat, lng, locationLabelForEmpty, cycleId, radiusKm, requestId, ssCacheKey, opts) {
      opts = opts || {};
      if (window.__WB_DIAG__) console.log('[WB_DIAG] requestId guard', { requestId: requestId, workshopFetchRequestId: workshopFetchRequestId, pass: requestId === workshopFetchRequestId });
      if (requestId !== workshopFetchRequestId) return data;
      setLoading(booking, false);
      var ph = booking.querySelector('[data-workshop-events-placeholder]');
      try {
        var apiGroupsForList = Array.isArray(data.groups) ? data.groups : null;
        if (!apiGroupsForList) {
          throw new Error('discovery payload missing groups');
        }
        if (window.__WB_DIAG__) {
          var sumVenues = 0;
          apiGroupsForList.forEach(function (g) {
            if (g && Array.isArray(g.venues)) sumVenues += g.venues.length;
          });
          console.log('[WB_DIAG] discovery payload', {
            ok: data.ok,
            venue_mode: data.meta && data.meta.venue_mode,
            groups: apiGroupsForList.length,
            sumVenues: sumVenues,
            metaCount: data.meta && data.meta.count
          });
        }
        var tBuild = performance.now();
        var venueList = buildVenueListFromApiGroups(apiGroupsForList, lat, lng);
        mergeShopCatalogVenuesForWaitlist(venueList, booking, lat, lng, radiusKm);
        wbEnrichVenueListImagesFromCatalog(venueList, booking);
        var buildMs = performance.now() - tBuild;
        var groups = (venueList && venueList.groups) ? venueList.groups : [];
        var venueCount = groups.reduce(function (acc, g) { return acc + (g.venues ? g.venues.length : 0); }, 0);
        var eventCount = groups.reduce(function (acc, g) {
          if (!g.venues) return acc;
          return acc + g.venues.reduce(function (a, v) { return a + (v.events ? v.events.length : 0); }, 0);
        }, 0);
        wbPerf(cycleId, requestId, 'build_venue_list_ms', buildMs, { groups: groups.length, venues: venueCount, events: eventCount, mode: 'discovery' });
        var cacheKeySave = cacheKeyWithRadius(lat, lng, radiusKm);
        var fetchSource =
          window.__WORKSHOP_LOCATION__ && window.__WORKSHOP_LOCATION__.source
            ? String(window.__WORKSHOP_LOCATION__.source)
            : '';
        /*
         * Wizard: "Use my location" / non-default fetch with zero bookable venues must restore the
         * default prefetch list. Catalog merge fills waitlist stubs so groups.length > 0 even when
         * the API returned no sessions — empty-groups-only restore never fired.
         */
        var hasBookableVenue = wbVenueListHasBookableVenue(venueList);
        wbTracePush({
          type: 'list_applied',
          request_id: String(requestId),
          detail: {
            groups: groups.length,
            venues: venueCount,
            bookable: hasBookableVenue ? 1 : 0,
          },
        });
        if (!hasBookableVenue) {
          wbTracePush({
            type: 'empty_list',
            request_id: String(requestId),
            detail: { venues: venueCount, groups: groups.length },
          });
        }
        var restoredInitial = false;
        if (
          !hasBookableVenue &&
          fetchSource &&
          fetchSource !== 'default' &&
          fetchSource !== 'inventory_search' &&
          wbWizardRestoreInitialVenueListIfEmpty(ph)
        ) {
          restoredInitial = true;
          wbPerf(cycleId, requestId, 'wizard_initial_list_restored', null, {
            source: fetchSource,
            reason: 'no_bookable_venues',
            groups: groups.length,
            venues: venueCount
          });
        } else if (!hasBookableVenue) {
          wbTraceFlush('empty_list');
        }
        if (restoredInitial) {
          /* kept initial list; no empty placeholder */
        } else if (!groups || groups.length === 0) {
          if (window.__WB_DIAG__) console.log('[WB_DIAG] empty discovery result → showing placeholder', { builtGroups: groups ? groups.length : 0 });
          window.__WORKSHOP_VENUE_LIST__ = venueList;
          wbwDispatchVenueReset();
          eventsRoot.innerHTML = '';
          var locLabel = (locationLabelForEmpty != null && String(locationLabelForEmpty).trim()) ? String(locationLabelForEmpty).trim() : (window.__WORKSHOP_LOCATION__ && window.__WORKSHOP_LOCATION__.label) || (lat + ', ' + lng);
          if (ph) {
            ph.classList.remove('pdp-wb-hidden');
            ph.textContent = 'No sessions found near ' + locLabel + '. Try a different location or increase the radius.';
          }
          if (booking.classList && booking.classList.contains('wb-wizard')) {
            try {
              wbRefreshBookingGuideUi();
            } catch (_) {}
          }
          wbPerf(cycleId, requestId, 'placeholder_empty', null, { radius_km: radiusKm, label: locLabel });
        } else {
          if (cacheKeySave) workshopEventsCache[cacheKeySave] = { venueList: venueList, ts: Date.now() };
          if (window.__WB_DIAG__) console.log('[WB_DIAG] rendering venue list', { groups: groups.length, venues: venueCount, events: eventCount, firstGroup: groups[0] ? { city_key: groups[0].city_key, venues: groups[0].venues ? groups[0].venues.length : 0 } : null });
          var skipWizardRerender = false;
          if (booking.classList && booking.classList.contains('wb-wizard')) {
            var nextRefs = wbVenueListRefFingerprint(venueList);
            var prevRefs = wbVenueListRefFingerprint(window.__WORKSHOP_VENUE_LIST__);
            if (booking.__wbWizardVenueChosen) {
              skipWizardRerender = true;
            } else if (
              eventsRoot &&
              eventsRoot.children.length > 0 &&
              nextRefs &&
              nextRefs === prevRefs
            ) {
              skipWizardRerender = true;
            }
          }
          if (skipWizardRerender) {
            window.__WORKSHOP_VENUE_LIST__ = venueList;
            if (ph) ph.classList.add('pdp-wb-hidden');
            wbPerf(cycleId, requestId, 'wizard_skip_venue_rerender', null, {
              venue_chosen: !!booking.__wbWizardVenueChosen
            });
          } else if (fetchSource === 'inventory_search') {
            wbWizardMergeVenueListIntoInitial(venueList);
            var pendingQ = String(booking.__wbWizardPendingInventoryQuery || '').trim();
            if (pendingQ) {
              wbWizardApplyInventoryFilter(pendingQ);
            } else {
              window.__WORKSHOP_VENUE_LIST__ = venueList;
              var tRenderInv = performance.now();
              var countsInv = renderVenueCentricList(venueList);
              wbPerf(cycleId, requestId, 'render_ms', performance.now() - tRenderInv, countsInv || {});
            }
            if (ph) ph.classList.add('pdp-wb-hidden');
            trySelectEventFromUrl();
          } else {
            window.__WORKSHOP_VENUE_LIST__ = venueList;
            var tRender = performance.now();
            var counts = renderVenueCentricList(venueList);
            var renderMs = performance.now() - tRender;
            wbPerf(cycleId, requestId, 'render_ms', renderMs, counts || {});
            if (ph) ph.classList.add('pdp-wb-hidden');
            trySelectEventFromUrl();
            if (fetchSource === 'default' && !booking.__wbWizardInitialVenueList) {
              wbWizardStoreInitialVenueList(venueList);
            }
          }
        }
        if (!restoredInitial && !opts.fromSessionCache && ssCacheKey) writeEventsCache(ssCacheKey, data);
        if (
          !restoredInitial &&
          booking.classList &&
          booking.classList.contains('wb-wizard') &&
          window.__WORKSHOP_LOCATION__ &&
          window.__WORKSHOP_LOCATION__.source === 'default'
        ) {
          triggerWizardAutoGeolocation();
        }
      } catch (e) {
        if (window.__WB_DIAG__) console.error('[WB_DIAG] venue list process/render error', e);
        if (eventsRoot) eventsRoot.innerHTML = '';
        if (ph) { ph.classList.remove('pdp-wb-hidden'); ph.textContent = "Couldn't load sessions. Try again."; }
      }
      return data;
    }

    /**
     * Lat/lng-only fetch. ALL mutable state (AbortController, requestId) is managed by the CALLER
     * and passed in explicitly. This function never reads radius from the DOM.
     * @param {number} lat
     * @param {number} lng
     * @param {string} locationLabelForEmpty
     * @param {number} cycleId
     * @param {number} radiusKm — already resolved, never re-read.
     * @param {number} requestId — caller-incremented workshopFetchRequestId.
     * @param {AbortSignal} signal — from the caller's AbortController.
     */
    function fetchEventsByLatLngEndpoint(lat, lng, locationLabelForEmpty, cycleId, radiusKm, requestId, signal, mode) {
      if (!eventsRoot || lat == null || lng == null) return Promise.reject(new Error('Missing lat/lng or events root'));
      var nLat = Math.round(Number(lat) * 100000) / 100000;
      var nLng = Math.round(Number(lng) * 100000) / 100000;
      var ssCacheKey = eventsSessionStorageKey(lat, lng, radiusKm);
      var ssHit = shouldBypassEventsCache(mode) ? null : readEventsCache(ssCacheKey);
      if (ssHit && ssHit.payload) {
        wbPerf(cycleId, requestId, 'session_cache_hit', null, { key: ssCacheKey || '' });
        return Promise.resolve(ssHit.payload).then(function (data) {
          var applied = applyEventsByLatLngPayload(data, lat, lng, locationLabelForEmpty, cycleId, radiusKm, requestId, ssCacheKey, { fromSessionCache: true });
          var refreshMode = mode === 'user' ? 'refresh_user' : 'refresh';
          fetchEventsByLatLngEndpoint(lat, lng, locationLabelForEmpty, cycleId, radiusKm, requestId, signal, refreshMode).catch(function (err) {
            if (err && err.name === 'AbortError') return;
            if (DEV_MODE) console.warn('[WB_EVENTS] background refresh failed after session cache hit', err);
            wbPerf(cycleId, requestId, 'session_cache_refresh_failed', null, {});
          });
          return applied;
        }).catch(function (err) {
          if (err && err.name === 'AbortError') return Promise.reject(err);
          throw err;
        });
      }
      var cacheKey = cacheKeyWithRadius(nLat, nLng, radiusKm);
      var endpointPath = joinProxyPath(PROXY_BASE, EVENTS_PATH);
      var expandParams = (mode === 'user' || mode === 'refresh_user') ? '&min_cards=3&auto_expand_max_km=300' : '';
      // Step 1: thin discovery only. Adapter: omitted max_groups/max_venues = unlimited; epv unused in discovery.
      var fetchKey = endpointPath + '|' + nLat + ',' + nLng + '|r' + radiusKm + '|vm=discovery|expand=' + (expandParams ? '1' : '0') + (productGid ? '|p' + productGid : '') + '|ev2';
      if (window.__WB_EVENTS_IN_FLIGHT[fetchKey]) {
        if (window.WB_DEBUG_FETCH) console.log('[WB_FETCH_DEDUPE] key=' + fetchKey + ' deduped');
        return window.__WB_EVENTS_IN_FLIGHT[fetchKey];
      }
      var qs = 'lat=' + encodeURIComponent(nLat) + '&lng=' + encodeURIComponent(nLng) + '&radius_km=' + encodeURIComponent(radiusKm) + expandParams + '&include_empty_venues=true&venue_mode=discovery&request_id=' + encodeURIComponent(requestId) + (productGid ? '&product_gid=' + encodeURIComponent(productGid) : '');
      var url = endpointPath + '?' + qs;
      if (window.WB_DEBUG_FETCH) console.log('[WB_FETCH_DEDUPE] key=' + fetchKey + ' new');
      if (window.WB_DEBUG_FETCH) console.log('[WB_PROXY] base=' + PROXY_BASE + ' path=' + EVENTS_PATH + ' url=' + url);
      if (DEV_MODE) console.log('[WB_EVENTS] url=' + url + ' radius_km=' + radiusKm);
      wbPerf(cycleId, requestId, 'fetch_start', null, { url: url, radius_km: radiusKm, cacheKey: cacheKey || '' });
      wbTracePush({
        type: 'fetch_start',
        request_id: String(requestId),
        detail: { radius_km: radiusKm, mode: String(mode || '') },
      });
      var fetchStartPerf = performance.now();
      var promise = fetchWorkshopEvents(qs, { method: 'GET', credentials: 'same-origin', signal: signal, requestId: requestId })
        .then(function (res) {
          var ttfb = performance.now() - fetchStartPerf;
          wbPerf(cycleId, requestId, 'network_ttfb_ms', ttfb, {});
          if (!res.ok) throw new Error('proxy_http_error');
          return res.text();
        })
        .then(function (text) {
          var downloadMs = performance.now() - fetchStartPerf;
          var t0 = performance.now();
          var data;
          try {
            data = text ? JSON.parse(text) : null;
          } catch (e) {
            showWorkshopFetchError();
            throw new Error('Invalid response');
          }
          var jsonParseMs = performance.now() - t0;
          wbPerf(cycleId, requestId, 'network_download_ms', downloadMs, { bytes: (text && text.length) || 0 });
          wbPerf(cycleId, requestId, 'json_parse_ms', jsonParseMs, {});
          if (!data || data.ok !== true) {
            console.warn('[workshop-events]', data && data.error_code, data && data.message);
            showWorkshopFetchError(data && data.message ? data.message : undefined);
            throw new Error('Invalid response');
          }
          if (data.meta && data.meta.debug && data.meta.debug.rid) {
            wbPerf(cycleId, requestId, 'backend_rid', null, { rid: data.meta.debug.rid });
          }
          logBackendRidIfPresent(requestId, data);
          wbTracePush({
            type: 'fetch_ok',
            request_id: String(requestId),
            backend_rid:
              data.meta && data.meta.debug && data.meta.debug.rid
                ? String(data.meta.debug.rid)
                : undefined,
            detail: { bytes: (text && text.length) || 0 },
          });
          // Prove whether client sent correct radius or backend clamped
          if (DEV_MODE) {
            var respRadius = (data.meta && data.meta.radius_used_km != null) ? data.meta.radius_used_km : ((data.meta && data.meta.debug && data.meta.debug.radius_used_km != null) ? data.meta.debug.radius_used_km : '(not in response)');
            var backendRid = (data.meta && data.meta.debug && data.meta.debug.rid) || '(none)';
            console.log('[WB_RADIUS] request_id=' + requestId + ' backend_rid=' + backendRid + ' radius_requested=' + radiusKm + ' radius_used=' + respRadius);
          }
          return data;
        })
        .then(function (data) {
          return applyEventsByLatLngPayload(data, lat, lng, locationLabelForEmpty, cycleId, radiusKm, requestId, ssCacheKey, null);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return Promise.reject(err);
          wbTracePush({
            type: 'fetch_error',
            request_id: String(requestId),
            detail: { message: err && err.message ? String(err.message) : 'error' },
          });
          wbTraceFlush('fetch_error');
          throw err;
        });
      window.__WB_EVENTS_IN_FLIGHT[fetchKey] = promise;
      promise.then(
        function () { delete window.__WB_EVENTS_IN_FLIGHT[fetchKey]; },
        function () { delete window.__WB_EVENTS_IN_FLIGHT[fetchKey]; }
      );
      return promise;
    }

    /**
     * Single entry point for every location-based fetch. Radius is always from getRadiusKm at call sites.
     * @param {Element} bookingRoot — the booking component root element (explicit, not closure).
     * @param {number} lat
     * @param {number} lng
     * @param {number} radiusKm — from getRadiusKm(bookingRoot) at every call site.
     * @param {Object} addressParts — { label, source }
     */
    function fetchEventsByLatLng(bookingRoot, lat, lng, radiusKm, addressParts) {
      if (bookingRoot && bookingRoot.__wbCoralHub) return;
      if (booking && booking.__wbCoralHub) return;
      if (lat == null || lng == null || !Number.isFinite(Number(lat)) || !Number.isFinite(Number(lng))) return;
      var source = (addressParts && addressParts.source) || 'geolocation';
      var label = (addressParts && addressParts.label) || (lat + ', ' + lng);
      var forceRefresh = (source === 'geolocation' || source === 'radius_change');

      if (!Number.isFinite(radiusKm) || radiusKm <= 0) radiusKm = getRadiusKm(bookingRoot);
      wbTraceContext({
        shop_domain: workshopCacheShop || '',
        product_id: productGid ? String(productGid) : '',
        product_handle:
          (bookingRoot && bookingRoot.getAttribute && bookingRoot.getAttribute('data-product-handle')) ||
          (booking && booking.getAttribute && booking.getAttribute('data-product-handle')) ||
          '',
        workshop_type:
          (bookingRoot && bookingRoot.getAttribute && bookingRoot.getAttribute('data-workshop-type')) ||
          (booking && booking.getAttribute && booking.getAttribute('data-workshop-type')) ||
          '',
      });
      wbTracePush({
        type: 'location_set',
        detail: {
          lat: Math.round(Number(lat) * 1e5) / 1e5,
          lng: Math.round(Number(lng) * 1e5) / 1e5,
          radius_km: radiusKm,
          source: String(source),
        },
      });
      var isInitial = (source === 'default');
      var fetchMode = isInitial ? 'initial' : 'user';
      if (window.__WB_DEBUG__) console.debug('[WB] fetch', { lat: Number(lat), lng: Number(lng), radiusKm: radiusKm, source: source, label: label });
      if (window.WB_DEBUG_FETCH) console.log('[WB_FETCH_MODE] mode=' + fetchMode + ' source=' + source + ' radius_km=' + radiusKm);
      var cycleId = ++workshopPerfCycleId;
      if (DEV_MODE) console.log('[WB_RADIUS] action source=' + source + ' selected_radius=' + radiusKm + ' force=' + forceRefresh);
      wbPerf(cycleId, null, 'ui_action', null, { source: source, label: label, lat: lat, lng: lng, radius_km: radiusKm });

      // Cache key includes the radius that was resolved for this action
      var newCacheKey = cacheKeyWithRadius(lat, lng, radiusKm);
      var prevCacheKey = (typeof window.__WB_LAST_CACHE_KEY__ !== 'undefined') ? String(window.__WB_LAST_CACHE_KEY__) : '';

      // RESET: on new location OR forced refresh, clear UI and show loading
      var isNewLocation = !prevCacheKey || prevCacheKey !== newCacheKey;
      var preserveWbAllListSelection =
        bookingRoot &&
        bookingRoot.closest &&
        bookingRoot.closest('#wb-sheet-body') &&
        document.querySelector('#wb-event-list .wb-all__event-card.is-selected');

      window.__WB_LAST_RENDER_SOURCE__ = 'LOCATION';
      var partsCity = addressParts && addressParts.city != null ? String(addressParts.city).trim() : '';
      var partsState = addressParts && addressParts.state != null ? String(addressParts.state).trim() : '';
      var partsStateCode =
        addressParts && addressParts.state_code != null
          ? String(addressParts.state_code).trim().toUpperCase()
          : '';
      if (!partsCity && label) {
        var fromLabel = parseCityStateFromFormattedAddress(label);
        if (fromLabel) {
          partsCity = partsCity || (fromLabel.city || '');
          partsState = partsState || (fromLabel.state || '');
          partsStateCode = partsStateCode || (fromLabel.state_code || '');
        }
        if (!partsCity) partsCity = wbNormalizeSearchCityToken(label);
        if (partsCity && partsCity === partsCity.toLowerCase() && label) {
          var rawLocality = String(label).split(',')[0].trim();
          if (wbNormalizeSearchCityToken(rawLocality) === partsCity) partsCity = rawLocality;
        }
      }
      /* Set location before venue-reset so wizard can see source === 'places'. */
      window.__WORKSHOP_LOCATION__ = {
        lat: Number(lat),
        lng: Number(lng),
        label: label,
        city: partsCity || '',
        state: partsState || '',
        state_code: partsStateCode || '',
        country: 'US',
        source: source
      };
      wbSetUserLoc(lat, lng);
      window.__WB_LAST_CACHE_KEY__ = newCacheKey;
      if (source === 'default') {
        wbSetLocationUi({ isDefault: true });
      } else {
        if (typeof window !== 'undefined') window.__WB_USER_CHOSEN_LOCATION__ = true;
        wbSetLocationUi({ label: label });
      }

      if (isNewLocation || forceRefresh) {
        if (!preserveWbAllListSelection) {
          clearEventSelection();
        }
        wbwDispatchVenueReset();
        eventsRoot.innerHTML = '';
        window.__WORKSHOP_VENUE_LIST__ = null;
        if (forceRefresh && newCacheKey && workshopEventsCache[newCacheKey]) {
          delete workshopEventsCache[newCacheKey];
        }
        setLoading(booking, true);
        wbPerf(cycleId, null, 'placeholder_loading', null, {});
      }
      setWbState(1);
      if (preserveWbAllListSelection && typeof validateSeatSelection === 'function') {
        validateSeatSelection();
      }

      // Skip fetch only when location+radius are unchanged, not forced, and UI already populated
      if (!isNewLocation && !forceRefresh && window.__WORKSHOP_VENUE_LIST__ && eventsRoot.children.length > 0) {
        if (DEV_MODE) console.log('[WB_RADIUS] skipping fetch — same location+radius, UI populated');
        return;
      }

      var servedFromMemoryCache = false;
      var memoryCached = newCacheKey && workshopEventsCache[newCacheKey] && workshopEventsCache[newCacheKey].venueList ? workshopEventsCache[newCacheKey] : null;
      if (memoryCached && (Date.now() - (memoryCached.ts || 0)) < WORKSHOP_CACHE_TTL_MS) {
        wbPerf(cycleId, null, 'cache_check', null, { hit: true, cacheKey: newCacheKey, stale_while_revalidate: true });
        if (source === 'inventory_search') {
          wbWizardMergeVenueListIntoInitial(memoryCached.venueList);
          var pendingCacheQ = String(booking.__wbWizardPendingInventoryQuery || '').trim();
          setLoading(booking, false);
          if (pendingCacheQ) {
            wbWizardApplyInventoryFilter(pendingCacheQ);
          } else {
            window.__WORKSHOP_VENUE_LIST__ = memoryCached.venueList;
            renderVenueCentricList(window.__WORKSHOP_VENUE_LIST__);
            trySelectEventFromUrl();
          }
        } else {
          var cachedList = memoryCached.venueList;
          var cachePh = booking.querySelector('[data-workshop-events-placeholder]');
          if (
            source !== 'default' &&
            source !== 'inventory_search' &&
            !wbVenueListHasBookableVenue(cachedList) &&
            wbWizardRestoreInitialVenueListIfEmpty(cachePh)
          ) {
            setLoading(booking, false);
            if (DEV_MODE) {
              console.log('[WB] memory cache waitlist-only → restored initial venue list', { source: source });
            }
          } else {
            window.__WORKSHOP_VENUE_LIST__ = cachedList;
            setLoading(booking, false);
            renderVenueCentricList(window.__WORKSHOP_VENUE_LIST__);
            trySelectEventFromUrl();
          }
        }
        if (source === 'default') {
          if (!booking.__wbWizardInitialVenueList) {
            wbWizardStoreInitialVenueList(window.__WORKSHOP_VENUE_LIST__);
          }
          triggerWizardAutoGeolocation();
        }
        servedFromMemoryCache = true;
      } else if (memoryCached) {
        delete workshopEventsCache[newCacheKey];
      }
      if (!servedFromMemoryCache) wbPerf(cycleId, null, 'cache_check', null, { hit: false, cacheKey: newCacheKey || '' });

      // ── Manage AbortController + requestId HERE, pass them to the endpoint function. ──
      if (latLngAbortController) {
        if (DEV_MODE) console.log('[WB_RADIUS] request_id=' + workshopFetchRequestId + ' aborted=true');
        wbPerf(cycleId, workshopFetchRequestId, 'fetch_aborted', null, {});
        latLngAbortController.abort();
      }
      latLngAbortController = new AbortController();
      var requestId = ++workshopFetchRequestId;
      var signal = latLngAbortController.signal;

      // Definitive pre-fetch log with all correlation fields
      if (DEV_MODE) {
        var preUrl = joinProxyPath(PROXY_BASE, EVENTS_PATH) + '?lat=' + Number(lat) + '&lng=' + Number(lng) + '&radius_km=' + radiusKm + '&include_empty_venues=true&request_id=' + requestId;
        console.log('[WB_RADIUS] request_id=' + requestId + ' source=' + source + ' selected_radius=' + radiusKm + ' url=' + preUrl);
      }

      if (!servedFromMemoryCache) {
        setLoading(booking, true);
        wbPerf(cycleId, null, 'placeholder_loading', null, {});
      }
      var endpointMode = servedFromMemoryCache ? (fetchMode === 'user' ? 'refresh_user' : 'refresh') : fetchMode;
      fetchEventsByLatLngEndpoint(lat, lng, label, cycleId, radiusKm, requestId, signal, endpointMode).catch(function (err) {
        if (requestId !== workshopFetchRequestId) return;
        setLoading(booking, false);
        if (err && err.name === 'AbortError') {
          if (DEV_MODE) console.log('[WB_RADIUS] request_id=' + requestId + ' aborted=true (superseded)');
          return;
        }
        if (servedFromMemoryCache) {
          if (DEV_MODE) console.warn('[WB_EVENTS] background refresh failed after memory cache hit', err);
          wbPerf(cycleId, requestId, 'memory_cache_refresh_failed', null, {});
          return;
        }
        wbwDispatchVenueReset();
        var root = booking.querySelector('[data-workshop-events]');
        if (root) root.innerHTML = '';
        var phErr = booking.querySelector('[data-workshop-events-placeholder]');
        if (phErr) { phErr.classList.remove('pdp-wb-hidden'); phErr.textContent = "Couldn't load sessions. Try again."; }
        if (booking.classList && booking.classList.contains('wb-wizard')) {
          try {
            wbRefreshBookingGuideUi();
          } catch (_) {}
        }
      });
    }

    var venueMonthResponseCache = Object.create(null);
    /** Persist events/_wbLoadedMonths by venue_ref across list re-renders. */
    var venueCalMemoryByRef = Object.create(null);
    var venueCalInFlight = Object.create(null);
    var venueCalAbortController = null;
    var venueCalGeneration = 0;
    var venueCalFetchSeq = 0;
    var VENUE_MONTH_CACHE_TTL_MS = 30 * 60 * 1000;
    /** Dense centers: date-window fetch must not hit default epv strip. */
    /* Date window bounds calendar rows; do not send max_events_per_venue (adapter skips default epv when window set). */

    function wbVenueMonthFetchKey(venueRefId, dateFrom, dateTo) {
      return joinProxyPath(PROXY_BASE, EVENTS_PATH) +
        '|vr=' + wbNormalizeVenueRefKey(venueRefId) +
        '|df=' + String(dateFrom || '') +
        '|dt=' + String(dateTo || '') +
        (productGid ? '|p' + productGid : '');
    }

    function wbMarkMonthsFromEventList(venue, events) {
      if (!venue) return;
      if (!venue._wbLoadedMonths) venue._wbLoadedMonths = Object.create(null);
      var list = Array.isArray(events) ? events : Array.isArray(venue.events) ? venue.events : [];
      for (var i = 0; i < list.length; i++) {
        var dk = list[i] && list[i].date_key != null ? String(list[i].date_key).trim() : '';
        if (dk.length >= 7) venue._wbLoadedMonths[dk.slice(0, 7)] = true;
      }
    }

    function wbPersistVenueCalMemory(venue) {
      if (!venue) return;
      var key = wbNormalizeVenueRefKey(venue.venue_ref_id);
      if (!key) return;
      venueCalMemoryByRef[key] = {
        events: Array.isArray(venue.events) ? venue.events.slice() : [],
        _wbLoadedMonths: Object.assign(Object.create(null), venue._wbLoadedMonths || {})
      };
    }

    function wbRestoreVenueCalMemory(venue) {
      if (!venue) return;
      var key = wbNormalizeVenueRefKey(venue.venue_ref_id);
      if (!key) return;
      var mem = venueCalMemoryByRef[key];
      if (mem) {
        if (!venue._wbLoadedMonths) venue._wbLoadedMonths = Object.create(null);
        Object.keys(mem._wbLoadedMonths || {}).forEach(function (ym) {
          venue._wbLoadedMonths[ym] = true;
        });
        if (!Array.isArray(venue.events) || !venue.events.length) {
          if (mem.events && mem.events.length) venue.events = mem.events.slice();
        } else if (mem.events && mem.events.length) {
          var seen = Object.create(null);
          venue.events.forEach(function (ev) {
            var id =
              String((ev && (ev.id || ev.event_metaobject_gid || '')) || '') +
              '|' +
              String((ev && ev.date_key) || '') +
              '|' +
              String((ev && ev.time_label) || '');
            seen[id] = true;
          });
          mem.events.forEach(function (ev) {
            if (!ev) return;
            var id =
              String((ev.id || ev.event_metaobject_gid || '') || '') +
              '|' +
              String(ev.date_key || '') +
              '|' +
              String(ev.time_label || '');
            if (seen[id]) return;
            seen[id] = true;
            venue.events.push(ev);
          });
        }
      }
      wbMarkMonthsFromEventList(venue);
    }

    function wbVenueMonthsCovered(venue, year, month1to12, lookahead) {
      if (!venue) return false;
      if (!venue._wbLoadedMonths) venue._wbLoadedMonths = Object.create(null);
      var look = Number(lookahead);
      if (!Number.isFinite(look) || look < 0) look = 0;
      var check = { year: Number(year), month: Number(month1to12) };
      for (var i = 0; i <= look; i++) {
        if (!venue._wbLoadedMonths[wbYmKey(check.year, check.month)]) return false;
        check = wbShiftYm(check.year, check.month, 1);
      }
      return true;
    }

    function wbExtractVenueEventsFromPayload(data, venueRefId) {
      var out = [];
      var want = wbNormalizeVenueRefKey(venueRefId);
      if (!want) throw new Error('venue_ref_id required');
      if (!Array.isArray(data && data.groups)) {
        throw new Error('calendar payload missing groups');
      }
      function pushEv(ev, venueMeta) {
        if (!ev || typeof ev !== 'object') return;
        var merged = {};
        for (var k in ev) {
          if (Object.prototype.hasOwnProperty.call(ev, k)) merged[k] = ev[k];
        }
        if (venueMeta) {
          if (venueMeta.venue_name && !merged.venue_name) merged.venue_name = venueMeta.venue_name;
          if (venueMeta.venue_ref_id && !merged.venue_ref_id) merged.venue_ref_id = venueMeta.venue_ref_id;
          if (venueMeta.venue_address && !merged.venue_address) {
            merged.venue_address = venueMeta.venue_address;
          }
          if (wbParseCoord(merged.venue_lat) == null) {
            var vl = wbFirstCoord(venueMeta.lat, venueMeta.latitude, venueMeta.venue_lat);
            if (vl != null) merged.venue_lat = vl;
          }
          if (wbParseCoord(merged.venue_lng) == null) {
            var vn = wbFirstCoord(venueMeta.lng, venueMeta.longitude, venueMeta.venue_lng);
            if (vn != null) merged.venue_lng = vn;
          }
        }
        var nev = normalizeApiEvent(merged);
        if (nev) out.push(nev);
      }
      data.groups.forEach(function (g) {
        if (!g || !Array.isArray(g.venues)) return;
        g.venues.forEach(function (v) {
          if (!v) return;
          var vref = v.venue_ref_id != null ? String(v.venue_ref_id).trim() : '';
          if (!vref || wbNormalizeVenueRefKey(vref) !== want) return;
          var evs = Array.isArray(v.events) ? v.events : [];
          for (var i = 0; i < evs.length; i++) pushEv(evs[i], v);
        });
      });
      /* Empty month window is valid: groups may omit the venue or return events:[]. */
      return out;
    }

    function wbMergeVenueEventsInDateWindow(venue, newEvents, dateFrom, dateTo) {
      if (!venue) return;
      var existing = Array.isArray(venue.events) ? venue.events : [];
      var outside = [];
      var inWindow = [];
      existing.forEach(function (ev) {
        var dk = ev && ev.date_key != null ? String(ev.date_key).trim() : '';
        if (!dk) return;
        var inRange = true;
        if (dateFrom && dk < dateFrom) inRange = false;
        if (dateTo && dk > dateTo) inRange = false;
        if (inRange) inWindow.push(ev);
        else outside.push(ev);
      });
      var fetched = Array.isArray(newEvents) ? newEvents : [];
      var preservedDiscovery = !fetched.length && inWindow.length > 0;
      var incoming = preservedDiscovery ? inWindow : fetched;
      var seen = Object.create(null);
      var kept = outside.slice();
      kept.forEach(function (ev) {
        var id = String((ev && (ev.id || ev.event_metaobject_gid || '')) || '') + '|' + String((ev && ev.date_key) || '') + '|' + String((ev && ev.time_label) || '');
        seen[id] = true;
      });
      incoming.forEach(function (ev) {
        var dk = ev && ev.date_key != null ? String(ev.date_key).trim() : '';
        if (!dk) return;
        var id = String((ev && (ev.id || ev.event_metaobject_gid || '')) || '') + '|' + dk + '|' + String((ev && ev.time_label) || '');
        if (seen[id]) return;
        seen[id] = true;
        kept.push(ev);
      });
      kept.sort(function (a, b) {
        var da = String((a && a.date_key) || '');
        var db = String((b && b.date_key) || '');
        if (da !== db) return da < db ? -1 : 1;
        return String((a && a.time_label) || '').localeCompare(String((b && b.time_label) || ''));
      });
      venue.events = kept;
      if (!venue._wbLoadedMonths) venue._wbLoadedMonths = Object.create(null);
      /*
       * Successful calendar response (incl. empty) marks the window loaded so ensure/prefetch
       * do not refetch forever. Empty + discovery-in-window keeps those events for UI only —
       * do not treat that as “not loaded”.
       */
      if (dateFrom && dateTo && String(dateFrom) <= String(dateTo)) {
        var y = Number(dateFrom.slice(0, 4));
        var m = Number(dateFrom.slice(5, 7));
        var endY = Number(dateTo.slice(0, 4));
        var endM = Number(dateTo.slice(5, 7));
        if (Number.isFinite(y) && Number.isFinite(m)) {
          var cur = { year: y, month: m };
          var guard = 0;
          while (guard < 36) {
            venue._wbLoadedMonths[wbYmKey(cur.year, cur.month)] = true;
            if (cur.year === endY && cur.month === endM) break;
            cur = wbShiftYm(cur.year, cur.month, 1);
            guard++;
          }
        }
        if (!preservedDiscovery) wbMarkMonthsFromEventList(venue, fetched);
      }
      wbPersistVenueCalMemory(venue);
    }

    /**
     * Full-row events for one venue + inclusive date window (calendar / lookahead).
     * Dedicated in-flight map (not shared URL interceptor keys) so abort cannot poison a retry.
     * @returns {Promise<Array>} normalized events
     */
    function fetchVenueCalendarWindow(venueRefId, dateFrom, dateTo, signal, requestId) {
      var vref = String(venueRefId || '').trim();
      if (!vref) return Promise.reject(new Error('venue_ref_id required'));
      if (!/^\d{4}-\d{2}-\d{2}$/.test(String(dateFrom || '')) || !/^\d{4}-\d{2}-\d{2}$/.test(String(dateTo || ''))) {
        return Promise.reject(new Error('date_from/date_to required (YYYY-MM-DD)'));
      }
      /** Coral hub + city venue products: events-batch by product_gid (no lat/lng required). */
      var CoralHub = typeof window !== 'undefined' ? window.WorkshopBookingCoralHub : null;
      var selectedVenue = booking.__wbSelectedVenue || null;
      var batchProductGid = '';
      if (selectedVenue) {
        batchProductGid = String(
          selectedVenue.sell_product_gid || selectedVenue.product_gid || ''
        ).trim();
      }
      if (!batchProductGid && productGid) batchProductGid = String(productGid).trim();

      var locProbe = window.__WORKSHOP_LOCATION__;
      var hasLl =
        locProbe &&
        locProbe.lat != null &&
        locProbe.lng != null &&
        Number.isFinite(Number(locProbe.lat)) &&
        Number.isFinite(Number(locProbe.lng));
      var preferBatch =
        !!batchProductGid &&
        (booking.__wbCoralHub ||
          (selectedVenue && selectedVenue._coral_hub) ||
          !hasLl);

      if (
        preferBatch &&
        CoralHub &&
        typeof CoralHub.fetchVenueCalendar === 'function'
      ) {
        var coralVenue = null;
        var coralList = booking.__wbCoralVenues || [];
        for (var ci = 0; ci < coralList.length; ci++) {
          if (coralList[ci] && String(coralList[ci].venue_ref_id || '') === vref) {
            coralVenue = coralList[ci];
            break;
          }
        }
        if (!coralVenue && selectedVenue) coralVenue = selectedVenue;
        if (!coralVenue) {
          coralVenue = {
            venue_ref_id: vref,
            sell_product_gid: batchProductGid,
            product_gid: batchProductGid,
          };
        } else if (!coralVenue.sell_product_gid && batchProductGid) {
          coralVenue.sell_product_gid = batchProductGid;
          coralVenue.product_gid = coralVenue.product_gid || batchProductGid;
        }
        var fetchKeyCoral = wbVenueMonthFetchKey(vref, dateFrom, dateTo);
        if (venueCalInFlight[fetchKeyCoral]) return venueCalInFlight[fetchKeyCoral];
        var coralPromise = CoralHub.fetchVenueCalendar(
          booking,
          coralVenue,
          dateFrom,
          dateTo,
          signal
        ).then(function (events) {
          venueMonthResponseCache[fetchKeyCoral] = {
            events: events,
            ts: Date.now(),
            meta: { source: 'events-batch' },
          };
          return events;
        });
        venueCalInFlight[fetchKeyCoral] = coralPromise;
        function clearCoralInFlight() {
          if (venueCalInFlight[fetchKeyCoral] === coralPromise) delete venueCalInFlight[fetchKeyCoral];
        }
        coralPromise.then(clearCoralInFlight, clearCoralInFlight);
        return coralPromise;
      }

      /** City PDP without CoralHub script: direct events-batch (fixes missing lat/lng). */
      if (preferBatch && batchProductGid) {
        var fetchKeyBatch = wbVenueMonthFetchKey(vref, dateFrom, dateTo);
        if (venueCalInFlight[fetchKeyBatch]) return venueCalInFlight[fetchKeyBatch];
        var Cfg = typeof window !== 'undefined' ? window.WorkshopBookingConfig : null;
        var apiBase =
          (Cfg && typeof Cfg.resolveAogenApiBase === 'function' && Cfg.resolveAogenApiBase()) ||
          (Cfg && typeof Cfg.getApiBase === 'function' && Cfg.getApiBase()) ||
          (typeof window !== 'undefined' && window.__AOGEN_API_BASE__) ||
          (typeof window !== 'undefined' && window.__WB_FORMS_API_BASE__) ||
          'https://adapter.aogen.com.au';
        var shop =
          (typeof window !== 'undefined' && window.Shopify && window.Shopify.shop) ||
          '';
        var batchBody = {
          shop_domain: shop,
          product_gids: [batchProductGid],
          date_from: dateFrom,
          date_to: dateTo,
        };
        if (vref && vref.indexOf('product:') !== 0 && vref.indexOf('gid://') === 0) {
          batchBody.venue_ref_ids = [vref];
        }
        var batchPromise = fetch(String(apiBase).replace(/\/?$/, '') + '/api/public/workshop-venue/events-batch', {
          method: 'POST',
          credentials: 'omit',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(batchBody),
          signal: signal,
        })
          .then(function (res) {
            return res.json().then(function (json) {
              if (!res.ok || !json || json.ok === false) {
                throw new Error((json && json.description) || 'events_batch_failed');
              }
              var out = [];
              (json.products || []).forEach(function (row) {
                (row.slots || []).forEach(function (slot) {
                  if (!slot) return;
                  out.push({
                    id: slot.event_id,
                    gid: slot.event_id,
                    event_id: slot.event_id,
                    handle: String(slot.handle || '').trim(),
                    date_key: slot.date_key,
                    starts_at: slot.starts_at,
                    time_label: slot.time_label,
                    venue_ref_id: slot.venue_ref_id || vref,
                    status: slot.status || 'active',
                    display_status: slot.display_status || 'bookable',
                    capacity_remaining: slot.capacity_remaining,
                    canonical_event_id: slot.canonical_event_id,
                    capacity_group_id: slot.capacity_group_id,
                    product_gid: row.product_gid,
                    _raw: { handle: String(slot.handle || '').trim(), event_id: slot.event_id },
                  });
                });
              });
              venueMonthResponseCache[fetchKeyBatch] = {
                events: out,
                ts: Date.now(),
                meta: { source: 'events-batch' },
              };
              return out;
            });
          });
        venueCalInFlight[fetchKeyBatch] = batchPromise;
        function clearBatchInFlight() {
          if (venueCalInFlight[fetchKeyBatch] === batchPromise) delete venueCalInFlight[fetchKeyBatch];
        }
        batchPromise.then(clearBatchInFlight, clearBatchInFlight);
        return batchPromise;
      }

      var loc = window.__WORKSHOP_LOCATION__;
      if (!loc || loc.lat == null || loc.lng == null) {
        return Promise.reject(new Error('lat/lng required for venue calendar'));
      }
      var lat = Number(loc.lat);
      var lng = Number(loc.lng);
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
        return Promise.reject(new Error('lat/lng required for venue calendar'));
      }
      var radiusKm = getRadiusKm(booking);
      var nLat = Math.round(lat * 100000) / 100000;
      var nLng = Math.round(lng * 100000) / 100000;
      var fetchKey = wbVenueMonthFetchKey(vref, dateFrom, dateTo);
      var cached = venueMonthResponseCache[fetchKey];
      if (cached && cached.events && (Date.now() - (cached.ts || 0)) < VENUE_MONTH_CACHE_TTL_MS) {
        return Promise.resolve(cached.events);
      }
      if (venueCalInFlight[fetchKey]) {
        return venueCalInFlight[fetchKey];
      }
      var qs =
        'lat=' + encodeURIComponent(nLat) +
        '&lng=' + encodeURIComponent(nLng) +
        '&radius_km=' + encodeURIComponent(radiusKm) +
        '&venue_ref_id=' + encodeURIComponent(vref) +
        '&date_from=' + encodeURIComponent(dateFrom) +
        '&date_to=' + encodeURIComponent(dateTo) +
        '&include_empty_venues=false' +
        '&request_id=' + encodeURIComponent(requestId != null ? requestId : ++venueCalFetchSeq) +
        (productGid ? '&product_gid=' + encodeURIComponent(productGid) : '');
      if (DEV_MODE) console.log('[WB_VENUE_CAL] fetch ' + dateFrom + '..' + dateTo + ' venue=' + vref);
      wbTracePush({
        type: 'calendar_fetch_start',
        request_id: String(requestId != null ? requestId : ''),
        detail: { venue_ref_id: vref, date_from: dateFrom, date_to: dateTo },
      });
      var promise = fetchWorkshopEvents(qs, { method: 'GET', credentials: 'same-origin', signal: signal, requestId: requestId })
        .then(function (res) {
          if (!res.ok) {
            var err = new Error(res.status === 400 ? 'bad_request' : 'proxy_http_error');
            err.status = res.status;
            throw err;
          }
          return res.text();
        })
        .then(function (text) {
          var data;
          try {
            data = text ? JSON.parse(text) : null;
          } catch (e) {
            throw new Error('Invalid response');
          }
          if (!data || data.ok !== true) {
            var msg = (data && data.message) ? String(data.message) : 'Invalid response';
            var code = (data && data.error_code) ? String(data.error_code) : '';
            var err2 = new Error(code === 'bad_request' || msg.indexOf('bad_request') !== -1 ? 'bad_request' : msg);
            err2.error_code = code;
            throw err2;
          }
          var events = wbExtractVenueEventsFromPayload(data, vref);
          venueMonthResponseCache[fetchKey] = { events: events, ts: Date.now(), meta: data.meta || null };
          wbTracePush({
            type: 'calendar_fetch_ok',
            request_id: String(requestId != null ? requestId : ''),
            backend_rid:
              data.meta && data.meta.debug && data.meta.debug.rid
                ? String(data.meta.debug.rid)
                : undefined,
            detail: { venue_ref_id: vref, count: events.length },
          });
          return events;
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') throw err;
          wbTracePush({
            type: 'calendar_fetch_error',
            request_id: String(requestId != null ? requestId : ''),
            detail: {
              venue_ref_id: vref,
              message: err && err.message ? String(err.message) : 'error',
            },
          });
          wbTraceFlush('calendar_fetch_error');
          throw err;
        });
      venueCalInFlight[fetchKey] = promise;
      function clearInFlight() {
        if (venueCalInFlight[fetchKey] === promise) delete venueCalInFlight[fetchKey];
      }
      if (signal) {
        if (signal.aborted) clearInFlight();
        else signal.addEventListener('abort', clearInFlight, { once: true });
      }
      promise.then(clearInFlight, clearInFlight);
      return promise;
    }

    /**
     * Ensure venue.events covers view month (+ optional lookahead). Prefetch next month in background.
     * @param {object} venue
     * @param {number} year
     * @param {number} month1to12
     * @param {{ lookahead?: number, prefetch?: boolean, signal?: AbortSignal }} opts
     */
    function ensureVenueCalendarMonths(venue, year, month1to12, opts) {
      opts = opts || {};
      if (!venue || typeof venue !== 'object') return Promise.reject(new Error('venue required'));
      var vref = String(venue.venue_ref_id || '').trim();
      if (!vref) return Promise.reject(new Error('venue_ref_id missing'));
      wbRestoreVenueCalMemory(venue);
      var lookahead = opts.lookahead != null ? Number(opts.lookahead) : 1;
      if (!Number.isFinite(lookahead) || lookahead < 0) lookahead = 1;
      var y = Number(year);
      var m = Number(month1to12);
      if (!Number.isFinite(y) || !Number.isFinite(m) || m < 1 || m > 12) {
        return Promise.reject(new Error('invalid month'));
      }
      if (!venue._wbLoadedMonths) venue._wbLoadedMonths = Object.create(null);
      var needFetch = !wbVenueMonthsCovered(venue, y, m, lookahead);
      var bounds = wbWindowDateBounds(y, m, lookahead);
      var runFetch = needFetch
        ? fetchVenueCalendarWindow(vref, bounds.from, bounds.to, opts.signal, ++venueCalFetchSeq).then(function (events) {
            wbMergeVenueEventsInDateWindow(venue, events, bounds.from, bounds.to);
            return venue;
          })
        : Promise.resolve(venue);

      return runFetch.then(function (v) {
        wbPersistVenueCalMemory(venue);
        if (opts.prefetch === false) return v;
        var next = wbShiftYm(y, m, lookahead + 1);
        if (venue._wbLoadedMonths[wbYmKey(next.year, next.month)]) return v;
        var nextBounds = wbMonthDateBounds(next.year, next.month);
        fetchVenueCalendarWindow(vref, nextBounds.from, nextBounds.to, opts.signal, ++venueCalFetchSeq)
          .then(function (events) {
            wbMergeVenueEventsInDateWindow(venue, events, nextBounds.from, nextBounds.to);
          })
          .catch(function (err) {
            if (err && err.name === 'AbortError') return;
            if (DEV_MODE) console.warn('[WB_VENUE_CAL] prefetch failed', err);
          });
        return v;
      });
    }

    function ensureVenueCalendarForView(venue, viewDate, opts) {
      opts = opts || {};
      var d = viewDate instanceof Date ? viewDate : new Date();
      var y = d.getFullYear();
      var m = d.getMonth() + 1;
      var lookahead = opts.lookahead != null ? Number(opts.lookahead) : 1;
      if (!Number.isFinite(lookahead) || lookahead < 0) lookahead = 1;
      wbRestoreVenueCalMemory(venue);
      var covered = wbVenueMonthsCovered(venue, y, m, lookahead);
      /* Cache hit: do not abort in-flight work / do not bump generation. */
      if (covered && opts.abortPrevious !== true) {
        return ensureVenueCalendarMonths(venue, y, m, {
          lookahead: lookahead,
          prefetch: opts.prefetch !== false,
          signal: opts.signal
        });
      }
      if (opts.abortPrevious !== false) {
        if (venueCalAbortController) {
          try { venueCalAbortController.abort(); } catch (_) {}
        }
        venueCalGeneration += 1;
        venueCalAbortController = new AbortController();
      }
      var gen = venueCalGeneration;
      var signal = opts.signal || (venueCalAbortController && venueCalAbortController.signal);
      return ensureVenueCalendarMonths(venue, y, m, {
        lookahead: lookahead,
        prefetch: opts.prefetch !== false,
        signal: signal
      }).then(function (v) {
        if (gen !== venueCalGeneration) {
          var aborted = new Error('Aborted');
          aborted.name = 'AbortError';
          throw aborted;
        }
        return v;
      });
    }

    /**
     * Coral hub popup venues: load all near-term sessions in one request.
     * Month lookahead (store calendar) leaves later months (e.g. Dec) off hub pills.
     */
    function ensurePopupVenueCalendarAll(venue, opts) {
      opts = opts || {};
      if (!venue || typeof venue !== 'object') return Promise.reject(new Error('venue required'));
      var vref = String(venue.venue_ref_id || '').trim();
      if (!vref) return Promise.reject(new Error('venue_ref_id missing'));
      wbRestoreVenueCalMemory(venue);
      if (venue._wbPopupAllLoaded === true && Array.isArray(venue.events)) {
        return Promise.resolve(venue);
      }
      if (opts.abortPrevious !== false) {
        if (venueCalAbortController) {
          try {
            venueCalAbortController.abort();
          } catch (_) {}
        }
        venueCalGeneration += 1;
        venueCalAbortController = new AbortController();
      }
      var gen = venueCalGeneration;
      var signal = opts.signal || (venueCalAbortController && venueCalAbortController.signal);
      var pad = function (n) {
        return (n < 10 ? '0' : '') + n;
      };
      var today = new Date();
      var from =
        today.getFullYear() +
        '-' +
        pad(today.getMonth() + 1) +
        '-' +
        pad(today.getDate());
      var end = new Date(today.getTime() + 180 * 24 * 60 * 60 * 1000);
      var to = end.getFullYear() + '-' + pad(end.getMonth() + 1) + '-' + pad(end.getDate());
      return fetchVenueCalendarWindow(vref, from, to, signal, ++venueCalFetchSeq).then(function (events) {
        if (gen !== venueCalGeneration) {
          var aborted = new Error('Aborted');
          aborted.name = 'AbortError';
          throw aborted;
        }
        wbMergeVenueEventsInDateWindow(venue, events, from, to);
        venue._wbPopupAllLoaded = true;
        wbPersistVenueCalMemory(venue);
        return venue;
      });
    }

    booking.__wbFetchByLatLng = function (lat, lng, addressParts) {
      fetchEventsByLatLng(booking, lat, lng, getRadiusKm(booking), addressParts);
    };
    booking.__wbEnsureVenueCalendar = ensureVenueCalendarForView;
    booking.__wbEnsureVenueCalendarMonths = ensureVenueCalendarMonths;
    booking.__wbEnsurePopupVenueCalendarAll = ensurePopupVenueCalendarAll;
    booking.__wbTriggerDefaultPrefetch = triggerDefaultPrefetch;
    if (global.WorkshopBookingLocationSearch && typeof global.WorkshopBookingLocationSearch.attach === 'function') {
      S.locInput = locInput;
      S.ensureGooglePlacesLoaded = ensureGooglePlacesLoaded;
      S.fetchEventsByLatLng = fetchEventsByLatLng;
      S.wbSetLocationUi = wbSetLocationUi;
      S.wbSetUserLoc = wbSetUserLoc;
      S.wbWizardApplyInventoryFilter = wbWizardApplyInventoryFilter;
      S.wbWizardFormatVenueSearchLabel = wbWizardFormatVenueSearchLabel;
      S.wbWizardHasRenderableVenueList = wbWizardHasRenderableVenueList;
      S.wbWizardInventorySearchActive = wbWizardInventorySearchActive;
      S.wbWizardInventorySearchSubmit = wbWizardInventorySearchSubmit;
      S.wbWizardLiveFilterFromInput = wbWizardLiveFilterFromInput;
      S.wbWizardMatchScore = wbWizardMatchScore;
      S.wbWizardStoreInitialVenueList = wbWizardStoreInitialVenueList;
      S.wbWizardVenueCoords = wbWizardVenueCoords;
      S.wbWizardVenueEventMeta = wbWizardVenueEventMeta;
      S.wbWizardVenueIsWaitlist = wbWizardVenueIsWaitlist;
      S.wbWizardVenueSearchCityLabel = wbWizardVenueSearchCityLabel;
      S.wbWizardFlattenInventoryVenues = wbWizardFlattenInventoryVenues;
      S.wbWizardFilterInventoryByQuery = wbWizardFilterInventoryByQuery;
      S.wbWizardGetInventoryVenueList = wbWizardGetInventoryVenueList;
      S.wbResolveVenueCardImage = wbResolveVenueCardImage;
      global.WorkshopBookingLocationSearch.attach(S);
      setupWizardVenueInventorySearch = S.setupWizardVenueInventorySearch;
      setupWizardVenueTitleScroll = S.setupWizardVenueTitleScroll;
      wbWizardHideGoogleSuggestions = S.wbWizardHideGoogleSuggestions;
      wbWizardPaintSearchDropdown = S.wbWizardPaintSearchDropdown;
      wbWizardRequestGooglePredictions = S.wbWizardRequestGooglePredictions;
      wbWizardSelectInventoryVenue = S.wbWizardSelectInventoryVenue;
      wbWizardSelectGooglePrediction = S.wbWizardSelectGooglePrediction;
      wbWizardGeocodeAndRecenter = S.wbWizardGeocodeAndRecenter;
    }
    if (locInput) setupWizardVenueInventorySearch();
    if (booking.classList && booking.classList.contains('wb-wizard')) {
      booking.__wbTriggerDefaultPrefetch = function () {
        wbWizardInventorySearchSubmit();
      };
      setupWizardVenueTitleScroll();
    }
    if (typeof window !== 'undefined') {
      window.__WB_fetchEventsByLatLng = booking.__wbFetchByLatLng;
      window.__WB_ensureVenueCalendar = ensureVenueCalendarForView;
      window.__WB_ACTIVE_BOOKING_ROOT__ = booking;
    }

    function wbReadWaitlistVenueCatalog(bookingRoot) {
      if (!bookingRoot) return [];
      var el = bookingRoot.querySelector('script[type="application/json"][data-wb-venues-waitlist-catalog]');
      if (!el || !el.textContent) return [];
      try {
        var parsed = JSON.parse(el.textContent);
        return Array.isArray(parsed) ? parsed : [];
      } catch (_) {
        return [];
      }
    }

    function wbVenueTokenMatchesCatalogRow(token, row, opts) {
      opts = opts || {};
      if (!token || !row) return false;
      var t = String(token).trim().toLowerCase();
      var ref = wbNormalizeVenueRefKey(row.venue_ref_id || '');
      var refNum = ref.match(/(\d+)$/);
      var matched = false;
      if (refNum && refNum[1] === t) matched = true;
      if (!matched) {
        var handle = String(row.venue_handle || '').trim().toLowerCase();
        var name = String(row.venue_name || '').trim().toLowerCase();
        if (handle && handle === t) matched = true;
        if (name && name === t) matched = true;
        if (name && (name.indexOf(t) >= 0 || t.indexOf(name) >= 0)) matched = true;
      }
      if (!matched) return false;
      if (/^\d+$/.test(t)) return true;
      var stateCode = opts.stateCode || '';
      if (!stateCode) return true;
      var code = '';
      try {
        if (
          window.WorkshopBookingWizardHelpers &&
          typeof window.WorkshopBookingWizardHelpers.catalogRowRegionCode === 'function'
        ) {
          code = String(
            window.WorkshopBookingWizardHelpers.catalogRowRegionCode(row) || ''
          )
            .trim()
            .toUpperCase();
        }
      } catch (_) {}
      if (!code) code = wbResolveCatalogRegionCode(row);
      if (!code) return !opts.requireState;
      return code === String(stateCode).trim().toUpperCase();
    }

    function wbResolveDeepLinkVenueCoords(bookingRoot) {
      var token = '';
      var stateCode = '';
      try {
        var params = new URLSearchParams(window.location.search);
        token = (params.get('venue') || '').trim();
        stateCode = (params.get('state') || params.get('state_code') || '').trim().toUpperCase();
        if (stateCode && !/^[A-Z]{2}$/.test(stateCode)) stateCode = '';
      } catch (_) {}
      if (!token) return null;
      var catalog = wbReadWaitlistVenueCatalog(bookingRoot);
      function pick(requireState) {
        for (var i = 0; i < catalog.length; i++) {
          var row = catalog[i];
          if (
            !row ||
            !wbVenueTokenMatchesCatalogRow(token, row, {
              stateCode: stateCode,
              requireState: requireState,
            })
          ) {
            continue;
          }
          var lat = row.lat != null ? Number(row.lat) : NaN;
          var lng = row.lng != null ? Number(row.lng) : NaN;
          if (!Number.isFinite(lat) || !Number.isFinite(lng)) continue;
          return {
            lat: lat,
            lng: lng,
            label: String(row.venue_name || 'Venue').trim() || 'Venue',
          };
        }
        return null;
      }
      if (stateCode && !/^\d+$/.test(token)) {
        var strict = pick(true);
        if (strict) return strict;
      }
      return pick(false);
    }

    /** Coral hub: apply city-product venue list into the same Step-1 renderer. */
    booking.__wbApplyVenueList = function (venueList) {
      try {
        if (wbWizardHasRenderableVenueList(venueList)) {
          booking.__wbWizardInitialVenueList = JSON.parse(JSON.stringify(venueList));
        }
      } catch (e) {
        booking.__wbWizardInitialVenueList = venueList;
      }
      var nextFp = '';
      try {
        var g0 = venueList && venueList.groups && venueList.groups[0];
        var vs = (g0 && g0.venues) || [];
        nextFp = vs
          .map(function (v) {
            return (
              String((v && (v.sell_product_gid || v.product_gid || v.venue_ref_id)) || '') +
              (v && v._wbAvailabilityKnown === true ? ':1' : ':0') +
              (v && v.has_events === true ? 'e' : '') +
              ':' +
              String((v && v.next_date_key) || '')
            );
          })
          .join('|');
      } catch (e2) {
        nextFp = '';
      }
      if (booking.__wbCoralHub && nextFp && booking.__wbCoralPaintedFp === nextFp) {
        if (typeof setLoading === 'function') setLoading(booking, false);
        return;
      }
      renderVenueCentricList(venueList);
      if (nextFp) booking.__wbCoralPaintedFp = nextFp;
      if (typeof setLoading === 'function') setLoading(booking, false);
      var ph = booking.querySelector('[data-workshop-events-placeholder]');
      if (ph) {
        var n = (venueList && venueList.groups && venueList.groups[0] && venueList.groups[0].venues
          ? venueList.groups[0].venues.length
          : 0);
        if (n > 0) ph.classList.add('pdp-wb-hidden');
        else {
          ph.classList.remove('pdp-wb-hidden');
          ph.textContent = 'No venues found';
        }
      }
    };

    // ── Default prefetch: if no location selected yet and no lat/lng in URL, fetch default location ──
    function triggerDefaultPrefetch(opts) {
      var force = !!(opts && opts.force);
      /** Coral hubs: Shopify type-collection city products (not hub product_gid discovery). */
      var CoralHub = typeof window !== 'undefined' ? window.WorkshopBookingCoralHub : null;
      if (CoralHub && typeof CoralHub.isCoralHub === 'function' && CoralHub.isCoralHub(booking)) {
        if (booking.__wbCoralBooted) return;
        booking.__wbCoralBooted = true;
        // Keep Liquid skeleton; venue list paints once after background fetch.
        if (typeof setLoading === 'function') setLoading(booking, false);
        CoralHub.boot(booking)
          .then(function () {
            if (typeof setLoading === 'function') setLoading(booking, false);
          })
          .catch(function (err) {
            console.warn('[WB_CORAL_HUB] boot failed', err);
            booking.__wbCoralBooted = false;
            if (typeof setLoading === 'function') setLoading(booking, false);
            var ph = booking.querySelector('[data-workshop-events-placeholder]');
            if (ph) {
              ph.classList.remove('pdp-wb-hidden');
              ph.textContent = 'Unable to load venues';
            }
          });
        return;
      }
      /** List page + bottom sheet: booking is cloned into #wb-sheet-body; default Auckland fetch runs after hydrate and calls clearEventSelection + setWbState(1), which disables CTAs until qty is touched. Skip prefetch for this instance (list card already drives selection). */
      if (booking && booking.closest && booking.closest('#wb-sheet-body')) return;
      if (!force && typeof window !== 'undefined' && window.__WB_USER_CHOSEN_LOCATION__) return;
      var prevLoc = window.__WORKSHOP_LOCATION__;
      var hasLocation = prevLoc && prevLoc.lat != null && prevLoc.lng != null && Number.isFinite(Number(prevLoc.lat)) && Number.isFinite(Number(prevLoc.lng));
      if (!force && hasLocation) return;
      var params = new URLSearchParams(window.location.search);
      if (!force && params.get('lat') && params.get('lng')) return;
      if (!eventsRoot) return;
      // Guard: avoid duplicate default fetch when init runs from both DOMContentLoaded and section:load
      var now = Date.now();
      if (!force && window.__WB_DEFAULT_PREFETCH_AT != null && (now - window.__WB_DEFAULT_PREFETCH_AT) < 3000) return;
      window.__WB_DEFAULT_PREFETCH_AT = now;
      var deepVenue = wbResolveDeepLinkVenueCoords(booking);
      if (deepVenue) {
        if (typeof window !== 'undefined') window.__WB_USER_CHOSEN_LOCATION__ = true;
        setTimeout(function () {
          fetchEventsByLatLng(booking, deepVenue.lat, deepVenue.lng, getRadiusKm(booking), {
            label: deepVenue.label,
            source: 'venue_deep_link',
          });
        }, 0);
        return;
      }
      if (!Number.isFinite(initialFetchLat) || !Number.isFinite(initialFetchLng)) return;
      // Do not overwrite location input on load; user types address without it being cleared
      setTimeout(function () {
        fetchEventsByLatLng(booking, initialFetchLat, initialFetchLng, initialFetchRadiusKm, { label: 'Configured default', source: 'default' });
      }, 0);
    }
    (function defaultPrefetch() {
      function run() {
        triggerDefaultPrefetch({ force: false });
      }
      var target = booking;
      if (typeof IntersectionObserver !== 'undefined' && target) {
        var done = false;
        var io = new IntersectionObserver(
          function (entries) {
            if (done) return;
            if (!entries[0] || !entries[0].isIntersecting) return;
            done = true;
            io.disconnect();
            if (typeof requestIdleCallback === 'function') {
              requestIdleCallback(function () {
                run();
              }, { timeout: 1800 });
            } else {
              setTimeout(run, 0);
            }
          },
          { root: null, rootMargin: '160px 0px', threshold: 0.01 }
        );
        io.observe(target);
        setTimeout(function () {
          if (done) return;
          done = true;
          io.disconnect();
          run();
        }, 4500);
      } else {
        run();
      }
    })();

    (function startDefaultInputGuard() {
      // Guard disabled: was overwriting location input while user typed. No automatic "restore default" on empty.
    })();

    function wbClearWizardDeepLinkUrlForPlacesSearch() {
      try {
        window.__WB_STRIP_VENUE_PARAM__ = true;
        window.__WB_STRIP_EVENT_ID_PARAM__ = true;
        window.__WB_URL_EVENT_ID_NUMERIC__ = '';
        window.__WB_INITIAL_EVENT_ID__ = null;
        var params = new URLSearchParams(window.location.search);
        var had =
          params.has('venue') ||
          params.has('event_id') ||
          params.has('state') ||
          params.has('state_code') ||
          params.has('wbw_step');
        params.delete('venue');
        params.delete('event_id');
        params.delete('state');
        params.delete('state_code');
        params.delete('wbw_step');
        if (had) {
          var qs = params.toString();
          history.replaceState(
            history.state,
            '',
            window.location.pathname + (qs ? '?' + qs : '') + (window.location.hash || '')
          );
        }
      } catch (_) {}
      try {
        var wiz =
          (booking && booking.closest && booking.closest('[data-workshop-booking-wizard]')) ||
          document.querySelector('[data-workshop-booking-wizard]');
        if (wiz) {
          wiz.__wbwUrlDeepLinkComplete = true;
          wiz.__wbwUserReachedDatetime = false;
        }
      } catch (_) {}
    }

    async function handlePlaceSelect(ev) {
      if (wbWizardInventorySearchActive()) {
        if (window.__WB_DIAG__) console.log('[WB_DIAG] place_select ignored — wizard uses inventory filter');
        return;
      }
      if (window.__WB_DIAG__) console.log('[WB_DIAG] place_select fired', ev && ev.type, ev && ev.detail ? Object.keys(ev.detail) : null);
      var placeEl = document.querySelector('#workshop-location-place-autocomplete,[data-workshop-place-autocomplete]');
      var detail = ev && (ev.detail || ev);
      
      // 1. PRIORITY: Get text from placePrediction first (most reliable source)
      var predictionText = '';
      if (detail && detail.placePrediction) {
        predictionText = (detail.placePrediction.text && detail.placePrediction.text.text) 
          || detail.placePrediction.text 
          || detail.placePrediction.displayName 
          || '';
        if (typeof predictionText === 'object' && predictionText.text) predictionText = predictionText.text;
        predictionText = String(predictionText || '').trim();
        if (window.__WB_DIAG__) console.log('[WB_DIAG] placePrediction.text', predictionText);
      }

      // ── 2. Get Place with coordinates ──
      // RULE: place starts null. NEVER assign a non-Place object (like ev.detail).
      var place = null;

      // 2a. placePrediction.toPlace() + fetchFields (gmp-select event)
      if (detail && detail.placePrediction && typeof detail.placePrediction.toPlace === 'function') {
        if (window.__WB_DIAG__) console.log('[WB_DIAG] placePrediction detected');
        try {
          place = detail.placePrediction.toPlace();
          if (place && typeof place.then === 'function') place = await place;
          if (window.__WB_DIAG__) console.log('[WB_DIAG] toPlace resolved', !!place);
          if (place && typeof place.fetchFields === 'function' && !place.__wbFieldsFetched) {
            await place.fetchFields({ fields: ['location'] });
            place.__wbFieldsFetched = true;
            if (window.__WB_DIAG__) {
              var fLat = null, fLng = null;
              if (place.location) { fLat = typeof place.location.lat === 'function' ? place.location.lat() : place.location.lat; fLng = typeof place.location.lng === 'function' ? place.location.lng() : place.location.lng; }
              console.log('[WB_DIAG] fetchFields resolved: lat=' + fLat + ', lng=' + fLng);
            }
          }
        } catch (e) {
          if (window.__WB_DIAG__) console.warn('[WB_DIAG] placePrediction.toPlace()/fetchFields error', e);
          place = null;
        }
      }

      // 2b. detail.place (gmp-placeselect event) — NEVER use bare detail
      if (!place && detail && detail.place) {
        place = detail.place;
        if (window.__WB_DIAG__) console.log('[WB_DIAG] using detail.place');
      }

      // 2c. placeEl.getPlace() fallback
      if (!place && placeEl && typeof placeEl.getPlace === 'function') {
        try {
          var gp = placeEl.getPlace();
          if (gp && typeof gp.then === 'function') gp = await gp;
          if (gp) { place = gp; if (window.__WB_DIAG__) console.log('[WB_DIAG] using placeEl.getPlace()'); }
        } catch (e) {}
      }

      // 2d. target.getPlace() fallback
      if (!place) {
        var target = ev && ev.target;
        if (target && typeof target.getPlace === 'function') {
          try {
            var tp = target.getPlace();
            if (tp && typeof tp.then === 'function') tp = await tp;
            if (tp) { place = tp; if (window.__WB_DIAG__) console.log('[WB_DIAG] using target.getPlace()'); }
          } catch (e) {}
        }
      }

      // 2e. Ensure place has coordinates — fetchFields for 2b/2c/2d paths
      if (place && typeof place.fetchFields === 'function' && !place.__wbFieldsFetched && !(place.geometry && place.geometry.location) && !place.location) {
        try {
          if (window.__WB_DIAG__) console.log('[WB_DIAG] place missing coords, calling fetchFields');
          await place.fetchFields({ fields: ['location'] });
          place.__wbFieldsFetched = true;
          if (window.__WB_DIAG__) {
            var fLat2 = null, fLng2 = null;
            if (place.location) { fLat2 = typeof place.location.lat === 'function' ? place.location.lat() : place.location.lat; fLng2 = typeof place.location.lng === 'function' ? place.location.lng() : place.location.lng; }
            console.log('[WB_DIAG] fetchFields resolved: lat=' + fLat2 + ', lng=' + fLng2);
          }
        } catch (e) {
          if (window.__WB_DIAG__) console.warn('[WB_DIAG] fetchFields fallback error', e);
        }
      }
      if (place && typeof place.then === 'function') place = await place;
      
      // Get lat/lng early so we can allow new location through even if place_id/text duplicates
      var ll = (place && typeof getLatLngFromPlace === 'function') ? await getLatLngFromPlace(place) : null;
      var prevLoc = window.__WORKSHOP_LOCATION__;
      var hasNewCoords = ll && ll.lat != null && ll.lng != null && (!prevLoc || prevLoc.lat == null || prevLoc.lng == null || Math.abs(prevLoc.lat - ll.lat) > 1e-5 || Math.abs(prevLoc.lng - ll.lng) > 1e-5);
      // Duplicate check: only skip when same place_id AND not a new location (different lat/lng)
      var fp = String((place && (place.placeId || place.place_id || place.id)) || (detail && detail.placePrediction && (detail.placePrediction.placeId || detail.placePrediction.place_id)) || predictionText || '');
      if (fp && fp === (window.__WORKSHOP_PLACE_LAST_ID__ || __WB_lastHandledPlaceFp) && !hasNewCoords) return;
      __WB_lastHandledPlaceFp = fp;
      window.__WORKSHOP_PLACE_LAST_ID__ = fp;

      // 4. Label fallbacks only (parsed / getCityStateFromPlace): improve displayLabel when coords exist, or set label when they do not.
      // fetchEventsByLatLng is only called with ll from getLatLngFromPlace — never with parsed.city / parsed.state_code (those are not API parameters).
      // getCityStateFromPlace runs when comma-parsing predictionText did not yield city+state; it is not on the events-fetch critical path.
      // Priority: predictionText → getCityStateFromPlace(place) → place.formattedAddress
      var label = '';
      var parsed = null;
      var Flow = window.WorkshopLocationFlow;
      
      // Try predictionText first (most reliable)
      if (predictionText && predictionText.indexOf(',') >= 0) {
        parsed = parseCityStateFromFormattedAddress(predictionText);
        label = predictionText;
        if (window.__WB_DIAG__) console.log('[WB_DIAG] parsed from predictionText', parsed);
      }
      
      // If predictionText didn't work, try place object
      if ((!parsed || (!parsed.city && !parsed.state_code)) && place) {
        var placeResult = await getCityStateFromPlace(place);
        if (placeResult && (placeResult.city || placeResult.state_code)) {
          parsed = placeResult;
          label = label || [placeResult.city, placeResult.state || placeResult.state_code].filter(Boolean).join(', ') || placeResult.formattedAddress || '';
          if (window.__WB_DIAG__) console.log('[WB_DIAG] parsed from getCityStateFromPlace', parsed);
        }
      }
      
      // Final fallback: try formattedAddress
      if ((!parsed || (!parsed.city && !parsed.state_code)) && place) {
        var fa = (place.formattedAddress || place.formatted_address || '').toString().trim();
        if (fa && fa.indexOf(',') >= 0) {
          parsed = parseCityStateFromFormattedAddress(fa);
          label = label || fa;
          if (window.__WB_DIAG__) console.log('[WB_DIAG] parsed from formattedAddress', parsed);
        }
      }
      
      // Ensure we have a label
      label = label || predictionText || 'Location selected';

      // Prefer lat/lng for venue-centric fetch (single source for API)
      if (ll && ll.lat != null && ll.lng != null && Number.isFinite(Number(ll.lat)) && Number.isFinite(Number(ll.lng))) {
        var fallback = (ll && (ll.formattedAddress || '').trim()) ? ll.formattedAddress.trim() : label;
        var displayLabel = getPlaceDisplayLabel(place, fallback) || fallback;
        wbSetLocationUi({ label: displayLabel });
        /* Drop sticky ?venue= / ?event_id= so list re-render cannot re-apply deep-link. */
        wbClearWizardDeepLinkUrlForPlacesSearch();
        if (window.__WB_DIAG__) console.log('[WB_DIAG] triggering fetchEventsByLatLng lat=' + ll.lat + ', lng=' + ll.lng + ', radius=' + getRadiusKm(booking));
        fetchEventsByLatLng(booking, Number(ll.lat), Number(ll.lng), getRadiusKm(booking), {
          label: displayLabel,
          source: 'places',
          city: (parsed && parsed.city) || '',
          state: (parsed && parsed.state) || '',
          state_code: (parsed && parsed.state_code) || ''
        });
        return;
      }

      // 5. No coordinates available — update UI label but do NOT fetch.
      //    Only valid lat/lng from Place + fetchFields triggers event fetches.
      wbSetLocationUi({ label: label });
      if (window.__WB_DIAG__) console.warn('[WB_DIAG] handlePlaceSelect: no coordinates from Place, skipping fetch', { label: label, place: !!place });
    }

    /** When place/parsed unavailable, widget may set input value async. After delay, read it and trigger fetch if parseable. */
    function scheduleFetchFromInputAfterPlaceSelect(placeEl) {
      var delay = 200;
      setTimeout(function () {
        var displayText = '';
        try {
          if (placeEl && placeEl.shadowRoot) {
            var inner = placeEl.shadowRoot.querySelector('input');
            if (inner && inner.value) displayText = inner.value.trim();
          }
          if (!displayText) {
            var hidden = document.getElementById('workshop-location-input');
            if (hidden && hidden.value) displayText = hidden.value.trim();
          }
          if (!displayText && locSummary && locSummary.textContent) displayText = locSummary.textContent.trim();
        } catch (_) {}
        if (!displayText || displayText === 'Location selected' || displayText.indexOf(',') < 0) return;
        var fallbackParsed = parseCityStateFromFormattedAddress(displayText);
        if (!fallbackParsed || (!fallbackParsed.city && !fallbackParsed.state_code)) return;
        var flowRef = window.WorkshopLocationFlow;
        var cityKey = (flowRef && typeof flowRef.deriveEventCityKey === 'function')
          ? flowRef.deriveEventCityKey(fallbackParsed.state_code, fallbackParsed.city)
          : '';
        var resolved = {
          lat: undefined,
          lng: undefined,
          city: fallbackParsed.city,
          state: fallbackParsed.state,
          state_code: (fallbackParsed.state_code || fallbackParsed.state || '').toString().trim().toUpperCase(),
          country: fallbackParsed.country || 'US',
          source: 'places',
          city_key: cityKey ? String(cityKey).trim() : undefined
        };
        if (window.__WB_DIAG__) console.log('[WB_DIAG] scheduleFetchFromInput: text parsed, no lat/lng — skipping (coordinates required for fetch)', { state_code: resolved.state_code, displayText: displayText });
        // Do NOT call onLocationResolved without lat/lng — it would clear UI and show error.
      }, delay);
    }

    /**
     * Updates location input text. Delegates to wbSetLocationUi only (no direct .value elsewhere).
     * Empty/falsy label → resets to default.
     */
    function setLocationInputTextOnly(label) {
      wbSetLocationUi(label ? { label: label } : { isDefault: true });
    }

    /** @deprecated Use setLocationInputTextOnly or wbSetLocationUi. Kept for backward compatibility. */
    function setPlaceSelectionInInputs(placeEl, label) {
      wbSetLocationUi(label ? { label: label } : { isDefault: true });
    }
    window.__WB_onPlaceSelect = handlePlaceSelect;

    (function startPlaceSelectFallbackPoll() {
      var pollInterval = 1200;
      var pollTimer = null;
      var lastPlaceId = '';
      var idleStopsAt = 0;

      function tick() {
        if (typeof window.__WB_onPlaceSelect !== 'function') return;
        var placeEl = document.querySelector('#workshop-location-place-autocomplete,[data-workshop-place-autocomplete]');
        if (!placeEl || typeof placeEl.getPlace !== 'function') {
          stopPoll();
          return;
        }
        if (idleStopsAt && Date.now() > idleStopsAt) {
          stopPoll();
          return;
        }
        try {
          var p = placeEl.getPlace();
          var place = p && typeof p.then === 'function' ? null : p;
          var nextPlaceId = place ? String(place.id || place.placeId || place.place_id || '') : '';
          if (nextPlaceId && nextPlaceId !== lastPlaceId && nextPlaceId !== (window.__WORKSHOP_PLACE_LAST_ID__ || '')) {
            lastPlaceId = nextPlaceId;
            if (window.__WB_DIAG__) console.log('[WB_DIAG] place select fallback poll triggered', { placeId: nextPlaceId });
            window.__WB_onPlaceSelect({ target: placeEl });
            stopPoll();
            return;
          }
          if (place) lastPlaceId = nextPlaceId;
          if (!place && p && typeof p.then === 'function') {
            p.then(function (resolved) {
              if (!resolved) return;
              var id = String(resolved.id || resolved.placeId || resolved.place_id || '');
              if (id && id !== lastPlaceId && id !== (window.__WORKSHOP_PLACE_LAST_ID__ || '')) {
                lastPlaceId = id;
                if (window.__WB_DIAG__) console.log('[WB_DIAG] place select fallback poll (async) triggered', { placeId: id });
                window.__WB_onPlaceSelect({ target: placeEl });
                stopPoll();
              }
            }).catch(function () {});
          }
        } catch (_) {}
      }

      function stopPoll() {
        if (pollTimer) {
          clearInterval(pollTimer);
          pollTimer = null;
        }
      }

      function startPoll(msActive) {
        stopPoll();
        idleStopsAt = Date.now() + (msActive || 20000);
        pollTimer = setInterval(tick, pollInterval);
        tick();
      }

      document.addEventListener(
        'wbw:places-mounted',
        function () {
          startPoll(20000);
        },
        true
      );
      document.addEventListener(
        'focusin',
        function (e) {
          if (!e.target) return;
          if (
            e.target.closest &&
            e.target.closest('#workshop-location-place-autocomplete,[data-workshop-place-autocomplete],.wbw-search-place-host')
          ) {
            startPoll(25000);
          }
        },
        true
      );
    })();

    function fetchCity(cityKey) {
      // Theme: city_key fetch disabled. Only lat/lng + radius_km (events-v) is used.
      if (typeof window !== 'undefined' && (window.__WB_DEV__ === true || window.__WB_DEBUG__ === true)) {
        console.log('[WB_EVENTS] fetchCity(city_key) disabled; not sending request');
      }
      return Promise.reject(new Error('city_key fetch disabled'));

      if (!cityKey || !eventsRoot) return Promise.reject(new Error('Missing city_key or events root'));
      var cacheKey = workshopCacheShop + '|' + (productGid || '') + '|city:' + cityKey;
      var cached = workshopEventsCache[cacheKey];
      if (cached && (Date.now() - cached.ts) < WORKSHOP_CACHE_TTL_MS) {
        var requestId = ++workshopFetchRequestId;
        if (window.__WB_DIAG__) {
          console.log('[WB_DIAG] response meta.count (cache)', cached.data.meta && cached.data.meta.count);
          console.log('[WB_DIAG] events render source', window.__WB_LAST_RENDER_SOURCE__ || 'CITY');
        }
        var events = cached.data.events || [];
        var cityList = getCityList();
        var cityRec = cityList.filter(function (c) { return (c.city_key || '').toString().trim().toLowerCase() === (cityKey || '').toString().trim().toLowerCase(); })[0];
        var clat = cityRec && cityRec.lat != null ? Number(cityRec.lat) : null;
        var clng = cityRec && cityRec.lng != null ? Number(cityRec.lng) : null;
        var venueList = buildVenueListFromEvents(events, clat, clng);
        window.__WORKSHOP_VENUE_LIST__ = venueList;
        if (eventsPlaceholder) eventsPlaceholder.classList.add('pdp-wb-hidden');
        renderVenueCentricList(venueList);
        trySelectEventFromUrl();
        if (window.__WB_DIAG__) console.log('[workshop] cache hit city', cityKey);
        return Promise.resolve(cached.data);
      }
      if (cityAbortController) cityAbortController.abort();
      cityAbortController = new AbortController();
      var requestId = ++workshopFetchRequestId;
      var signal = cityAbortController.signal;
      var qs = 'city_key=' + encodeURIComponent(cityKey) + (productGid ? '&product_gid=' + encodeURIComponent(productGid) : '');
      if (window.__WB_DIAG__) {
        window.__WB_LAST_FETCH_ENDPOINT__ = 'city_key';
        console.log('[WB_DIAG] endpoint', 'city_key', 'url', joinProxyPath(PROXY_BASE, EVENTS_PATH) + '?' + qs);
      }
      return fetchWorkshopEvents(qs, { method: 'GET', credentials: 'same-origin', signal: signal, requestId: requestId })
        .then(function (res) {
          if (!res.ok) throw new Error('proxy_http_error');
          return res.text();
        })
        .then(function (text) {
          var data;
          try {
            data = text ? JSON.parse(text) : null;
          } catch (e) {
            showWorkshopFetchError();
            throw new Error('Invalid response');
          }
          if (!data || data.ok !== true) {
            console.warn('[workshop-events]', data && data.error_code, data && data.message);
            showWorkshopFetchError(data && data.message ? data.message : undefined);
            throw new Error('Invalid response');
          }
          logBackendRidIfPresent(requestId, data);
          return data;
        })
        .then(function (data) {
          if (requestId !== workshopFetchRequestId) return data;
          var events = data.events || [];
          if (events.length > 0) workshopEventsCache[cacheKey] = { data: data, ts: Date.now() };
          if (window.__WB_DIAG__) {
            console.log('[WB_DIAG] response meta.count', data.meta && data.meta.count);
            console.log('[WB_DIAG] events render source', window.__WB_LAST_RENDER_SOURCE__ || 'CITY');
          }
          var cityList = getCityList();
          var cityRec = cityList.filter(function (c) { return (c.city_key || '').toString().trim().toLowerCase() === (cityKey || '').toString().trim().toLowerCase(); })[0];
          var clat = cityRec && cityRec.lat != null ? Number(cityRec.lat) : null;
          var clng = cityRec && cityRec.lng != null ? Number(cityRec.lng) : null;
          var venueList = buildVenueListFromEvents(events, clat, clng);
          window.__WORKSHOP_VENUE_LIST__ = venueList;
          if (eventsPlaceholder) eventsPlaceholder.classList.add('pdp-wb-hidden');
          renderVenueCentricList(venueList);
          trySelectEventFromUrl();
          return data;
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return Promise.reject(err);
          throw err;
        });
    }

    /**
     * Legacy: fetchState is no longer used in the venue-centric flow.
     * All fetch paths now go through lat/lng via fetchEventsByLatLng.
     * This function is kept for backward compatibility but updated to use venue-centric rendering.
     */
    function fetchState(stateCode, isPrimary) {
      if (!stateCode || !eventsRoot) return Promise.reject(new Error('Missing state_code or events root'));
      var primary = isPrimary !== false;
      var cacheKey = workshopCacheShop + '|' + (productGid || '') + '|state:' + stateCode.toUpperCase();
      var cached = workshopEventsCache[cacheKey];
      if (cached && (Date.now() - cached.ts) < WORKSHOP_CACHE_TTL_MS) {
        if (primary) {
          if (window.__WB_DIAG__) console.log('[WB_DIAG] fetchState cache hit', stateCode);
          // Venue-centric rendering for cache hit
          var venueList = buildVenueListFromEvents(cached.data.events || [], null, null);
          window.__WORKSHOP_VENUE_LIST__ = venueList;
          if (eventsPlaceholder) eventsPlaceholder.classList.add('pdp-wb-hidden');
          renderVenueCentricList(venueList);
          trySelectEventFromUrl();
        }
        return Promise.resolve(cached.data);
      }
      if (primary && stateAbortController) stateAbortController.abort();
      if (primary) stateAbortController = new AbortController();
      var requestId = ++workshopFetchRequestId;
      var signal = primary && stateAbortController ? stateAbortController.signal : undefined;
      var qs = 'state_code=' + encodeURIComponent(stateCode) + (productGid ? '&product_gid=' + encodeURIComponent(productGid) : '');
      if (window.__WB_DIAG__) console.log('[WB_DIAG] endpoint state_code', stateCode, 'primary', primary);
      var fetchOpts = { method: 'GET', credentials: 'same-origin', requestId: requestId };
      if (signal) fetchOpts.signal = signal;
      return fetchWorkshopEvents(qs, fetchOpts)
        .then(function (res) {
          if (!res.ok) throw new Error('proxy_http_error');
          return res.text();
        })
        .then(function (text) {
          var data;
          try {
            data = text ? JSON.parse(text) : null;
          } catch (e) {
            showWorkshopFetchError();
            throw new Error('Invalid response');
          }
          if (!data || data.ok !== true) {
            console.warn('[workshop-events]', data && data.error_code, data && data.message);
            showWorkshopFetchError(data && data.message ? data.message : undefined);
            throw new Error('Invalid response');
          }
          logBackendRidIfPresent(requestId, data);
          return data;
        })
        .then(function (data) {
          if (requestId !== workshopFetchRequestId) return data;
          var events = data.events || [];
          if (events.length > 0) workshopEventsCache[cacheKey] = { data: data, ts: Date.now() };
          if (primary) {
            // Venue-centric rendering
            var venueList = buildVenueListFromEvents(events, null, null);
            window.__WORKSHOP_VENUE_LIST__ = venueList;
            if (eventsPlaceholder) eventsPlaceholder.classList.add('pdp-wb-hidden');
            renderVenueCentricList(venueList);
            trySelectEventFromUrl();
          }
          return data;
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return Promise.reject(err);
          throw err;
        });
    }

    /** Date from starts_at: wall-clock only. Extract YYYY-MM-DD from string; never use Date/toISOString (no timezone conversion). */
    function dayFromStartsAt(ev) {
      try {
        var s = (ev && ev.starts_at != null) ? String(ev.starts_at) : '';
        if (!s) return '';
        if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
        return '';
      } catch (e) { return ''; }
    }

    /** Extract HH:mm or HH:mm:ss from starts_at string (handles T, space, or regex). */
    function extractTimeFromStartsAt(st) {
      if (st == null) return '';
      var s = typeof st === 'string' ? st.trim() : '';
      if (!s) return '';
      var sep = s.length > 10 ? s.charAt(10) : '';
      if (sep === 'T' || sep === ' ') {
        if (s.length >= 19) return s.slice(11, 8);
        if (s.length >= 16) return s.slice(11, 5);
      }
      var match = s.match(/\d{1,2}:\d{2}(?::\d{2})?/);
      return match ? match[0] : '';
    }
    /** From a range time_label like "10:00-12:30" or "10-12.30", return start part as HH:mm for display. */
    function extractStartTimeFromRange(timeLabel) {
      if (!timeLabel || typeof timeLabel !== 'string') return '';
      var t = timeLabel.trim();
      var i = t.indexOf('-');
      if (i <= 0) return '';
      var startPart = t.slice(0, i).trim();
      if (!startPart) return '';
      var match = startPart.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
      if (match) return match[1] + ':' + match[2] + (match[3] != null ? ':' + match[3] : '');
      var hourOnly = startPart.match(/^(\d{1,2})$/);
      if (hourOnly) {
        var h = parseInt(hourOnly[1], 10);
        if (h >= 0 && h <= 23) return (h < 10 ? '0' : '') + h + ':00';
      }
      return '';
    }
    /** Convert 24h string (HH:mm or HH:mm:ss) to 12h (e.g. 02:00 PM). */
    function time24hTo12h(s) {
      if (!s || typeof s !== 'string') return '';
      var parts = s.trim().split(':');
      var h = parseInt(parts[0], 10);
      var m = (parts.length >= 2 && parts[1]) ? parseInt(parts[1], 10) : 0;
      if (isNaN(h) || h < 0 || h > 23 || isNaN(m) || m < 0 || m > 59) return '';
      var hour12 = h % 12;
      if (hour12 === 0) hour12 = 12;
      var ampm = h < 12 ? 'AM' : 'PM';
      var mm = (m < 10 ? '0' : '') + m;
      return (hour12 < 10 ? '0' : '') + hour12 + ':' + mm + ' ' + ampm;
    }

    /** Event time display: ONLY ev.time_label (pure string). Wall-clock: never convert to local; no Date/Intl/toLocale*, no parsing of starts_at. */
    var _workshopTimeLabelWarned = (typeof Set !== 'undefined') ? new Set() : {};
    function getEventDisplayTime(ev) {
      if (!ev || typeof ev !== 'object') return '';
      var t = (ev.time_label != null && ev.time_label !== '') ? String(ev.time_label).trim() : '';
      if (!t) {
        var key = (ev.id != null ? String(ev.id) : '') || (ev.handle != null ? String(ev.handle) : '') || '';
        if (key && !_workshopTimeLabelWarned.has(key)) {
          _workshopTimeLabelWarned.add(key);
          console.warn('[workshop] time_label missing for event', ev.id || ev.handle || '');
        }
      }
      return t;
    }

    /** Date label from date_key (YYYY-MM-DD). Wall-clock: no timezone conversion; display the calendar day as stored. */
    function formatDateLabelFromKey(dateKey) {
      if (!dateKey || typeof dateKey !== 'string') return dateKey || '';
      var parts = dateKey.trim().split('-').map(Number);
      if (parts.length < 3) return dateKey;
      var y = parts[0], m = parts[1], d = parts[2];
      if (!y || !m || !d) return dateKey;
      try {
        return new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric' }).format(new Date(y, m - 1, d));
      } catch (_) { return dateKey; }
    }

    function wbCoerceImageUrl(img) {
      if (img == null || img === '') return '';
      if (typeof img === 'object') {
        if (img.url) return wbNormalizeAssetUrl(String(img.url).trim());
        if (img.src) return wbNormalizeAssetUrl(String(img.src).trim());
        if (img.value != null && img.value !== img) return wbCoerceImageUrl(img.value);
        if (img.preview && img.preview.image && img.preview.image.url) {
          return wbNormalizeAssetUrl(String(img.preview.image.url).trim());
        }
      }
      var s = String(img).trim();
      if (!s || s === '[object Object]') return '';
      return wbNormalizeAssetUrl(s);
    }

    /** Protocol-relative CDN URLs → https (theme preview / http localhost). */
    function wbNormalizeAssetUrl(url) {
      var u = String(url || '').trim();
      if (!u) return '';
      if (u.indexOf('//') === 0) return 'https:' + u;
      return u;
    }

    function wbIsValidImageUrl(url) {
      if (!url || typeof url !== 'string') return false;
      var u = url.trim();
      if (!u || u === '[object Object]') return false;
      return /^https?:\/\//i.test(u) || u.indexOf('//') === 0 || u.charAt(0) === '/';
    }

    /** US state code from address line, e.g. "…, Aurora, CO 80239, …" → CO */
    function wbRegionCodeFromAddress(addr) {
      var m = String(addr || '').match(/,\s*([A-Za-z]{2})\s+\d{5}(?:-\d{4})?\b/);
      return m ? m[1].toUpperCase() : '';
    }

    function wbEscapeAttr(s) {
      return String(s || '')
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;');
    }

    /** Venue image from fetch event or nested venue object (includes metaobject-backed fields). */
    function wbVenueImageFromApiEvent(ev) {
      if (!ev || typeof ev !== 'object') return '';
      var venue = ev.venue && typeof ev.venue === 'object' ? ev.venue : {};
      var raw =
        ev.venue_image ||
        ev.venueImage ||
        ev.venue_image_url ||
        venue.venue_image ||
        venue.venueImage ||
        venue.image ||
        ev.cover_image ||
        venue.cover_image ||
        '';
      var u = wbCoerceImageUrl(raw);
      return wbIsValidImageUrl(u) ? u : '';
    }

    function wbVenueImageFromStub(v) {
      if (!v || typeof v !== 'object') return '';
      var u = wbCoerceImageUrl(
        v.venue_image ||
        v.venueImage ||
        v.image ||
        v.cover_image ||
        ''
      );
      return wbIsValidImageUrl(u) ? u : '';
    }

    function wbNormalizeVenueNameKey(name) {
      return String(name || '')
        .trim()
        .toLowerCase()
        .replace(/,\s*[a-z]{2}\s*$/i, '')
        .replace(/\s+/g, ' ')
        .replace(/[^\w\s\u0100-\u024f-]/g, '')
        .trim();
    }

    function wbMergeVenueImageIfMissing(targetVenue, sourceVenue) {
      if (!targetVenue || !sourceVenue) return;
      if (wbIsValidImageUrl(wbVenueImageFromStub(targetVenue))) return;
      var img = wbVenueImageFromStub(sourceVenue);
      if (wbIsValidImageUrl(img)) targetVenue.venue_image = img;
    }

    function wbVenueNameKeysMatch(probe, catalogKey) {
      if (!probe || !catalogKey) return false;
      if (probe === catalogKey) return true;
      if (probe.length >= 4 && catalogKey.indexOf(probe) >= 0) return true;
      if (catalogKey.length >= 4 && probe.indexOf(catalogKey) >= 0) return true;
      return catalogKey.indexOf(probe) === 0 || probe.indexOf(catalogKey) === 0;
    }

    /** Cached venue_ref_id / venue_name → image URL from shop metaobject catalog JSON. */
    function wbGetVenueImageCatalogIndex(bookingRoot) {
      if (!bookingRoot) return null;
      if (bookingRoot._wbVenueImageCatalogIndex) return bookingRoot._wbVenueImageCatalogIndex;
      var el = bookingRoot.querySelector('script[type="application/json"][data-wb-venues-waitlist-catalog]');
      if (!el || !el.textContent) return null;
      var rows;
      try {
        rows = JSON.parse(el.textContent);
      } catch (_) {
        return null;
      }
      if (!Array.isArray(rows)) return null;
      var byRef = Object.create(null);
      var byName = Object.create(null);
      var byHandle = Object.create(null);
      var regionByRef = Object.create(null);
      var regionByName = Object.create(null);
      var regionByHandle = Object.create(null);
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        if (!row || typeof row !== 'object') continue;
        var img = wbCoerceImageUrl(row.venue_image);
        if (wbIsValidImageUrl(img)) {
          wbCatalogRegisterRef(byRef, row.venue_ref_id, img);
          var nk = wbNormalizeVenueNameKey(row.venue_name);
          if (nk) byName[nk] = img;
          var hk = row.venue_handle != null ? String(row.venue_handle).trim().toLowerCase() : '';
          if (hk) {
            byHandle[hk] = img;
            if (hk.indexOf('venue-') === 0) {
              var hkShort = hk.slice(6);
              if (hkShort) byHandle[hkShort] = img;
            }
          }
        }
        var regionCode = wbResolveCatalogRegionCode(row);
        if (regionCode) {
          wbCatalogRegisterRef(regionByRef, row.venue_ref_id, regionCode);
          var rnk = wbNormalizeVenueNameKey(row.venue_name);
          if (rnk) regionByName[rnk] = regionCode;
          var rhk = row.venue_handle != null ? String(row.venue_handle).trim().toLowerCase() : '';
          if (rhk) {
            regionByHandle[rhk] = regionCode;
            if (rhk.indexOf('venue-') === 0) {
              var rhkShort = rhk.slice(6);
              if (rhkShort) regionByHandle[rhkShort] = regionCode;
            }
          }
        }
      }
      bookingRoot._wbVenueImageCatalogIndex = {
        byRef: byRef,
        byName: byName,
        byHandle: byHandle,
        regionByRef: regionByRef,
        regionByName: regionByName,
        regionByHandle: regionByHandle,
      };
      return bookingRoot._wbVenueImageCatalogIndex;
    }

    function wbLookupVenueImageFromCatalogRow(row, venue, displayName) {
      if (!row || typeof row !== 'object') return '';
      var img = wbCoerceImageUrl(row.venue_image);
      if (!wbIsValidImageUrl(img)) return '';
      venue = venue && typeof venue === 'object' ? venue : {};
      var rowRef = String(row.venue_ref_id || '').trim();
      var venueRef = String(venue.venue_ref_id || venue.id || '').trim();
      if (rowRef && venueRef && (rowRef === venueRef || wbNormalizeVenueRefKey(rowRef) === wbNormalizeVenueRefKey(venueRef))) {
        return img;
      }
      var rowHandle = String(row.venue_handle || '').trim().toLowerCase();
      var venueHandle = String(venue.venue_handle || venue.handle || '').trim().toLowerCase();
      if (rowHandle && venueHandle && rowHandle === venueHandle) return img;
      var rowName = wbNormalizeVenueNameKey(row.venue_name);
      var names = [displayName, venue.venue_name, venue.name, venue.city_name, venue.city];
      for (var ni = 0; ni < names.length; ni++) {
        var probe = wbNormalizeVenueNameKey(names[ni]);
        if (probe && rowName && (probe === rowName || wbVenueNameKeysMatch(probe, rowName))) return img;
      }
      return '';
    }

    function wbLookupVenueImageFromCatalog(venue, displayName, bookingRoot) {
      var idx = wbGetVenueImageCatalogIndex(bookingRoot);
      venue = venue && typeof venue === 'object' ? venue : {};
      if (!idx) {
        return wbLookupVenueImageFromCatalogRows(venue, displayName, bookingRoot);
      }
      var refs = [venue.venue_ref_id, venue.id];
      for (var ri = 0; ri < refs.length; ri++) {
        var ref = refs[ri] != null ? String(refs[ri]).trim() : '';
        if (!ref) continue;
        if (idx.byRef[ref]) return idx.byRef[ref];
        var normRef = wbNormalizeVenueRefKey(ref);
        if (normRef && idx.byRef[normRef]) return idx.byRef[normRef];
      }
      var handle = (venue.venue_handle || venue.handle || '').toString().trim().toLowerCase();
      if (handle && idx.byHandle && idx.byHandle[handle]) return idx.byHandle[handle];
      var names = [displayName, venue.venue_name, venue.name, venue.city_name, venue.city];
      for (var ni = 0; ni < names.length; ni++) {
        var nk = wbNormalizeVenueNameKey(names[ni]);
        if (nk && idx.byName[nk]) return idx.byName[nk];
      }
      for (var ci = 0; ci < names.length; ci++) {
        var probe = wbNormalizeVenueNameKey(names[ci]);
        if (!probe) continue;
        var nameKeys = Object.keys(idx.byName || {});
        for (var ki = 0; ki < nameKeys.length; ki++) {
          var catalogKey = nameKeys[ki];
          if (wbVenueNameKeysMatch(probe, catalogKey)) return idx.byName[catalogKey];
        }
      }
      var fromRows = wbLookupVenueImageFromCatalogRows(venue, displayName, bookingRoot);
      return wbIsValidImageUrl(fromRows) ? fromRows : '';
    }

    function wbRegionCodeFromCatalogName(name) {
      var raw = String(name || '').trim();
      if (!raw) return '';
      if (/^[a-z]{2}$/i.test(raw)) return raw.toUpperCase();
      var key = raw.toLowerCase();
      var fromMap = WB_CATALOG_REGION_NAME_TO_CODE[key];
      return fromMap ? fromMap : '';
    }

    function wbResolveCatalogRegionCode(row) {
      if (!row || typeof row !== 'object') return '';
      try {
        if (
          window.WorkshopBookingWizardHelpers &&
          typeof window.WorkshopBookingWizardHelpers.catalogRowRegionCode === 'function'
        ) {
          var shared = String(
            window.WorkshopBookingWizardHelpers.catalogRowRegionCode(row) || ''
          )
            .trim()
            .toUpperCase();
          if (shared) return shared;
        }
      } catch (_) {}
      var code = String(row.region_code || row.state_code || '').trim();
      if (/^[a-z]{2}$/i.test(code)) return code.toUpperCase();
      code = wbRegionCodeFromCatalogName(row.region_name);
      if (code) return code;
      return wbRegionCodeFromAddress(row.venue_address || row.address || '');
    }

    function wbResolveVenueRegionCode(venue, displayName, bookingRoot) {
      venue = venue && typeof venue === 'object' ? venue : {};
      var direct = [venue.region_code, venue.state_code];
      for (var di = 0; di < direct.length; di++) {
        var d = String(direct[di] || '').trim();
        if (/^[a-z]{2}$/i.test(d)) return d.toUpperCase();
      }
      var fromCat = wbLookupRegionCodeFromCatalog(venue, displayName, bookingRoot);
      if (fromCat) return fromCat;
      return wbRegionCodeFromAddress(venue.venue_address || venue.address || '');
    }

    function wbLookupRegionCodeFromCatalogRow(row, venue, displayName) {
      if (!row || typeof row !== 'object') return '';
      var code = wbResolveCatalogRegionCode(row);
      if (!code) return '';
      venue = venue && typeof venue === 'object' ? venue : {};
      var rowRef = String(row.venue_ref_id || '').trim();
      var venueRef = String(venue.venue_ref_id || venue.id || '').trim();
      if (rowRef && venueRef && (rowRef === venueRef || wbNormalizeVenueRefKey(rowRef) === wbNormalizeVenueRefKey(venueRef))) {
        return code;
      }
      var rowHandle = String(row.venue_handle || '').trim().toLowerCase();
      var venueHandle = String(venue.venue_handle || venue.handle || '').trim().toLowerCase();
      if (rowHandle && venueHandle && rowHandle === venueHandle) return code;
      var rowName = wbNormalizeVenueNameKey(row.venue_name);
      var names = [displayName, venue.venue_name, venue.name, venue.city_name, venue.city];
      for (var ni = 0; ni < names.length; ni++) {
        var probe = wbNormalizeVenueNameKey(names[ni]);
        if (probe && rowName && (probe === rowName || wbVenueNameKeysMatch(probe, rowName))) return code;
      }
      return '';
    }

    function wbLookupRegionCodeFromCatalogRows(venue, displayName, bookingRoot) {
      if (!bookingRoot) return '';
      var el = bookingRoot.querySelector('script[type="application/json"][data-wb-venues-waitlist-catalog]');
      if (!el || !el.textContent) return '';
      var rows;
      try {
        rows = JSON.parse(el.textContent);
      } catch (_) {
        return '';
      }
      if (!Array.isArray(rows)) return '';
      for (var i = 0; i < rows.length; i++) {
        var hit = wbLookupRegionCodeFromCatalogRow(rows[i], venue, displayName);
        if (hit) return hit;
      }
      return '';
    }

    function wbLookupRegionCodeFromCatalog(venue, displayName, bookingRoot) {
      var idx = wbGetVenueImageCatalogIndex(bookingRoot);
      venue = venue && typeof venue === 'object' ? venue : {};
      if (!idx) {
        return wbLookupRegionCodeFromCatalogRows(venue, displayName, bookingRoot);
      }
      var refs = [venue.venue_ref_id, venue.id];
      for (var ri = 0; ri < refs.length; ri++) {
        var ref = refs[ri] != null ? String(refs[ri]).trim() : '';
        if (!ref) continue;
        if (idx.regionByRef && idx.regionByRef[ref]) return idx.regionByRef[ref];
        var normRef = wbNormalizeVenueRefKey(ref);
        if (normRef && idx.regionByRef && idx.regionByRef[normRef]) return idx.regionByRef[normRef];
      }
      var handle = (venue.venue_handle || venue.handle || '').toString().trim().toLowerCase();
      if (handle && idx.regionByHandle && idx.regionByHandle[handle]) return idx.regionByHandle[handle];
      var names = [displayName, venue.venue_name, venue.name, venue.city_name, venue.city];
      for (var ni = 0; ni < names.length; ni++) {
        var nk = wbNormalizeVenueNameKey(names[ni]);
        if (nk && idx.regionByName && idx.regionByName[nk]) return idx.regionByName[nk];
      }
      for (var ci = 0; ci < names.length; ci++) {
        var probe = wbNormalizeVenueNameKey(names[ci]);
        if (!probe) continue;
        var nameKeys = Object.keys(idx.regionByName || {});
        for (var ki = 0; ki < nameKeys.length; ki++) {
          var catalogKey = nameKeys[ki];
          if (wbVenueNameKeysMatch(probe, catalogKey)) return idx.regionByName[catalogKey];
        }
      }
      return wbLookupRegionCodeFromCatalogRows(venue, displayName, bookingRoot);
    }

    function wbWizardVenueLabelWithRegionCode(label, regionCode) {
      var city = String(label || '').trim();
      var code = String(regionCode || '').trim();
      if (!city || !code) return city;
      var escaped = code.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      if (new RegExp(',\\s*' + escaped + '$', 'i').test(city)) return city;
      return city + ', ' + code;
    }

    function wbLookupVenueImageFromCatalogRows(venue, displayName, bookingRoot) {
      if (!bookingRoot) return '';
      var el = bookingRoot.querySelector('script[type="application/json"][data-wb-venues-waitlist-catalog]');
      if (!el || !el.textContent) return '';
      var rows;
      try {
        rows = JSON.parse(el.textContent);
      } catch (_) {
        return '';
      }
      if (!Array.isArray(rows)) return '';
      for (var i = 0; i < rows.length; i++) {
        var hit = wbLookupVenueImageFromCatalogRow(rows[i], venue, displayName);
        if (wbIsValidImageUrl(hit)) return hit;
      }
      return '';
    }

    /** Best image for venue grid: stub, any event, then shop catalog (fixes Auckland etc.). */
    function wbResolveVenueCardImage(venue, displayName, bookingRoot) {
      if (!venue || typeof venue !== 'object') return '';
      var u = wbVenueImageFromStub(venue);
      if (wbIsValidImageUrl(u)) return u;
      if (venue.venue_image) venue.venue_image = '';
      var evs = Array.isArray(venue.events) ? venue.events : [];
      for (var ei = 0; ei < evs.length; ei++) {
        u = wbVenueImageFromApiEvent(evs[ei]);
        if (wbIsValidImageUrl(u)) {
          venue.venue_image = u;
          return u;
        }
      }
      u = wbLookupVenueImageFromCatalog(venue, displayName, bookingRoot);
      if (wbIsValidImageUrl(u)) venue.venue_image = u;
      return wbIsValidImageUrl(u) ? u : '';
    }

    function wbEnrichVenueListImagesFromCatalog(venueList, bookingRoot) {
      if (!venueList || !bookingRoot || !Array.isArray(venueList.groups)) return;
      venueList.groups.forEach(function (g) {
        var grpLabel = (g.city_label || '').toString().trim();
        (g.venues || []).forEach(function (v) {
          if (!v || typeof v !== 'object') return;
          var dn =
            grpLabel && !/^us-[a-z]{2}-/i.test(grpLabel)
              ? grpLabel
              : (v.venue_name || v.name || v.city_name || '').toString().trim();
          wbResolveVenueCardImage(v, dn, bookingRoot);
        });
      });
    }

    function wbWizardVenuePlaceholderInnerHtml() {
      return (
        '<span class="wbw-venue-card__placeholder" aria-hidden="true">' +
        '<svg class="wbw-venue-card__placeholder-icon" width="44" height="44" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<rect x="5" y="9" width="38" height="30" rx="5" stroke="currentColor" stroke-width="2"/>' +
        '<circle cx="16.5" cy="19.5" r="3.25" fill="currentColor" opacity="0.85"/>' +
        '<path d="M9 35l11-11 7.5 7.5L31 18l8 8v9H9z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>' +
        '</svg>' +
        '</span>'
      );
    }

    function wbApplyVenueCardMediaPlaceholder(mediaEl) {
      if (!mediaEl) return;
      mediaEl.className = 'wbw-venue-card__media wbw-venue-card__media--empty';
      mediaEl.setAttribute('aria-hidden', 'true');
      mediaEl.innerHTML = wbWizardVenuePlaceholderInnerHtml();
    }

    function wbBindVenueCardImages(container, bookingRoot) {
      if (!container || !container.querySelectorAll) return;
      var imgs = container.querySelectorAll('.wbw-venue-card__media img');
      for (var ii = 0; ii < imgs.length; ii++) {
        (function (img, index) {
          if (index < 6) img.loading = 'eager';
          img.decoding = 'async';
          img.addEventListener(
            'error',
            function onImgErr() {
              var card = img.closest('.wb-venue-pick-card, .wb-venue-card');
              if (!card || !card._wbVenue) return;
              var label = card.getAttribute('data-wbw-city-label') || '';
              var fb = wbLookupVenueImageFromCatalog(card._wbVenue, label, bookingRoot);
              if (wbIsValidImageUrl(fb) && fb !== img.getAttribute('src')) {
                img.src = fb;
                card._wbVenue.venue_image = fb;
                return;
              }
              wbApplyVenueCardMediaPlaceholder(img.closest('.wbw-venue-card__media'));
            },
            { once: true }
          );
        })(imgs[ii], ii);
      }
    }

    function wbWizardVenueCardMediaHtml(imgUrl) {
      return wbIsValidImageUrl(imgUrl)
        ? '<span class="wbw-venue-card__media"><img src="' +
            wbEscapeAttr(imgUrl) +
            '" alt="" loading="eager" decoding="async" /></span>'
        : '<span class="wbw-venue-card__media wbw-venue-card__media--empty" aria-hidden="true">' +
            wbWizardVenuePlaceholderInnerHtml() +
            '</span>';
    }

    function wbWizardVenueCardCaptionHtml(lineCity, kmLine) {
      return (
        '<span class="wbw-venue-card__caption">' +
        '<span class="wbw-venue-card__name">' +
        escapeHtml(lineCity) +
        '</span>' +
        (kmLine ? '<span class="wbw-venue-card__km">' + escapeHtml(kmLine) + '</span>' : '') +
        '</span>'
      );
    }

    function wbWizardShowVenueDistance(root) {
      if (!root) return false;
      var fromSelf = root.getAttribute ? String(root.getAttribute('data-wbw-show-venue-distance') || '').trim() : '';
      if (fromSelf === 'true') return true;
      if (fromSelf === 'false') return false;
      try {
        var wiz = root.closest && root.closest('[data-workshop-booking-wizard]');
        if (wiz) return String(wiz.getAttribute('data-wbw-show-venue-distance') || '').trim() === 'true';
      } catch (_) {}
      return false;
    }

    function wbWorkshopTypeFromBookingRoot(bookingRoot) {
      if (!bookingRoot || !bookingRoot.getAttribute) return '';
      return String(bookingRoot.getAttribute('data-workshop-type') || '').trim().toLowerCase();
    }

    /** Resin: permanent stores. Center uses Dallas (+ Orlando); legacy Carrollton kept. */
    function wbResinStoreVenue(venue) {
      if (!venue || typeof venue !== 'object') return false;
      if (venue._coral_store === true || venue.venue_type === 'store') return true;
      var storeCities = ['dallas', 'orlando', 'carrollton'];
      var parts = [
        venue.venue_name,
        venue.name,
        venue.city_name,
        venue.city,
        venue.venue_handle,
        venue.handle,
        venue.city_key,
        venue.sell_product_handle,
        venue.product_handle,
      ];
      for (var ci = 0; ci < storeCities.length; ci++) {
        var city = storeCities[ci];
        for (var i = 0; i < parts.length; i++) {
          var s = String(parts[i] || '')
            .trim()
            .toLowerCase();
          if (!s) continue;
          if (s === city) return true;
          if (new RegExp('(^|-)(' + city + ')$').test(s)) return true;
          if (new RegExp('\\b' + city + '\\b').test(s)) return true;
        }
      }
      return false;
    }

    function wbWizardVenueAllowedForProduct(venue, bookingRoot) {
      // Coral hub lists type-collection city products as-is (incl. waitlist).
      if (bookingRoot && bookingRoot.__wbCoralHub) return true;
      if (wbWorkshopTypeFromBookingRoot(bookingRoot) === 'resin') {
        return wbResinStoreVenue(venue);
      }
      return true;
    }

    function wbWizardVenueGridCardInnerHtml(lineCity, kmLine, imgUrl, flatIsWaitlist) {
      var front = wbWizardVenueCardMediaHtml(imgUrl) + wbWizardVenueCardCaptionHtml(lineCity, kmLine);
      if (!flatIsWaitlist) return front;
      return (
        '<span class="wbw-venue-flip__inner">' +
        '<span class="wbw-venue-flip__face wbw-venue-flip__face--front">' +
        front +
        '</span>' +
        '<span class="wbw-venue-flip__face wbw-venue-flip__face--back">' +
        '<span class="wbw-venue-flip__back-name">' +
        escapeHtml(lineCity) +
        '</span>' +
        '<span class="wbw-venue-flip__back-cta-wrap">' +
        '<button type="button" class="wbw-venue-wl-cta" data-wbw-wl-signup>Sign up for Waitlist</button>' +
        '</span>' +
        '</span>' +
        '</span>'
      );
    }

    function normalizeApiEvent(ev) {
      if (!ev || typeof ev !== 'object') return null;
      var statusEarly = wbResolveEventStatus(ev);
      var displayStatusEarly = wbNormalizeEventStatus(ev.display_status || ev.displayStatus || '');
      if (
        statusEarly === 'draft' ||
        statusEarly === 'completed' ||
        statusEarly === 'cancelled' ||
        displayStatusEarly === 'hidden' ||
        displayStatusEarly === 'ended'
      ) return null;
      const venue = ev.venue && typeof ev.venue === 'object' ? ev.venue : {};
      /** date_key: use ev.date_key when present; else derive from starts_at (wall-clock string). When both date_key and time_label are set, starts_at is ignored. */
      let dateKey = (ev.date_key || '').toString().trim();
      if (!dateKey && ev.starts_at) {
        try {
          var st = (ev.starts_at || '').toString();
          if (/^\d{4}-\d{2}-\d{2}/.test(st)) dateKey = st.slice(0, 10);
        } catch (_) {}
      }
      /** time_label: use only if "11:00 AM" or single 24h (e.g. 14:00). Ranges (10:00-12:30) are ignored; fallback to starts_at. If starts_at empty → show "-". */
      function isTimeLabelAmPmFormat(s) {
        if (!s || typeof s !== 'string') return false;
        return /^\s*\d{1,2}:\d{2}(:\d{2})?\s*(AM|PM)\s*$/i.test(s.trim());
      }
      function isTimeLabel24h(s) {
        if (!s || typeof s !== 'string') return false;
        var t = s.trim();
        return /^\d{1,2}:\d{2}(:\d{2})?$/.test(t) && t.indexOf('-') === -1;
      }
      var timeLabel = (ev.time_label != null && ev.time_label !== '') ? String(ev.time_label).trim() : '';
      if (isTimeLabelAmPmFormat(timeLabel)) {
        /* use as-is */
      } else if (isTimeLabel24h(timeLabel)) {
        timeLabel = time24hTo12h(timeLabel);
      } else {
        timeLabel = '';
        if (ev.starts_at) {
          try {
            var rawTime = extractTimeFromStartsAt(ev.starts_at);
            if (rawTime) timeLabel = time24hTo12h(rawTime);
          } catch (_) {}
        }
        if (!timeLabel && ev.time_label) {
          var rangeStart = extractStartTimeFromRange(ev.time_label);
          if (rangeStart) timeLabel = time24hTo12h(rangeStart);
        }
      }
      const statusVal = wbResolveEventStatus(ev);
      const capRem = ev.capacity_remaining != null && ev.capacity_remaining !== '' ? Number(ev.capacity_remaining) : null;
      const capTot = ev.capacity_total != null && ev.capacity_total !== '' ? Number(ev.capacity_total) : null;
      const availVariants = Array.isArray(ev.available_variants) ? ev.available_variants : (Array.isArray(ev.availableVariants) ? ev.availableVariants : []);
      const variantId = ev.variant_id != null && ev.variant_id !== '' ? ev.variant_id : (availVariants[0] && (availVariants[0].id != null || availVariants[0].variant_id != null)) ? (availVariants[0].id || availVariants[0].variant_id) : null;
      const productHandle = (ev.product_handle || ev.productHandle || (ev.product && ev.product.handle) || '').toString().trim() || null;
      const linkEnabled = ev.link_enabled !== false && !!productHandle;
      var venueLat = wbFirstCoord(ev.venue_lat, ev.venue_latitude, ev.lat, ev.latitude, venue.lat, venue.latitude);
      var venueLng = wbFirstCoord(ev.venue_lng, ev.venue_longitude, ev.lng, ev.longitude, venue.lng, venue.longitude);
      var cityName = (ev.city_name || venue.city_name || ev.city || venue.city || '').toString().trim();
      if (window.__WB_DEBUG__) console.debug('[WB NORM]', {
        name: ev.venue_name || ev.name || venue.name || '',
        city_key: ev.city_key || venue.city_key || '',
        resolvedLat: venueLat, resolvedLng: venueLng,
        raw: { ev_venue_lat: ev.venue_lat, ev_lat: ev.lat, ev_latitude: ev.latitude, v_lat: venue.lat, v_latitude: venue.latitude,
               ev_venue_lng: ev.venue_lng, ev_lng: ev.lng, ev_longitude: ev.longitude, v_lng: venue.lng, v_longitude: venue.longitude }
      });
      return {
        id: ev.id,
        handle: ev.handle,
        canonical_event_id: ev.canonical_event_id || ev.event_id || ev.id || '',
        capacity_group_id: ev.capacity_group_id || ev.capacityGroupId || '',
        variant_id: variantId,
        available_variants: availVariants,
        event_metaobject_gid: String(ev.event_metaobject_gid || ev.id || ''),
        product_handle: productHandle,
        link_enabled: linkEnabled,
        state: ev.state || venue.state || '',
        state_code: ev.state_code || venue.state_code || '',
        city: ev.city || venue.city || '',
        city_name: cityName || null,
        city_key: (ev.city_key || venue.city_key || '').toString().trim(),
        status: statusVal,
        display_status: ev.display_status || ev.displayStatus || statusVal,
        event_name: ev.event_name || ev.name || '',
        venue_name: ev.venue_name || venue.name || venue.title || '',
        venue_handle: (ev.venue_handle || (venue && venue.handle) || '').toString().trim(),
        venue_address: ev.venue_address || venue.address || '',
        venue_phone: ev.venue_phone || venue.phone || '',
        venue_work_hours: ev.venue_work_hours || venue.work_hours || '',
        venue_tags: (function () {
          var t = ev.venue_tags != null ? ev.venue_tags : (venue && venue.tags);
          if (Array.isArray(t)) return t.map(function (x) { return (x != null && x !== '') ? String(x).trim() : ''; }).filter(Boolean);
          if (t != null && t !== '') return [String(t).trim()];
          return [];
        })(),
        venue_ref_id: ev.venue_ref_id || venue.id || '',
        date_key: dateKey,
        starts_at: ev.starts_at || '',
        capacity_remaining: capRem,
        capacity_total: capTot,
        venue_image: wbVenueImageFromApiEvent(ev),
        time_label: timeLabel,
        venue_lat: (venueLat != null && Number.isFinite(venueLat)) ? venueLat : null,
        venue_lng: (venueLng != null && Number.isFinite(venueLng)) ? venueLng : null,
        also_available_products: Array.isArray(ev.also_available_products) ? ev.also_available_products : []
      };
    }

    function productUrlFromEvent(event) {
      const enabled = event && event.link_enabled !== false;
      const handle = (event && (event.product_handle || event.productHandle || (event.product && event.product.handle) || '')) || null;
      const h = (handle && String(handle).trim()) || null;
      if (!enabled || !h) return null;
      return '/products/' + h;
    }

    /** Weekday from date_key (YYYY-MM-DD) only; no timezone. */
    /** Get weekday name from date_key (YYYY-MM-DD). UTC-safe: uses Date.UTC to avoid timezone shifts. */
    function getWeekdayFromDateKey(dateKey) {
      if (!dateKey || typeof dateKey !== 'string') return '';
      var parts = dateKey.trim().split('-').map(Number);
      if (parts.length < 3) return '';
      var y = parts[0], m = parts[1], d = parts[2];
      if (!y || !m || !d) return '';
      try {
        // Use Date.UTC to create a UTC timestamp, then getUTCDay() for timezone-safe weekday
        var utcDate = new Date(Date.UTC(y, m - 1, d));
        var day = utcDate.getUTCDay();
        var names = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return names[day] || '';
      } catch (_) { return ''; }
    }

    /** Venue-centric date label: WEEKDAY • YYYY-MM-DD (from date_key only). Wall-clock: no timezone conversion. */
    function formatDateLabelVenueCentric(dateKey) {
      if (!dateKey || typeof dateKey !== 'string') return dateKey || '';
      var weekday = getWeekdayFromDateKey(dateKey);
      return (weekday ? weekday + ' • ' : '') + dateKey.trim();
    }

    // near_cities rendering functions removed: venue-centric UI does not use them

    function ensureCrossProductStyles() {
      if (document.getElementById('wb-cross-product-styles')) return;
      var style = document.createElement('style');
      style.id = 'wb-cross-product-styles';
      style.textContent = '.wb-cross-product{font-size:11px;color:rgba(0,0,0,.6);margin-top:6px;padding-top:6px;border-top:1px solid rgba(0,0,0,.08);}.wb-cross-product__label{display:block;margin-bottom:4px;}.wb-cross-product__list{display:flex;flex-wrap:wrap;gap:8px;align-items:center;}.wb-cross-product__item{display:inline-flex;align-items:center;gap:6px;text-decoration:none;color:inherit;border-radius:6px;padding:2px 6px;transition:background .15s,text-decoration .15s;}.wb-cross-product__item:hover{text-decoration:underline;background:rgba(0,0,0,.04);}.wb-cross-product__img{width:20px;height:20px;border-radius:4px;object-fit:cover;background:rgba(0,0,0,.06);}.wb-cross-product--booking{margin-top:12px;padding-top:10px;}.wb-cross-product--booking .wb-cross-product__img{width:22px;height:22px;}';
      document.head.appendChild(style);
    }

    function ensureWaitlistStyles() {
      if (document.getElementById('wb-waitlist-styles-v10')) return;
      ['wb-waitlist-styles-v9', 'wb-waitlist-styles-v8', 'wb-waitlist-styles-v7', 'wb-waitlist-styles-v6', 'wb-waitlist-styles-v5', 'wb-waitlist-styles-v4', 'wb-waitlist-styles-v3', 'wb-waitlist-styles-v2', 'wb-waitlist-styles'].forEach(function (id) {
        var o = document.getElementById(id);
        if (o && o.parentNode) o.parentNode.removeChild(o);
      });
      var st = document.createElement('style');
      st.id = 'wb-waitlist-styles-v10';
      st.textContent =
        '.wb-waitlist-actions{display:flex;flex-direction:column;gap:10px;align-items:flex-start;max-width:100%;}' +
        '.wb-waitlist-btn{margin-top:4px;padding:10px 16px;border-radius:6px;border:1px solid rgba(var(--color-foreground),0.2);background:rgb(var(--color-background));cursor:pointer;font:inherit;}' +
        '.wb-waitlist-btn:disabled{opacity:0.6;cursor:not-allowed;}' +
        '.wb-waitlist-form{display:none;flex-direction:column;gap:8px;width:100%;margin-top:8px;}' +
        '.wb-waitlist-form.is-open{display:flex;}' +
        '.wb-waitlist-form input{padding:8px 10px;border:1px solid rgba(var(--color-foreground),0.15);border-radius:4px;font:inherit;width:100%;max-width:280px;box-sizing:border-box;}' +
        '.wb-waitlist-modal{position:fixed;inset:0;z-index:2147483010;display:none;align-items:center;justify-content:center;padding:clamp(16px,4vw,28px);box-sizing:border-box;-webkit-tap-highlight-color:transparent;}' +
        '.wb-waitlist-modal.is-open{display:flex;animation:wb-wl-modal-in 0.24s ease-out;}' +
        '@keyframes wb-wl-modal-in{from{opacity:0.88}to{opacity:1}}' +
        '.wb-waitlist-modal-backdrop{position:absolute;inset:0;background:rgba(15,18,28,0.62);cursor:pointer;-webkit-backdrop-filter:blur(12px);backdrop-filter:blur(12px);}' +
        '.wb-waitlist-modal-dialog{position:relative;z-index:1;width:min(100%,560px);max-width:560px;max-height:none;display:flex;flex-direction:column;overflow:hidden;background:var(--color-base-background-1,rgb(var(--color-background)));color:rgb(var(--color-foreground));border-radius:22px;padding:0;box-shadow:0 4px 6px rgba(15,23,42,0.04),0 24px 48px rgba(15,23,42,0.14),0 1px 0 rgba(255,255,255,0.6) inset;box-sizing:border-box;border:1px solid rgba(var(--color-foreground),0.08);}' +
        '.wb-waitlist-modal-dialog--has-photo{max-width:min(100%,720px);width:min(100%,720px);}' +
        '.wb-waitlist-modal-inner{display:flex;flex-direction:column;flex:1 1 auto;min-width:0;width:100%;align-self:stretch;background:inherit;}' +
        '@media (min-width:700px){.wb-waitlist-modal-dialog--has-photo .wb-waitlist-modal-inner{flex-direction:row;align-items:stretch;min-height:0;width:100%;}}' +
        '.wb-waitlist-modal-figure{margin:0;padding:0;flex:0 0 auto;display:block;overflow:hidden;background:rgba(var(--color-foreground),0.06);}' +
        '.wb-waitlist-modal-dialog--has-photo .wb-waitlist-modal-figure{min-height:0;height:auto;align-self:stretch;}' +
        '@media (max-width:699px){.wb-waitlist-modal-dialog--has-photo .wb-waitlist-modal-figure{max-height:min(32vh,200px);flex-shrink:1;}}' +
        '@media (min-width:700px){.wb-waitlist-modal-dialog--has-photo .wb-waitlist-modal-figure{flex:0 0 38%;max-width:320px;min-height:100%;min-width:200px;}}' +
        '.wb-waitlist-modal-photo{display:block;width:100%;height:auto;min-height:0;object-fit:cover;aspect-ratio:16/9;}' +
        '@media (max-width:699px){.wb-waitlist-modal-dialog--has-photo .wb-waitlist-modal-photo{max-height:min(32vh,200px);aspect-ratio:16/9;}}' +
        '@media (min-width:700px){.wb-waitlist-modal-dialog--has-photo .wb-waitlist-modal-photo{min-height:280px;aspect-ratio:auto;height:100%;}}' +
        '.wb-waitlist-modal-body{background:#fdfbf7;color:#1c1917;padding:clamp(1.35rem,3vw,2rem) clamp(1.25rem,3vw,1.85rem) clamp(1.5rem,2.5vw,1.85rem);flex:1 1 auto;min-width:0;display:flex;flex-direction:column;overflow-x:hidden;overflow-y:visible;align-self:stretch;box-sizing:border-box;}' +
        '@media (min-width:700px){.wb-waitlist-modal-dialog--has-photo .wb-waitlist-modal-body{flex:1 1 0%;width:auto;}}' +
        '.wb-waitlist-modal-dialog--has-photo .wb-waitlist-modal-body{padding-top:clamp(1.75rem,3.5vw,2.35rem);}' +
        '.wb-waitlist-modal-x{position:absolute;top:12px;right:12px;z-index:4;width:44px;height:44px;border:0;border-radius:999px;background:rgba(15,23,42,0.08);color:#1e293b;font-size:1.35rem;line-height:1;cursor:pointer;padding:0;display:flex;align-items:center;justify-content:center;transition:background .18s ease,transform .12s ease,box-shadow .18s ease;box-shadow:0 1px 2px rgba(15,23,42,0.06);}' +
        '.wb-waitlist-modal-x:hover{background:rgba(15,23,42,0.12);transform:scale(1.04);}' +
        '.wb-waitlist-modal-x:active{transform:scale(0.96);}' +
        '.wb-waitlist-modal-title{margin:0 2.75rem 1.1rem 0;font-size:clamp(1.2rem,2.6vw,1.45rem);font-weight:700;line-height:1.28;letter-spacing:-0.02em;color:#0f172a;}' +
        '.wb-waitlist-modal-fields{display:flex;flex-direction:column;gap:1rem;margin-bottom:0.25rem;}' +
        '.wb-waitlist-field{display:flex;flex-direction:column;gap:6px;}' +
        '.wb-waitlist-label{font-size:11px;font-weight:700;letter-spacing:0.06em;text-transform:uppercase;color:#475569;margin:0;}' +
        '.wb-waitlist-input{width:100%;box-sizing:border-box;padding:14px 16px;border:1.5px solid rgba(30,41,59,0.18);border-radius:12px;font:inherit;font-size:16px;line-height:1.35;background:#fff;color:#0f172a;box-shadow:0 1px 0 rgba(255,255,255,0.7) inset,0 1px 3px rgba(15,23,42,0.05);transition:border-color .18s ease,box-shadow .18s ease,background .18s ease,transform .1s ease;}' +
        '.wb-waitlist-input::placeholder{color:rgba(var(--color-foreground),0.38);}' +
        '.wb-waitlist-input:hover{border-color:rgba(var(--color-foreground),0.28);background:rgba(255,255,255,0.95);}' +
        '.wb-waitlist-input:focus{outline:none;border-color:rgba(45,41,38,0.32);box-shadow:0 0 0 3px rgba(45,41,38,0.1),0 1px 0 rgba(255,255,255,0.8) inset;}' +
        '.wb-waitlist-input:active{transform:translateY(1px);}' +
        '.wb-waitlist-modal-actions{display:flex;flex-wrap:wrap;gap:10px;align-items:stretch;margin-top:1.1rem;}' +
        '.wb-waitlist-modal .wb-waitlist-btn{position:relative;padding:13px 24px;border-radius:999px;font-weight:600;font-size:15px;min-height:50px;cursor:pointer;border-width:1.5px;border-style:solid;transition:transform .12s ease,box-shadow .2s ease,background .2s ease,border-color .2s ease,color .2s ease,filter .2s ease;}' +
        '.wb-waitlist-modal .wb-waitlist-btn:active:not(:disabled){transform:translateY(2px) scale(0.98);}' +
        '.wb-waitlist-modal .wb-waitlist-btn--primary{border-color:#0A3D4A!important;background:#042B39!important;background-color:#042B39!important;color:#ffffff!important;-webkit-text-fill-color:#ffffff!important;text-shadow:none!important;box-shadow:0 2px 8px rgba(4,43,57,0.18)!important;}' +
        '.wb-waitlist-modal .wb-waitlist-btn--primary:hover:not(:disabled){filter:none!important;background:#00A99E!important;border-color:#00A99E!important;box-shadow:0 4px 14px rgba(0,169,158,0.25)!important;}' +
        '.wb-waitlist-modal .wb-waitlist-btn--primary:active:not(:disabled){box-shadow:0 1px 4px rgba(45,41,38,0.08)!important;}' +
        '.wb-waitlist-modal .wb-waitlist-btn--primary:disabled{opacity:0.55;filter:none;box-shadow:none!important;background:#eceae8!important;border-color:#d1cec9!important;color:#78716c!important;-webkit-text-fill-color:#78716c!important;text-shadow:none!important;}' +
        '.wb-waitlist-modal .wb-waitlist-btn--secondary{background:#F7FAFA;border-color:#C5D9D6;color:#042B39;font-weight:600;box-shadow:none;}' +
        '.wb-waitlist-modal .wb-waitlist-btn--secondary:hover:not(:disabled){background:#EDF5F4;border-color:#b8d9d4;color:#042B39;}' +
        '.wb-waitlist-modal .wb-waitlist-btn--secondary:active:not(:disabled){background:#e8e6e3;}' +
        '.wb-waitlist-msg{margin-top:14px;font-size:15px;line-height:1.5;text-align:left;color:rgba(var(--color-foreground),0.88);padding:12px 14px;border-radius:12px;background:rgba(45,41,38,0.05);border:1px solid rgba(45,41,38,0.1);flex-shrink:0;max-width:100%;box-sizing:border-box;word-wrap:break-word;}' +
        '.wb-waitlist-err{margin-top:12px;color:#b00020;font-size:14px;line-height:1.45;text-align:left;padding:10px 12px;border-radius:10px;background:rgba(176,0,32,0.06);border:1px solid rgba(176,0,32,0.18);flex-shrink:0;max-width:100%;box-sizing:border-box;word-wrap:break-word;}' +
        '.wb-venue-slots-empty-msg{flex:1 1 100%;width:100%;max-width:100%;box-sizing:border-box;margin:12px 0 4px;font-size:14px;line-height:1.5;color:rgba(var(--color-foreground),0.62);text-align:center;padding:14px 12px;border-radius:12px;background:rgba(var(--color-foreground),0.04);border:1px dashed rgba(var(--color-foreground),0.12);}' +
        '.wb-venue-card--waitlist-banner .wb-waitlist-btn.wb-waitlist-btn--card-cta{background:#042B39!important;color:#ffffff!important;border-color:#0A3D4A!important;-webkit-text-fill-color:#ffffff!important;text-shadow:none!important;box-shadow:0 2px 8px rgba(4,43,57,0.15)!important;}' +
        '.wb-waitlist-modal .wb-waitlist-btn{flex:1 1 auto;min-width:min(160px,100%);}';
      document.head.appendChild(st);
    }

    function wbSyncWaitlistModalMedia(bookingHost, modalRoot) {
      if (!bookingHost || !modalRoot) return;
      var dlg = modalRoot.querySelector('.wb-waitlist-modal-dialog');
      var fig = modalRoot.querySelector('[data-wb-waitlist-modal-figure]');
      var img = modalRoot.querySelector('[data-wb-waitlist-modal-img]');
      if (!dlg || !fig || !img) return;
      var url = (bookingHost.getAttribute('data-wb-waitlist-modal-image-url') || '').trim();
      var alt = (bookingHost.getAttribute('data-wb-waitlist-modal-image-alt') || '').trim() || 'Workshop';
      if (url) {
        img.src = url;
        img.alt = alt;
        fig.removeAttribute('hidden');
        dlg.classList.add('wb-waitlist-modal-dialog--has-photo');
      } else {
        img.removeAttribute('src');
        img.alt = '';
        fig.setAttribute('hidden', '');
        dlg.classList.remove('wb-waitlist-modal-dialog--has-photo');
      }
    }

    /** Customer Location string for admin (e.g. "Orewa, New Zealand") from the venue card and its group. */
    function wbFormatWaitlistCustomerLocation(venue, group) {
      if (!venue || typeof venue !== 'object') venue = {};
      var addr = (venue.venue_address || '').toString().trim();
      if (addr && /\bnew zealand\b/i.test(addr)) return addr;
      var glabel = group && (group.city_label || '').toString().trim();
      if (glabel && !/^us-[a-z]{2}-/i.test(glabel)) {
        if (/\bnew zealand\b/i.test(glabel)) return glabel;
        return glabel + ', New Zealand';
      }
      var place = (venue.city_name || venue.city || venue.venue_name || '').toString().trim();
      if (!place) return '';
      if (/\bnew zealand\b/i.test(place)) return place;
      return place + ', New Zealand';
    }

    /** Open waitlist modal for an empty venue (has_events false or no events). Shared by Join Waitlist and card-delegation. */
    function wbOpenWaitlistModalForVenue(bookingHost, venueRefId, venueNameForApi, customerLocation) {
      if (
        bookingHost &&
        bookingHost.classList &&
        (bookingHost.classList.contains('wb-wizard') ||
          (bookingHost.closest && bookingHost.closest('[data-workshop-booking-wizard]')))
      ) {
        try {
          document.dispatchEvent(
            new CustomEvent('wbw:open-waitlist-modal', {
              detail: {
                venueRefId: venueRefId,
                venueName: venueNameForApi,
                customerLocation: customerLocation,
                bookingRoot: bookingHost,
              },
            })
          );
        } catch (_) {}
        return;
      }
      if (typeof window.wbOpenAogenWaitlistPopup === 'function') {
        var cityFromLoc = '';
        if (customerLocation) {
          var locParts = String(customerLocation).split(',');
          if (locParts[0]) cityFromLoc = String(locParts[0]).trim();
        }
        if (
          window.wbOpenAogenWaitlistPopup(
            {
              venue_ref_id: venueRefId,
              venue_name: venueNameForApi,
              city_name: cityFromLoc || venueNameForApi,
            },
            bookingHost
          )
        ) {
          return;
        }
      }
      if (typeof window.wbBuildAogenBookingContext === 'function' && typeof window.wbDispatchAogenBookingContext === 'function') {
        var cityFromLoc2 = '';
        if (customerLocation) {
          var locParts2 = String(customerLocation).split(',');
          if (locParts2[0]) cityFromLoc2 = String(locParts2[0]).trim();
        }
        window.wbDispatchAogenBookingContext(
          window.wbBuildAogenBookingContext(
            {
              venue_ref_id: venueRefId,
              venue_name: venueNameForApi,
              city_name: cityFromLoc2 || venueNameForApi,
            },
            bookingHost,
            { intent: 'popup' }
          )
        );
        return;
      }
      var modal = ensureWaitlistModal(bookingHost);
      if (!modal) return;
      wbSyncWaitlistModalMedia(bookingHost, modal);
      var titleEl = modal.querySelector('[data-wb-waitlist-modal-title]');
      var displayName = (venueNameForApi != null ? String(venueNameForApi) : '').trim() || 'this venue';
      if (titleEl) titleEl.textContent = 'Join the waitlist for ' + displayName;
      modal._wbVenueId = venueRefId != null ? String(venueRefId).trim() : '';
      modal._wbVenueTitle = (venueNameForApi != null ? String(venueNameForApi) : '').trim();
      modal._wbCustomerLocation = (customerLocation != null ? String(customerLocation) : '').trim();
      var firstIn = modal.querySelector('[data-wb-waitlist-modal-first-name]');
      var lastIn = modal.querySelector('[data-wb-waitlist-modal-last-name]');
      var emailIn = modal.querySelector('[data-wb-waitlist-modal-email]');
      var subM = modal.querySelector('[data-wb-waitlist-modal-submit]');
      var errM = modal.querySelector('[data-wb-waitlist-modal-error]');
      var okM = modal.querySelector('[data-wb-waitlist-modal-success]');
      if (firstIn) {
        firstIn.value = '';
        firstIn.style.display = '';
      }
      if (lastIn) {
        lastIn.value = '';
        lastIn.style.display = '';
      }
      if (emailIn) {
        emailIn.value = '';
        emailIn.style.display = '';
      }
      if (subM) subM.style.display = '';
      if (errM) {
        errM.textContent = '';
        errM.hidden = true;
      }
      if (okM) okM.hidden = true;
      modal.removeAttribute('hidden');
      modal.classList.add('is-open');
      try {
        if (firstIn) firstIn.focus();
      } catch (e) {}
    }

    /** One centered waitlist modal per booking root; opened from each empty-venue card. */
    function ensureWaitlistModal(bookingHost) {
      if (!bookingHost) return null;
      if (bookingHost._wbWaitlistModal) return bookingHost._wbWaitlistModal;
      ensureWaitlistStyles();
      var wlId = 'wl';
      try {
        var sid =
          bookingHost.getAttribute('data-wb-section-id') ||
          bookingHost.getAttribute('data-product-id') ||
          'wl';
        wlId = String(sid).replace(/[^a-zA-Z0-9_-]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '').slice(0, 72) || 'wl';
      } catch (e) {
        wlId = 'wl';
      }
      var idFirst = 'wb-waitlist-first-' + wlId;
      var idLast = 'wb-waitlist-last-' + wlId;
      var idEmail = 'wb-waitlist-email-' + wlId;
      var wrap = document.createElement('div');
      wrap.className = 'wb-waitlist-modal';
      wrap.setAttribute('hidden', '');
      wrap.innerHTML =
        '<div class="wb-waitlist-modal-backdrop" data-wb-waitlist-modal-dismiss></div>' +
        '<div class="wb-waitlist-modal-dialog" role="dialog" aria-modal="true" aria-labelledby="wb-wl-modal-title">' +
        '<button type="button" class="wb-waitlist-modal-x" data-wb-waitlist-modal-dismiss aria-label="Close">\u00d7</button>' +
        '<div class="wb-waitlist-modal-inner">' +
        '<figure class="wb-waitlist-modal-figure" data-wb-waitlist-modal-figure hidden>' +
        '<img class="wb-waitlist-modal-photo" data-wb-waitlist-modal-img alt="" width="640" height="480" loading="lazy" decoding="async" />' +
        '</figure>' +
        '<div class="wb-waitlist-modal-body">' +
        '<h3 id="wb-wl-modal-title" class="wb-waitlist-modal-title" data-wb-waitlist-modal-title>Join the waitlist</h3>' +
        '<div class="wb-waitlist-modal-fields">' +
        '<div class="wb-waitlist-field">' +
        '<label class="wb-waitlist-label" for="' +
        idFirst +
        '">First name</label>' +
        '<input id="' +
        idFirst +
        '" class="wb-waitlist-input" type="text" data-wb-waitlist-modal-first-name autocomplete="given-name" placeholder="e.g. Jane" required />' +
        '</div>' +
        '<div class="wb-waitlist-field">' +
        '<label class="wb-waitlist-label" for="' +
        idLast +
        '">Last name</label>' +
        '<input id="' +
        idLast +
        '" class="wb-waitlist-input" type="text" data-wb-waitlist-modal-last-name autocomplete="family-name" placeholder="e.g. Doe" required />' +
        '</div>' +
        '<div class="wb-waitlist-field">' +
        '<label class="wb-waitlist-label" for="' +
        idEmail +
        '">Email</label>' +
        '<input id="' +
        idEmail +
        '" class="wb-waitlist-input" type="email" data-wb-waitlist-modal-email autocomplete="email" placeholder="you@example.com" required />' +
        '</div>' +
        '</div>' +
        '<div class="wb-waitlist-modal-actions">' +
        '<button type="button" class="wb-waitlist-btn wb-waitlist-btn--primary" data-wb-waitlist-modal-submit>Submit</button>' +
        '<button type="button" class="wb-waitlist-btn wb-waitlist-btn--secondary" data-wb-waitlist-modal-dismiss>Cancel</button>' +
        '</div>' +
        '<div class="wb-waitlist-err" data-wb-waitlist-modal-error hidden></div>' +
        '<div class="wb-waitlist-msg" data-wb-waitlist-modal-success hidden>You\'re on the waitlist!</div>' +
        '</div></div></div>';
      document.body.appendChild(wrap);
      bookingHost._wbWaitlistModal = wrap;
      wbSyncWaitlistModalMedia(bookingHost, wrap);

      function closeWaitlistModal() {
        wrap.classList.remove('is-open');
        wrap.setAttribute('hidden', '');
        wrap._wbVenueId = null;
        wrap._wbVenueTitle = '';
        wrap._wbCustomerLocation = '';
        var tReset = wrap.querySelector('[data-wb-waitlist-modal-title]');
        if (tReset) tReset.textContent = 'Join the waitlist';
      }
      wrap.querySelectorAll('[data-wb-waitlist-modal-dismiss]').forEach(function (el) {
        el.addEventListener('click', closeWaitlistModal);
      });
      var firstIn = wrap.querySelector('[data-wb-waitlist-modal-first-name]');
      var lastIn = wrap.querySelector('[data-wb-waitlist-modal-last-name]');
      var emailIn = wrap.querySelector('[data-wb-waitlist-modal-email]');
      var subBtn = wrap.querySelector('[data-wb-waitlist-modal-submit]');
      var errEl = wrap.querySelector('[data-wb-waitlist-modal-error]');
      var okEl = wrap.querySelector('[data-wb-waitlist-modal-success]');
      if (subBtn) {
        subBtn.addEventListener('click', function () {
          var firstV = firstIn ? String(firstIn.value || '').trim() : '';
          var lastV = lastIn ? String(lastIn.value || '').trim() : '';
          var emailV = emailIn ? String(emailIn.value || '').trim() : '';
          var venueIdVal = wrap._wbVenueId;
          var venueTitle = (wrap._wbVenueTitle != null ? String(wrap._wbVenueTitle) : '').trim();
          var locationV = (wrap._wbCustomerLocation != null ? String(wrap._wbCustomerLocation) : '').trim();
          var fullNameV = (firstV && lastV ? firstV + ' ' + lastV : firstV || lastV).trim();
          if (errEl) {
            errEl.textContent = '';
            errEl.hidden = true;
          }
          if (!firstV) {
            if (errEl) {
              errEl.textContent = 'Please enter your first name.';
              errEl.hidden = false;
            }
            return;
          }
          if (!lastV) {
            if (errEl) {
              errEl.textContent = 'Please enter your last name.';
              errEl.hidden = false;
            }
            return;
          }
          if (!emailV || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailV)) {
            if (errEl) {
              errEl.textContent = 'Please enter a valid email.';
              errEl.hidden = false;
            }
            return;
          }
          subBtn.disabled = true;
          var workshopType = '';
          try {
            if (bookingHost && bookingHost.getAttribute) {
              workshopType = bookingHost.getAttribute('data-workshop-type') || '';
            }
            if (!String(workshopType || '').trim()) {
              var _wbTypeEl = document.querySelector('[data-workshop-type]');
              workshopType = _wbTypeEl ? _wbTypeEl.getAttribute('data-workshop-type') || '' : '';
            }
          } catch (e) {
            workshopType = '';
          }
          if (typeof workshopType !== 'string') workshopType = '';
          workshopType = workshopType.trim();
          var cityForAddress = '';
          if (locationV) {
            var _addrParts = locationV.split(',');
            if (_addrParts[0]) cityForAddress = String(_addrParts[0]).trim();
          }
          if (!cityForAddress && venueTitle) cityForAddress = String(venueTitle).trim();
          var shopDomain = window.Shopify?.shop ? String(window.Shopify.shop).trim() : '';
          var myshopifyDomain = '';
          if (/\.myshopify\.com$/i.test(shopDomain)) myshopifyDomain = shopDomain;
          if (!myshopifyDomain) {
            try {
              var pfShopDomain =
                window.__pagefly_setting__ &&
                window.__pagefly_setting__.shopDomain
                  ? String(window.__pagefly_setting__.shopDomain).trim()
                  : '';
              if (/\.myshopify\.com$/i.test(pfShopDomain)) myshopifyDomain = pfShopDomain;
            } catch (_) {}
          }
          var resolvedShopDomain = myshopifyDomain || shopDomain;
          var waitlistPayload = {
            email: emailV,
            first_name: firstV,
            last_name: lastV,
            name: fullNameV,
            location: locationV,
            venue_id: venueIdVal,
            venue_name: venueTitle,
            shop_domain: resolvedShopDomain,
            shop: shopDomain,
            myshopify_domain: myshopifyDomain,
            workshop_type: workshopType
          };
          if (cityForAddress) {
            waitlistPayload.city = cityForAddress;
            waitlistPayload.country = 'New Zealand';
            waitlistPayload.country_code = 'NZ';
            waitlistPayload.default_address = {
              city: cityForAddress,
              country: 'New Zealand',
              country_code: 'NZ',
              address1: cityForAddress + ', New Zealand'
            };
          }
          fetch(__WB_WAITLIST_API_URL__, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(waitlistPayload),
            mode: 'cors'
          })
            .then(function (res) {
              if (res && res.ok) return;
              if (!res) throw new Error('Something went wrong. Please try again.');
              return res.text().then(function (txt) {
                var msg = 'Something went wrong. Please try again.';
                try {
                  var j = JSON.parse(txt);
                  if (j && (j.message || j.error)) msg = String(j.message || j.error).trim() || msg;
                } catch (_) {
                  if (txt && String(txt).trim()) msg = String(txt).trim().slice(0, 280);
                }
                throw new Error(msg);
              });
            })
            .then(function () {
              if (okEl) okEl.hidden = false;
              setTimeout(function () {
                closeWaitlistModal();
                if (okEl) okEl.hidden = true;
                if (firstIn) {
                  firstIn.value = '';
                  firstIn.style.display = '';
                }
                if (lastIn) {
                  lastIn.value = '';
                  lastIn.style.display = '';
                }
                if (emailIn) {
                  emailIn.value = '';
                  emailIn.style.display = '';
                }
                if (subBtn) subBtn.style.display = '';
              }, 2000);
            })
            .catch(function (err) {
              if (errEl) {
                errEl.textContent = err && err.message ? String(err.message) : 'Something went wrong. Please try again.';
                errEl.hidden = false;
              }
            })
            .finally(function () {
              subBtn.disabled = false;
            });
        });
      }
      return wrap;
    }

    function ensureCrossProductBookingContainer(booking) {
      if (!booking) return null;
      var id = 'wb-cross-product-booking';
      var el = booking.querySelector('#' + id);
      if (el) return el;
      var anchor = booking.querySelector('.wb-variant-grid') ||
        booking.querySelector('.wb-variant-list') ||
        booking.querySelector('.wb-variant-options') ||
        booking.querySelector('.workshop-variant-selector') ||
        booking.querySelector('.wb-variant-selector') ||
        (booking.querySelector('.wb-variant-btn') && booking.querySelector('.wb-variant-btn').closest('div'));
      if (!anchor) return null;
      el = document.createElement('div');
      el.id = id;
      el.className = 'wb-cross-product wb-cross-product--booking';
      el.style.display = 'none';
      anchor.insertAdjacentElement('afterend', el);
      return el;
    }

    function findEventById(eventId) {
      var list = window.__WORKSHOP_VENUE_LIST__;
      if (!list || !Array.isArray(list.groups) || !eventId) return null;
      for (var gi = 0; gi < list.groups.length; gi++) {
        var g = list.groups[gi];
        var venues = g && g.venues;
        if (!Array.isArray(venues)) continue;
        for (var vi = 0; vi < venues.length; vi++) {
          var v = venues[vi];
          var evs = v && v.events;
          if (!Array.isArray(evs)) continue;
          for (var ei = 0; ei < evs.length; ei++) {
            var ev = evs[ei];
            if (String(ev.id) === String(eventId) || String(ev.event_metaobject_gid || '') === String(eventId)) return ev;
          }
        }
      }
      return null;
    }

    function renderAlsoAvailableProducts(selectedEvent, bookingRoot) {
      var existing = bookingRoot && bookingRoot.querySelector('[data-wb-also-available]');
      if (!selectedEvent) {
        if (existing) existing.remove();
        return;
      }
      var arr = selectedEvent.also_available_products;
      if (!Array.isArray(arr) || arr.length === 0) {
        if (existing) existing.remove();
        return;
      }
      var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
      var currentHandle = m && m[1] ? m[1].toLowerCase() : '';
      var map = new Map();
      for (var i = 0; i < arr.length; i++) {
        var p = arr[i];
        if (!p || !p.handle) continue;
        var h = p.handle.toLowerCase();
        if (h === currentHandle) continue;
        if (!map.has(h)) map.set(h, p);
      }
      if (map.size === 0) {
        if (existing) existing.remove();
        return;
      }
      var anchor = bookingRoot.querySelector('.wb-variant-cards') || bookingRoot.querySelector('[data-workshop-variant-wrap]');
      if (!anchor) return;
      var keys = Array.from(map.keys()).slice(0, 2);
      var block = bookingRoot.querySelector('[data-wb-also-available]');
      if (!block) {
        block = document.createElement('div');
        block.setAttribute('data-wb-also-available', '');
        block.style.cssText = 'margin-top:10px;display:flex;gap:8px;flex-wrap:wrap';
        anchor.insertAdjacentElement('afterend', block);
      }
      var esc = function (s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; };
      var html = 'Also available as ';
      for (var k = 0; k < keys.length; k++) {
        var prod = map.get(keys[k]);
        html += '<a class="button button--secondary button--small" href="' + esc(prod.url || '') + '">' + esc(prod.title || '') + '</a>';
      }
      block.innerHTML = html;
    }

    function renderCrossProductBooking(booking, eventId) {
      ensureCrossProductStyles();
      var host = ensureCrossProductBookingContainer(booking);
      if (!host) return;
      var currentHandle = ((booking && booking.dataset && booking.dataset.productHandle) || '').toString().trim().toLowerCase();
      var ev = findEventById(eventId);
      var av = (ev && Array.isArray(ev.available_variants)) ? ev.available_variants : [];
      var byHandle = Object.create(null);
      for (var i = 0; i < av.length; i++) {
        var it = av[i] || {};
        var h = (it.product_handle || it.productHandle || '').toString().trim();
        if (!h) continue;
        if (h.toLowerCase() === currentHandle) continue;
        if (byHandle[h.toLowerCase()]) continue;
        byHandle[h.toLowerCase()] = {
          handle: h,
          title: (it.product_title || it.productTitle || it.title || h).toString().trim(),
          url: (it.product_url || it.productUrl || '').toString().trim() || ('/products/' + encodeURIComponent(h)),
          image: (it.product_image || it.productImage || it.image || '').toString().trim() || null
        };
      }
      var keys = Object.keys(byHandle);
      if (!keys.length) {
        host.innerHTML = '';
        host.style.display = 'none';
        return;
      }
      host.style.display = '';
      var html = '<span class="wb-cross-product__label">Other variant options are available for this time slot:</span><div class="wb-cross-product__list">';
      for (var k = 0; k < keys.length; k++) {
        var op = byHandle[keys[k]];
        html += '<a class="wb-cross-product__item" href="' + escapeHtml(op.url) + '" data-product-handle="' + escapeHtml(op.handle) + '">';
        if (op.image) html += '<img class="wb-cross-product__img" src="' + escapeHtml(op.image) + '" alt="" loading="lazy" width="22" height="22">';
        html += '<span>' + escapeHtml(op.title) + '</span></a>';
      }
      html += '</div>';
      host.innerHTML = html;
    }

    /**
     * Build calendar model for one month. date_key format YYYY-MM-DD.
     * @param {number} year
     * @param {number} month 1-12
     * @param {Set<string>} enabledDatesSet set of 'YYYY-MM-DD' that are clickable
     * @returns {{ year: number, month: number, weekDayNames: string[], cells: Array<{ dateKey: string|null, dayNum: number, isEnabled: boolean }> }}
     */
    function wbBuildCalendarModel(year, month, enabledDatesSet) {
      var weekDayNames = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
      var firstDay = (new Date(year, month - 1, 1).getDay() + 6) % 7;
      var daysInMonth = new Date(year, month, 0).getDate();
      var cells = [];
      var i, d, dateKey, pad = function (n) { return (n < 10 ? '0' : '') + n; };
      for (i = 0; i < firstDay; i++) cells.push({ dateKey: null, dayNum: 0, isEnabled: false });
      for (d = 1; d <= daysInMonth; d++) {
        dateKey = year + '-' + pad(month) + '-' + pad(d);
        cells.push({ dateKey: dateKey, dayNum: d, isEnabled: enabledDatesSet && enabledDatesSet.has(dateKey) });
      }
      var remainder = cells.length % 7;
      if (remainder) for (i = 0; i < 7 - remainder; i++) cells.push({ dateKey: null, dayNum: 0, isEnabled: false });
      return { year: year, month: month, weekDayNames: weekDayNames, cells: cells };
    }

    /**
     * Render mini calendar in venue card. Only enabled (event) dates are clickable.
     * Free month navigation (not limited to months already in datesSet); onMonthChange loads more.
     * @param {Element} cardEl .wb-venue-card
     * @param {Set<string>} datesSet set of 'YYYY-MM-DD' for this venue
     * @param {string} currentSelectedDate current select value (YYYY-MM-DD)
     * @param {function(string)} onSelectDate called when user picks a date (we then set select + dispatch)
     * @param {function(number, number)=} onMonthChange optional (year, month1to12) when nav changes month
     */
    function wbRenderVenueDateCalendar(cardEl, datesSet, currentSelectedDate, onSelectDate, onMonthChange) {
      var container = cardEl.querySelector('[data-wb-date-calendar]');
      if (!container) return;
      var dateSelect = cardEl.querySelector('[data-workshop-venue-date]');
      if (!dateSelect) return;

      container.innerHTML = '';
      container.classList.remove('wb-date-calendar--empty');

      var year;
      var month;
      if (currentSelectedDate && /^\d{4}-\d{2}/.test(currentSelectedDate)) {
        year = Number(currentSelectedDate.slice(0, 4));
        month = Number(currentSelectedDate.slice(5, 7));
      } else if (datesSet && datesSet.size > 0) {
        var firstDk = Array.from(datesSet).sort()[0];
        year = Number(firstDk.slice(0, 4));
        month = Number(firstDk.slice(5, 7));
      } else {
        var now = new Date();
        year = now.getFullYear();
        month = now.getMonth() + 1;
      }
      if (!Number.isFinite(year) || !Number.isFinite(month)) {
        var n2 = new Date();
        year = n2.getFullYear();
        month = n2.getMonth() + 1;
      }

      function renderMonth(yr, mo) {
        container.innerHTML = '';
        container.classList.remove('wb-date-calendar--empty');
        if (!datesSet || datesSet.size === 0) {
          container.classList.add('wb-date-calendar--empty');
        }
        var model = wbBuildCalendarModel(yr, mo, datesSet || new Set());
        var header = document.createElement('div');
        header.className = 'wb-cal-header';
        var monthLabel = document.createElement('span');
        monthLabel.className = 'wb-cal-month-label';
        try {
          monthLabel.textContent = new Intl.DateTimeFormat(undefined, { month: 'short', year: 'numeric' }).format(new Date(yr, mo - 1, 1));
        } catch (_) { monthLabel.textContent = yr + '-' + (mo < 10 ? '0' : '') + mo; }
        header.appendChild(monthLabel);
        var nav = document.createElement('div');
        nav.className = 'wb-cal-nav';
        var prevBtn = document.createElement('button');
        prevBtn.type = 'button';
        prevBtn.className = 'wb-cal-nav-prev';
        prevBtn.setAttribute('aria-label', 'Previous month');
        prevBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg>';
        var nextBtn = document.createElement('button');
        nextBtn.type = 'button';
        nextBtn.className = 'wb-cal-nav-next';
        nextBtn.setAttribute('aria-label', 'Next month');
        nextBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>';
        prevBtn.addEventListener('click', function () {
          var prev = wbShiftYm(yr, mo, -1);
          renderMonth(prev.year, prev.month);
          if (typeof onMonthChange === 'function') onMonthChange(prev.year, prev.month);
        });
        nextBtn.addEventListener('click', function () {
          var next = wbShiftYm(yr, mo, 1);
          renderMonth(next.year, next.month);
          if (typeof onMonthChange === 'function') onMonthChange(next.year, next.month);
        });
        nav.appendChild(prevBtn);
        nav.appendChild(nextBtn);
        header.appendChild(nav);
        container.appendChild(header);

        if (!datesSet || datesSet.size === 0) {
          var emptyMsg = document.createElement('p');
          emptyMsg.className = 'wb-date-calendar-empty-msg';
          emptyMsg.textContent =
            cardEl.getAttribute('data-wb-needs-cal-fetch') === '1'
              ? 'Loading dates\u2026'
              : 'No dates available';
          container.appendChild(emptyMsg);
        }

        var weekRow = document.createElement('div');
        weekRow.className = 'wb-cal-weekdays';
        model.weekDayNames.forEach(function (name) {
          var th = document.createElement('span');
          th.className = 'wb-cal-weekday';
          th.textContent = name;
          weekRow.appendChild(th);
        });
        container.appendChild(weekRow);

        var grid = document.createElement('div');
        grid.className = 'wb-cal-grid';
        model.cells.forEach(function (cell) {
          var dayEl = document.createElement('button');
          dayEl.type = 'button';
          dayEl.className = 'wb-cal-day';
          if (cell.dayNum) {
            dayEl.textContent = cell.dayNum;
            dayEl.setAttribute('data-date-key', cell.dateKey || '');
            if (cell.isEnabled) {
              dayEl.classList.add('wb-cal-day--enabled');
              dayEl.setAttribute('aria-label', 'Select ' + (cell.dateKey || ''));
              dayEl.addEventListener('click', function () {
                if (dateSelect.value !== cell.dateKey) {
                  dateSelect.value = cell.dateKey;
                  dateSelect.dispatchEvent(new Event('change', { bubbles: true }));
                }
                onSelectDate(cell.dateKey);
                wbSyncCalendarFromSelect(cardEl);
              });
            } else {
              dayEl.classList.add('wb-cal-day--disabled');
              dayEl.setAttribute('disabled', '');
            }
            if (cell.dateKey === (dateSelect.value || '')) { dayEl.classList.add('wb-cal-day--selected'); dayEl.classList.add('is-selected'); }
          } else {
            dayEl.classList.add('wb-cal-day--empty');
            dayEl.setAttribute('aria-hidden', 'true');
          }
          grid.appendChild(dayEl);
        });
        container.appendChild(grid);
      }

      renderMonth(year, month);
    }

    /**
     * Sync calendar selected state from the venue card's date select value.
     * @param {Element} cardEl .wb-venue-card
     */
    function wbSyncCalendarFromSelect(cardEl) {
      var container = cardEl.querySelector('[data-wb-date-calendar]');
      var dateSelect = cardEl.querySelector('[data-workshop-venue-date]');
      if (!container || !dateSelect) return;
      var val = (dateSelect.value || '').trim();
      container.querySelectorAll('.wb-cal-day--selected, .wb-cal-day.is-selected').forEach(function (el) { el.classList.remove('wb-cal-day--selected', 'is-selected'); });
      if (val) {
        var cell = container.querySelector('.wb-cal-day[data-date-key="' + CSS.escape(val) + '"]');
        if (cell) { cell.classList.add('wb-cal-day--selected'); cell.classList.add('is-selected'); }
      }
    }

    /**
     * Accordion: close all venue groups in the container except the one to keep open (animated).
     * @param {Element} containerEl - Root containing .wb-venue-group elements (e.g. eventsRoot)
     * @param {Element|null} keepGroupSectionEl - The .wb-venue-group to leave expanded, or null to close all
     */
    function wbCloseAllVenueCardsExcept(containerEl, keepGroupSectionEl) {
      if (!containerEl) return;
      var groups = containerEl.querySelectorAll('.wb-venue-group');
      for (var i = 0; i < groups.length; i++) {
        var group = groups[i];
        if (group === keepGroupSectionEl) continue;
        var toggle = group.querySelector('.wb-group-toggle');
        var body = group.querySelector('.wb-group-body');
        if (document.activeElement && group.contains(document.activeElement) && toggle) {
          try { toggle.focus(); } catch (e) {}
        }
        if (body && toggle) wbCollapseBody(body, toggle);
      }
    }

    /**
     * Collapse accordion body with height + opacity transition. Cleans up previous transitionend.
     */
    function wbCollapseBody(bodyEl, toggleEl) {
      if (!bodyEl) return;
      if (bodyEl._wbTransitionEnd) {
        bodyEl.removeEventListener('transitionend', bodyEl._wbTransitionEnd);
        bodyEl._wbTransitionEnd = null;
      }
      var curHeight = bodyEl.style.height;
      if (curHeight === 'auto' || curHeight === '') {
        bodyEl.style.height = bodyEl.scrollHeight + 'px';
        bodyEl.offsetHeight;
      }
      bodyEl.style.height = '0px';
      bodyEl.style.opacity = '0';
      bodyEl.setAttribute('aria-hidden', 'true');
      if (toggleEl) toggleEl.setAttribute('aria-expanded', 'false');
      var handler = function (e) {
        if (e.propertyName !== 'height') return;
        bodyEl.removeEventListener('transitionend', handler);
        bodyEl._wbTransitionEnd = null;
        bodyEl.style.height = '0';
      };
      bodyEl._wbTransitionEnd = handler;
      bodyEl.addEventListener('transitionend', handler);
    }

    /**
     * Expand accordion body with height + opacity transition. On transitionend sets height to auto.
     */
    function wbExpandBody(bodyEl, toggleEl) {
      if (!bodyEl) return;
      if (bodyEl._wbTransitionEnd) {
        bodyEl.removeEventListener('transitionend', bodyEl._wbTransitionEnd);
        bodyEl._wbTransitionEnd = null;
      }
      bodyEl.setAttribute('aria-hidden', 'false');
      if (toggleEl) toggleEl.setAttribute('aria-expanded', 'true');
      bodyEl.style.opacity = '1';
      bodyEl.style.height = bodyEl.scrollHeight + 'px';
      bodyEl.offsetHeight;
      var handler = function (e) {
        if (e.propertyName !== 'height') return;
        bodyEl.removeEventListener('transitionend', handler);
        bodyEl._wbTransitionEnd = null;
        bodyEl.style.height = 'auto';
      };
      bodyEl._wbTransitionEnd = handler;
      bodyEl.addEventListener('transitionend', handler);
    }

    wbRestoreVenueContext = function () {
      if (!eventsRoot) return;
      var targetGroup = null;
      if (__wbLive.lockedVenueGroupKey) {
        try {
          if (typeof CSS !== 'undefined' && CSS.escape) {
            targetGroup = eventsRoot.querySelector('.wb-venue-group[data-workshop-venue-group="' + CSS.escape(__wbLive.lockedVenueGroupKey) + '"]');
          }
        } catch (_) {}
        if (!targetGroup) {
          var allGroups = eventsRoot.querySelectorAll('.wb-venue-group');
          for (var gi = 0; gi < allGroups.length; gi++) {
            if (String(allGroups[gi].getAttribute('data-workshop-venue-group') || '').trim() === __wbLive.lockedVenueGroupKey) {
              targetGroup = allGroups[gi];
              break;
            }
          }
        }
      }
      if (!targetGroup && __wbLive.lockedVenueRefId) {
        var cards = eventsRoot.querySelectorAll('.wb-venue-card');
        for (var ci = 0; ci < cards.length; ci++) {
          if (String(cards[ci].getAttribute('data-venue-ref-id') || '').trim() !== __wbLive.lockedVenueRefId) continue;
          targetGroup = cards[ci].closest ? cards[ci].closest('.wb-venue-group') : null;
          if (targetGroup) break;
        }
      }
      if (!targetGroup) return;
      var header = targetGroup.querySelector('[data-workshop-group-toggle]') || targetGroup.querySelector('.wb-group-toggle');
      var body = targetGroup.querySelector('.wb-group-body');
      if (header && body && header.getAttribute('aria-expanded') !== 'true') {
        wbCloseAllVenueCardsExcept(eventsRoot, targetGroup);
        wbExpandBody(body, header);
      }
    };
    S.wbRestoreVenueContext = wbRestoreVenueContext;

    /**
     * Venue-centric: render location groups (collapsible), venue cards, date dropdown, hour slots.
     * Empty / waitlist venues: same loop over group.venues; venue._wbWaitlistVenue === true → card with Join Waitlist only (no date/slots).
     */
    function renderVenueCentricList(venueList) {
      if (!eventsRoot) return;
      var prevSelectedSlot = eventsRoot.querySelector('.workshop-event-card.is-selected');
      if (prevSelectedSlot) {
        var prevVenueCard = prevSelectedSlot.closest ? prevSelectedSlot.closest('.wb-venue-card') : null;
        if (prevVenueCard) wbLockVenueContextFromCard(prevVenueCard);
      } else {
        var prevOpenHeader = eventsRoot.querySelector('[data-workshop-group-toggle][aria-expanded="true"]');
        if (prevOpenHeader) {
          var prevOpenGroup = prevOpenHeader.closest ? prevOpenHeader.closest('.wb-venue-group') : null;
          if (prevOpenGroup) {
            var prevGroupKey = String(prevOpenGroup.getAttribute('data-workshop-venue-group') || '').trim();
            if (prevGroupKey) __wbLive.lockedVenueGroupKey = prevGroupKey;
            var firstVenueInOpen = prevOpenGroup.querySelector('.wb-venue-card[data-venue-ref-id]');
            if (firstVenueInOpen) {
              var prevRef = String(firstVenueInOpen.getAttribute('data-venue-ref-id') || '').trim();
              if (prevRef) __wbLive.lockedVenueRefId = prevRef;
            }
          }
        }
      }
      ensureCrossProductStyles();
      ensureWaitlistStyles();
      var groups = (venueList && venueList.groups) ? venueList.groups : [];
      if (window.__WB_DEBUG__) console.debug('[WB] render venues start', { count: groups.length, sample: groups[0] ? { city_label: groups[0].city_label, distance_km: groups[0].distance_km, userLoc: window.__wbUserLoc } : null });
      if (eventsPlaceholder) eventsPlaceholder.classList.add('pdp-wb-hidden');
      var wbEmptyVenueSlotsMsg =
        'Unfortunately, no events are scheduled at this venue in the near future.';

      var isWizardFlatVenuePicker =
        booking && booking.classList && booking.classList.contains('wb-wizard');
      if (isWizardFlatVenuePicker) {
        wbEnrichVenueListImagesFromCatalog(venueList, booking);
        var wizVenueLayout = '';
        try {
          wizVenueLayout = booking.getAttribute
            ? String(booking.getAttribute('data-wbw-venue-layout') || '')
                .trim()
                .toLowerCase()
            : '';
        } catch (_) {}
        var wizUseCardGrid = wizVenueLayout !== 'list';
        var showVenueDistance = wbWizardShowVenueDistance(booking);

        var wizardFlatEntries = [];

        for (var gfi = 0; gfi < groups.length; gfi++) {
          var grp = groups[gfi];
          var grpDist = toNum(grp.distance_km);
          var grpLabel = (grp.city_label || '').toString().trim();
          var flatVenues = grp.venues || [];
          for (var vfi = 0; vfi < flatVenues.length; vfi++) {
            var flatVenue = flatVenues[vfi];
            if (!wbWizardVenueAllowedForProduct(flatVenue, booking)) continue;
            var flatTitle = (flatVenue.venue_name || flatVenue.name || flatVenue.city_name || 'Venue')
              .toString()
              .trim();
            var flatHasBookable = wbVenueHasBookableEvents(flatVenue);
            var coralPending =
              flatVenue._coral_hub === true && flatVenue._wbAvailabilityKnown !== true;
            var flatIsWaitlist =
              !coralPending &&
              (flatVenue._wbWaitlistVenue === true || !wbVenueHasScheduledEvents(flatVenue));
            var lineCity =
              grpLabel && !/^us-[a-z]{2}-/i.test(grpLabel) ? grpLabel : flatTitle;
            lineCity = wbWizardVenueLabelWithRegionCode(
              lineCity,
              wbResolveVenueRegionCode(flatVenue, lineCity, booking)
            );
            /* Prefer stable venue id — city labels collapse distinct venues (e.g. Columbus OH/GA). */
            var dedupeKey = String(
              flatVenue.venue_ref_id || flatVenue.id || lineCity || flatTitle || flatVenue.venue_name || ''
            )
              .trim()
              .toLowerCase();
            wizardFlatEntries.push({
              venue: flatVenue,
              flatTitle: flatTitle,
              flatHasBookable: flatHasBookable,
              flatIsWaitlist: flatIsWaitlist,
              lineCity: lineCity,
              dedupeKey: dedupeKey,
              grpDist: grpDist,
              distText:
                showVenueDistance && grpDist != null && Number.isFinite(grpDist)
                  ? ' - ' + Number(grpDist).toFixed(1) + ' KM AWAY'
                  : '',
              kmLine:
                showVenueDistance && grpDist != null && Number.isFinite(grpDist)
                  ? Number(grpDist).toFixed(1) + ' km'
                  : '',
            });
          }
        }

        wizardFlatEntries = wbSortWizardFlatVenueEntries(
          wbDedupeWizardFlatVenueEntries(wizardFlatEntries)
        );

        function makeWizardPickCard(entry) {
          var flatVenue = entry.venue;
          var flatIsWaitlist = entry.flatIsWaitlist;
          var lineCity = entry.lineCity;
          var kmLine = entry.kmLine;
          var distText = entry.distText;
          var pick;
          if (wizUseCardGrid && flatIsWaitlist) {
            pick = document.createElement('div');
            pick.setAttribute('role', 'button');
            pick.setAttribute('tabindex', '0');
          } else {
            pick = document.createElement('button');
            pick.type = 'button';
          }
          pick.className =
            'wb-venue-pick-card wb-venue-card' +
            (flatIsWaitlist ? ' wb-venue-pick-card--waitlist' : ' wb-venue-pick-card--sessions') +
            (wizUseCardGrid ? ' wbw-venue-pick-card--card' : '') +
            (wizUseCardGrid && flatIsWaitlist ? ' wbw-venue-flip-card' : '');
          pick.setAttribute('data-venue-ref-id', flatVenue.venue_ref_id || '');
          pick.setAttribute('data-wbw-city-label', lineCity);
          pick.setAttribute('aria-pressed', 'false');
          if (flatIsWaitlist) pick.setAttribute('data-wb-waitlist-venue', '1');
          if (wizUseCardGrid) {
            var imgUrl = wbResolveVenueCardImage(flatVenue, lineCity, booking);
            pick.innerHTML = wbWizardVenueGridCardInnerHtml(lineCity, kmLine, imgUrl, flatIsWaitlist);
          } else {
            pick.innerHTML =
              '<span class="wb-venue-pick-card__line">' +
              escapeHtml(lineCity) +
              escapeHtml(distText) +
              '</span>';
          }
          pick._wbVenue = flatVenue;
          var pickVenueHandle = String(
            flatVenue.venue_handle ||
              flatVenue.handle ||
              (flatVenue.events &&
                flatVenue.events[0] &&
                flatVenue.events[0].venue_handle) ||
              ''
          ).trim();
          if (pickVenueHandle && !/^\d+$/.test(pickVenueHandle)) {
            pick.setAttribute('data-venue-handle', pickVenueHandle);
          }
          return pick;
        }

        /*
         * Coral hub always full-rebuilds below (no incremental append).
         * Keep skeleton until the first non-empty sorted list arrives.
         */
        if (!wizardFlatEntries.length && eventsRoot.querySelector('[data-wb-coral-skeleton]')) {
          return { groupCards: 0, venueCards: 0, slotButtons: 0 };
        }

        eventsRoot.innerHTML = '';
        var fragment = document.createDocumentFragment();
        var flatList = document.createElement('div');
        flatList.className =
          'wbw-venue-flat-list' +
          (wizUseCardGrid ? ' wbw-venue-flat-list--grid' : ' wbw-venue-flat-list--text');
        flatList.setAttribute('data-wbw-venue-flat-list', wizUseCardGrid ? 'grid' : 'list');

        for (var wfi = 0; wfi < wizardFlatEntries.length; wfi++) {
          flatList.appendChild(makeWizardPickCard(wizardFlatEntries[wfi]));
        }

        var flatVenueCount = wizardFlatEntries.length;
        if (flatVenueCount > 0) {
          flatList.setAttribute('data-wbw-venue-count', String(flatVenueCount));
        } else {
          flatList.removeAttribute('data-wbw-venue-count');
        }

        fragment.appendChild(flatList);
        eventsRoot.appendChild(fragment);
        wbBindVenueCardImages(flatList, booking);
        wbRestoreVenueContext();

        if (groups.length === 0 && eventsPlaceholder) {
          wbwDispatchVenueReset();
          eventsPlaceholder.classList.remove('pdp-wb-hidden');
          eventsPlaceholder.textContent =
            'No venues found for this location. Try another location.';
        }

        try {
          wbRefreshBookingGuideUi();
        } catch (_) {}

        var flatCards = eventsRoot.querySelectorAll('.wb-venue-pick-card');
        try {
          document.dispatchEvent(new CustomEvent('wbw:venue-list-rendered'));
        } catch (_) {}
        return {
          groupCards: groups.length,
          venueCards: flatCards.length,
          slotButtons: 0,
        };
      }

      function buildHourSlotsForDate(venueCard, venue, selectedDateKey, timesContainer) {
        if (window.WB_DEBUG_FETCH) console.log('[WB_SLOTS] container', {
          exists: !!timesContainer,
          className: timesContainer && timesContainer.className,
          parentEl: timesContainer && timesContainer.parentElement && timesContainer.parentElement.className,
          childCountBefore: timesContainer && timesContainer.children && timesContainer.children.length
        });
        timesContainer.innerHTML = '';
        var vEventsAll = Array.isArray(venue.events) ? venue.events : [];
        var eventsOnDate = vEventsAll.filter(function (ev) { return (ev.date_key || '') === selectedDateKey; });
        function wbSlotSortKey(ev) {
          try {
            var t = (ev && ev.time_label != null) ? String(ev.time_label).trim() : '';
            if (!t && ev && ev.starts_at) t = String(extractTimeFromStartsAt(ev.starts_at) || '').trim();
            var m = t.match(/(\d{1,2}):(\d{2})\s*(AM|PM)?/i);
            if (!m) return Number.MAX_SAFE_INTEGER;
            var hh = Number(m[1]);
            var mm = Number(m[2]);
            var mer = (m[3] || '').toUpperCase();
            if (mer) {
              if (mer === 'AM' && hh === 12) hh = 0;
              if (mer === 'PM' && hh < 12) hh += 12;
            }
            return (hh * 60) + mm;
          } catch (_) {
            return Number.MAX_SAFE_INTEGER;
          }
        }
        eventsOnDate.sort(function (a, b) { return wbSlotSortKey(a) - wbSlotSortKey(b); });
        if (window.WB_DEBUG_FETCH) console.log('[WB_SLOTS] eventsOnDate', {
          dateKey: selectedDateKey,
          count: eventsOnDate.length,
          sample: eventsOnDate.slice(0, 3).map(function (e) { return { id: e.id, time: e.time_label, status: e.status }; })
        });
        for (var i = 0; i < eventsOnDate.length; i++) {
          var ev = eventsOnDate[i];
          if (wbShouldHideEvent(ev)) continue;
          var timeLabel = (ev.time_label != null && ev.time_label !== '') ? String(ev.time_label).trim() : '';
          if (!timeLabel && ev.starts_at) {
            try {
              var raw = extractTimeFromStartsAt(ev.starts_at);
              if (raw) timeLabel = time24hTo12h(raw);
            } catch (_) {}
          }
          if (!timeLabel) timeLabel = '—';
          var cap = ev.capacity_remaining;
          var status = wbResolveEventStatus(ev);
          var isSoldOut = wbIsEventSoldOut({ status: status, capacity_remaining: cap });
          var hasVariant = ev.variant_id != null && ev.variant_id !== '';
          var notBookable = !hasVariant && (!ev.available_variants || ev.available_variants.length === 0);
          var title = (ev.event_name || ev.venue_name || '(Event)').trim();
          var dateLabel = formatDateLabelVenueCentric(selectedDateKey);
          var variantIdNumeric = hasVariant ? parseVariantIdFromGid(ev.variant_id) : null;
          var variantIdRaw = hasVariant ? String(ev.variant_id).trim() : '';

          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'workshop-event-card wb-time-slot' + (isSoldOut ? ' wb-time-slot--sold' : '');
          btn.setAttribute('data-event-id', String(ev.id || ''));
          btn.setAttribute('data-workshop-event-id', String(ev.id || ''));
          btn.setAttribute('data-event-metaobject-gid', String(ev.event_metaobject_gid || ev.id || ''));
          btn.setAttribute('data-workshop-event-card', '1');
          btn.setAttribute('data-event-handle', String(ev.handle || ''));
          btn.setAttribute('data-variant-id', variantIdNumeric ? String(variantIdNumeric) : (hasVariant ? variantIdRaw : 'none'));
          if (variantIdRaw && /^gid:\/\/shopify\/ProductVariant\/\d+$/i.test(variantIdRaw)) btn.setAttribute('data-variant-gid', variantIdRaw);
          if (notBookable) btn.setAttribute('data-not-bookable', '1');
          btn.setAttribute('data-state', String(ev.state || ''));
          btn.setAttribute('data-city', String(ev.city || ''));
          btn.setAttribute('data-city-key', String(ev.city_key || ''));
          btn.setAttribute('data-status', isSoldOut ? 'sold_out' : status);
          btn.setAttribute('data-event-name', title);
          btn.setAttribute('data-venue-name', String(ev.venue_name || ''));
          btn.setAttribute('data-venue-handle', String(ev.venue_handle || ''));
          btn.setAttribute('data-venue-address', String(ev.venue_address || ''));
          btn.setAttribute('data-venue-phone', String(ev.venue_phone || ''));
          btn.setAttribute('data-venue-work-hours', String(ev.venue_work_hours || ''));
          btn.setAttribute('data-date-key', selectedDateKey);
          btn.setAttribute('data-date-label', dateLabel);
          btn.setAttribute('data-time-label', timeLabel);
          btn.setAttribute('data-capacity-remaining', cap != null ? String(cap) : '');
          btn.setAttribute('data-capacity-total', (ev.capacity_total != null && ev.capacity_total !== '') ? String(ev.capacity_total) : '');
          btn.setAttribute('data-starts-at', '0');
          btn._wbEv = ev;
          btn.setAttribute('data-product-handle', String(ev.product_handle || ''));
          btn.setAttribute('data-link-enabled', ev.link_enabled !== false && !!(ev.product_handle || '').toString().trim() ? '1' : '0');
          var capLabel = '';
          if (typeof cap === 'number' && cap > 0 && cap <= 5) capLabel = ' · ' + cap + ' left';
          btn.innerHTML = '<span class="wb-slot-time">' + escapeHtml(timeLabel) + '</span>';
          if (isSoldOut) {
            btn.innerHTML += '<span class="wb-slot-sold-badge">Sold out</span>';
          } else if (capLabel) {
            btn.innerHTML += '<span class="wb-slot-cap">' + escapeHtml(capLabel) + '</span>';
          }
          if (notBookable) {
            btn.innerHTML += '<span class="wb-slot-cap">Not bookable</span>';
          }
          timesContainer.appendChild(btn);
        }
        if (eventsOnDate.length === 0 && vEventsAll.length > 0) {
          var emptyP = document.createElement('p');
          emptyP.className = 'wb-venue-slots-empty-msg';
          emptyP.setAttribute('role', 'status');
          emptyP.textContent = wbEmptyVenueSlotsMsg;
          timesContainer.appendChild(emptyP);
        }
        if (window.WB_DEBUG_FETCH) console.log('[WB_SLOTS] appended', {
          childCountAfter: timesContainer.children.length,
          containerInDOM: !!timesContainer.closest('.wb-venue-card'),
          containerVisible: timesContainer.offsetHeight > 0
        });
      }

      eventsRoot.innerHTML = '';
      var fragment = document.createDocumentFragment();

      for (var gi = 0; gi < groups.length; gi++) {
        var group = groups[gi];
        if (window.__WB_DEBUG__) {
          var firstVenue = (group.venues && group.venues[0]) || {};
          console.debug('[WB] group', { label: group.city_label, group_key: group.group_key, city_key: group.city_key, vlat: firstVenue.venue_lat, vlng: firstVenue.venue_lng, userLoc: window.__wbUserLoc, distKm: group.distance_km });
        }
        var groupSection = document.createElement('div');
        groupSection.className = 'wb-venue-group';
        groupSection.setAttribute('data-workshop-venue-group', group.group_key || group.city_key || '');

        var distKm = toNum(group.distance_km);
        var rawLabel = (group.city_label || '').toString().trim();
        var displayLabel = (rawLabel && !/^us-[a-z]{2}-/i.test(rawLabel)) ? rawLabel : '';
        var hasDistance = (distKm != null && Number.isFinite(distKm));
        var distText = hasDistance ? (' \u2014 ' + Number(distKm).toFixed(1) + ' km away') : '';
        var distClass = hasDistance ? 'wb-venue-distance' : 'wb-venue-distance is-hidden';

        var groupHeader = document.createElement('button');
        groupHeader.type = 'button';
        groupHeader.className = 'wb-group-toggle';
        groupHeader.setAttribute('data-workshop-group-toggle', '1');
        groupHeader.setAttribute('aria-expanded', 'false');
        groupHeader.innerHTML =
          '<span class="wb-group-label-wrap">' +
            '<span class="wb-group-label">' + escapeHtml(displayLabel) + '</span>' +
            '<span class="' + distClass + '" data-wb-venue-distance>' + escapeHtml(distText) + '</span>' +
          '</span>' +
          '<svg class="wb-group-chevron" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/></svg>';
        groupSection.appendChild(groupHeader);

        if (window.__WB_DEBUG__) {
          console.debug('[WB] distance check', {
            label: displayLabel,
            distKm: distKm,
            hasDistance: hasDistance,
            userLoc: window.__wbUserLoc,
            group_distance_km: group.distance_km
          });
        }

        var groupBody = document.createElement('div');
        groupBody.className = 'wb-group-body';
        groupBody.setAttribute('aria-hidden', 'true');
        groupBody.style.height = '0px';
        groupBody.style.opacity = '0';
        groupSection.appendChild(groupBody);

        for (var vi = 0; vi < group.venues.length; vi++) {
          (function (venue, venueGroup) {
            var venueCard = document.createElement('div');
            venueCard.className = 'workshop-venue-card wb-venue-card';
            venueCard.setAttribute('data-venue-ref-id', venue.venue_ref_id || '');

            var venueTitle = (venue.venue_name || venue.name || venue.city_name || 'Venue').toString().trim();
            var phoneEsc = venue.venue_phone ? escapeHtml(venue.venue_phone).replace(/"/g, '&quot;') : '';
            var tagsHtml = '';
            if (Array.isArray(venue.venue_tags) && venue.venue_tags.length > 0) {
              tagsHtml = '<div class="wb-venue-tags">' + venue.venue_tags.map(function (t) { return '<span class="wb-venue-tag">' + escapeHtml(String(t)) + '</span>'; }).join('') + '</div>';
            }
            var isWaitlistOnly = venue._wbWaitlistVenue === true;
            if (isWaitlistOnly) venueCard.setAttribute('data-wb-waitlist-venue', '1');
            else venueCard.removeAttribute('data-wb-waitlist-venue');

            var vEventsForVenue = Array.isArray(venue.events) ? venue.events : [];
            var hasScheduled = wbVenueHasScheduledEvents(venue);
            var hasAnyVenueEvents = vEventsForVenue.length > 0 || (hasScheduled && !isWaitlistOnly);
            var needsCalendarFetch = !isWaitlistOnly && hasScheduled && vEventsForVenue.length === 0;

            var venueHeadlineHtml;
            var useWaitlistBanner = isWaitlistOnly && !hasAnyVenueEvents;
            if (isWaitlistOnly) {
              if (useWaitlistBanner) {
                venueHeadlineHtml = '';
              } else {
                venueHeadlineHtml = '<h4 class="wb-venue-name">' + escapeHtml(venueTitle) + '</h4>';
              }
            } else if (!hasAnyVenueEvents) {
              venueHeadlineHtml =
                '<p class="wb-venue-no-events-banner wb-venue-no-events-banner--solo" role="status">' +
                escapeHtml(wbEmptyVenueSlotsMsg) +
                '</p>';
            } else {
              venueHeadlineHtml = '<h4 class="wb-venue-name">' + escapeHtml(venueTitle) + '</h4>';
            }

            var venueAddressInlineHtml = venue.venue_address
              ? '<span class="wb-venue-addr-inline">' + escapeHtml(venue.venue_address) + '</span>'
              : '';
            var venueSummaryRowHtml =
              '<div class="wb-venue-summary-row">' +
                venueAddressInlineHtml +
              '</div>';

            var leftColHtml =
              '<div class="wb-venue-left">' +
                (hasAnyVenueEvents && !isWaitlistOnly ? venueSummaryRowHtml : venueHeadlineHtml) +
                (hasAnyVenueEvents && !isWaitlistOnly ? '' :
                  '<div class="wb-venue-details">' +
                    (venue.venue_address ? '<div class="wb-venue-field"><div class="wb-venue-label">Address</div><div class="wb-venue-value wb-venue-addr">' + escapeHtml(venue.venue_address) + '</div></div>' : '') +
                    (venue.venue_phone ? '<div class="wb-venue-field"><div class="wb-venue-label">Phone</div><div class="wb-venue-value wb-venue-phone">' + '<a class="wb-venue-phone-link" href="tel:' + phoneEsc + '">' + escapeHtml(venue.venue_phone) + '</a></div></div>' : '') +
                    (venue.venue_work_hours ? '<div class="wb-venue-field"><div class="wb-venue-label">Work Hours</div><div class="wb-venue-value wb-venue-work-hours">' + escapeHtml(venue.venue_work_hours) + '</div></div>' : '') +
                    tagsHtml +
                  '</div>' +
                  '<div class="wb-venue-meta" data-wb-venue-meta></div>'
                ) +
              '</div>';

            var waitlistCtaHtml = isWaitlistOnly
              ? '<div class="wb-venue-right">' +
                  '<div class="wb-waitlist-actions">' +
                    '<button type="button" class="wb-waitlist-btn wb-waitlist-btn--card-cta" data-wb-waitlist-open aria-haspopup="dialog">Sign up for waitlist \u2192</button>' +
                  '</div>' +
                '</div>'
              : '';

            var calendarHtml =
              '<div class="wb-venue-date-wrap">' +
                '<div class="wb-date-calendar" data-wb-date-calendar data-wst-anchor="date"></div>' +
                '<select class="wb-venue-date-select wb-venue-date-select-fallback" data-workshop-venue-date="1" aria-label="Select date"></select>' +
              '</div>';

            var timeSlotsHtml =
              '<div class="wb-venue-slots" data-workshop-venue-times data-wst-anchor="time"></div>';

            var venueCardBodyHtml =
              '<div class="wb-venue-card-body">' +
                venueSummaryRowHtml +
                calendarHtml +
                timeSlotsHtml +
              '</div>';

            if (useWaitlistBanner) {
              venueCard.innerHTML =
                '<p class="wb-venue-no-events-banner" role="status">' +
                escapeHtml(wbEmptyVenueSlotsMsg) +
                '</p>' +
                '<div class="wb-venue-waitlist-footer">' +
                leftColHtml +
                waitlistCtaHtml +
                '</div>';
              venueCard.classList.add('wb-venue-card--waitlist-banner');
            } else if (hasAnyVenueEvents && !isWaitlistOnly) {
              venueCard.innerHTML =
                venueCardBodyHtml;
            } else {
              venueCard.innerHTML =
                leftColHtml + (isWaitlistOnly ? waitlistCtaHtml : '');
            }
            if (!hasAnyVenueEvents && !isWaitlistOnly) {
              venueCard.setAttribute('data-wb-no-scheduled-events', '1');
            }

            if (!isWaitlistOnly && hasAnyVenueEvents) {
              if (window.WB_DEBUG_FETCH) console.log('[WB_VENUE_DOM]', {
                hasDate: !!venueCard.querySelector('[data-workshop-venue-date]'),
                hasSlots: !!venueCard.querySelector('[data-workshop-venue-times]')
              });

              var dateSelect = venueCard.querySelector('[data-workshop-venue-date]');
              var timesContainer = venueCard.querySelector('[data-workshop-venue-times]');

              function wbCollectVenueDateKeys() {
                var keys = [];
                var seenDk = {};
                var evsNow = Array.isArray(venue.events) ? venue.events : [];
                evsNow.forEach(function (ev) {
                  var dk = (ev.date_key || '').toString().trim();
                  if (dk && !seenDk[dk]) { seenDk[dk] = true; keys.push(dk); }
                });
                keys.sort();
                return keys;
              }

              function wbRebuildVenueDateSelect(preferKey) {
                var keys = wbCollectVenueDateKeys();
                dateSelect.innerHTML = '';
                keys.forEach(function (dk) {
                  var opt = document.createElement('option');
                  opt.value = dk;
                  opt.textContent = formatDateLabelVenueCentric(dk);
                  dateSelect.appendChild(opt);
                });
                if (keys.length === 0) {
                  dateSelect.setAttribute('disabled', '');
                  return '';
                }
                dateSelect.removeAttribute('disabled');
                var sel = preferKey && keys.indexOf(preferKey) >= 0 ? preferKey : keys[0];
                dateSelect.value = sel;
                return sel;
              }

              var selectedDateKey = wbRebuildVenueDateSelect('');
              buildHourSlotsForDate(venueCard, venue, selectedDateKey, timesContainer);
              function wbTrackerVenueNameFromDom() {
                var name = '';
                var groupEl = venueCard.closest ? venueCard.closest('.wb-venue-group') : null;
                var groupHeader = groupEl ? (groupEl.querySelector('[data-workshop-group-toggle]') || groupEl.querySelector('.wb-group-toggle')) : null;
                if (groupHeader && groupHeader.getAttribute('aria-expanded') === 'true') {
                  var groupLabel = groupHeader.querySelector('.wb-group-label');
                  name = groupLabel ? String(groupLabel.textContent || '').trim() : '';
                }
                if (!name) {
                  var venueNameEl = venueCard.querySelector('.wb-venue-name');
                  name = venueNameEl ? String(venueNameEl.textContent || '').trim() : '';
                }
                if (!name) name = String(venueTitle || '').trim();
                return name;
              }

              dateSelect.addEventListener('change', function () {
                wbLockVenueContextFromCard(venueCard);
                venueCard.setAttribute('data-wb-date-touched', '1');
                var newDateKey = dateSelect.value || '';
                if (!newDateKey) return;
                var trackerVenueName = wbTrackerVenueNameFromDom();
                wbSyncCalendarFromSelect(venueCard);
                var sel = window.__WORKSHOP_SELECTION__;
                var selId = sel && (sel.eventId != null && sel.eventId !== '') ? String(sel.eventId) : '';
                var hasSelectedSlot = venueCard.querySelector('.workshop-event-card.is-selected') != null;
                var hasMatchingEventId = selId && venueCard.querySelector('.workshop-event-card[data-event-id="' + CSS.escape(selId) + '"]');
                var hadSelectionInThisCard = hasSelectedSlot || !!hasMatchingEventId;
                buildHourSlotsForDate(venueCard, venue, newDateKey, timesContainer);
                if (hadSelectionInThisCard) {
                  clearEventSelection();
                  wstUpdate(
                    3,
                    wstValues(trackerVenueName, wstFormatDateKey(newDateKey), '', '', '')
                  );
                }
                wbRestoreVenueContext();
                syncInCardSummaryForVenueCard(venueCard);
                try {
                  wbRefreshBookingGuideUi();
                } catch (e) {}
              });

              function wbRefreshVenueCardCalendar(preferKey) {
                var keys = wbCollectVenueDateKeys();
                var sel = wbRebuildVenueDateSelect(preferKey || dateSelect.value || '');
                wbRenderVenueDateCalendar(
                  venueCard,
                  new Set(keys),
                  sel,
                  function (pickedDateKey) {
                    var trackerVenueName = wbTrackerVenueNameFromDom();
                    wstUpdate(
                      3,
                      wstValues(trackerVenueName, wstFormatDateKey(pickedDateKey || ''), '', '', '')
                    );
                  },
                  function (yr, mo) {
                    var seq = ++venueCard._wbCalNavSeq;
                    ensureVenueCalendarMonths(venue, yr, mo, { lookahead: 1, prefetch: true })
                      .then(function () {
                        if (seq !== venueCard._wbCalNavSeq) return;
                        var keysNow = wbCollectVenueDateKeys();
                        var ym = wbYmKey(yr, mo);
                        var prefer = dateSelect.value || '';
                        if (!prefer || prefer.slice(0, 7) !== ym) {
                          var inMonth = keysNow.filter(function (k) { return k.slice(0, 7) === ym; });
                          prefer = inMonth[0] || (ym + '-01');
                        }
                        wbRefreshVenueCardCalendar(prefer);
                        if (dateSelect.value && keysNow.indexOf(dateSelect.value) >= 0) {
                          buildHourSlotsForDate(venueCard, venue, dateSelect.value, timesContainer);
                        }
                      })
                      .catch(function (err) {
                        if (err && err.name === 'AbortError') return;
                        if (seq !== venueCard._wbCalNavSeq) return;
                        if (DEV_MODE) console.warn('[WB_VENUE_CAL] month load failed', err);
                        var cal = venueCard.querySelector('[data-wb-date-calendar]');
                        if (cal) {
                          cal.classList.add('wb-date-calendar--empty');
                          cal.innerHTML = '<p class="wb-date-calendar-empty-msg">Couldn\'t load dates. Try again.</p>';
                        }
                      });
                  }
                );
              }

              venueCard._wbCalNavSeq = 0;
              venueCard.__wbRefreshCal = function () {
                wbRefreshVenueCardCalendar(dateSelect.value || '');
                if (dateSelect.value) {
                  buildHourSlotsForDate(venueCard, venue, dateSelect.value, timesContainer);
                }
              };
              venueCard.__wbLoadCalIfNeeded = function () {
                if (venueCard.getAttribute('data-wb-needs-cal-fetch') !== '1') return Promise.resolve();
                var nowCal = new Date();
                var seq = ++venueCard._wbCalNavSeq;
                var cal = venueCard.querySelector('[data-wb-date-calendar]');
                if (cal) {
                  var emptyMsg = cal.querySelector('.wb-date-calendar-empty-msg');
                  if (emptyMsg) emptyMsg.textContent = 'Loading dates\u2026';
                }
                return ensureVenueCalendarMonths(venue, nowCal.getFullYear(), nowCal.getMonth() + 1, {
                  lookahead: 1,
                  prefetch: true
                })
                  .then(function () {
                    if (seq !== venueCard._wbCalNavSeq) return;
                    venueCard.setAttribute('data-wb-needs-cal-fetch', '0');
                    venueCard.__wbRefreshCal();
                  })
                  .catch(function (err) {
                    if (err && err.name === 'AbortError') return;
                    if (seq !== venueCard._wbCalNavSeq) return;
                    if (DEV_MODE) console.warn('[WB_VENUE_CAL] initial load failed', err);
                    var calEl = venueCard.querySelector('[data-wb-date-calendar]');
                    if (calEl) {
                      calEl.classList.add('wb-date-calendar--empty');
                      calEl.innerHTML = '<p class="wb-date-calendar-empty-msg">Couldn\'t load dates. Try again.</p>';
                    }
                  });
              };

              if (needsCalendarFetch) venueCard.setAttribute('data-wb-needs-cal-fetch', '1');
              wbRefreshVenueCardCalendar(selectedDateKey);

              // No auto-select: user must click an hour slot to set selection.
              // Add to Cart stays disabled until user explicitly clicks a time slot.
            } else {
              var openBtn = venueCard.querySelector('[data-wb-waitlist-open]');
              var venueRefId = (venue.venue_ref_id != null && String(venue.venue_ref_id).trim() !== '') ? String(venue.venue_ref_id).trim() : '';
              if (openBtn) {
                openBtn.addEventListener('click', function (ev) {
                  if (ev && ev.stopPropagation) ev.stopPropagation();
                  wbOpenWaitlistModalForVenue(
                    booking,
                    venueRefId,
                    (venue.venue_name != null ? String(venue.venue_name) : '').trim(),
                    wbFormatWaitlistCustomerLocation(venue, venueGroup)
                  );
                });
              }
            }

            venueCard._wbVenue = venue;

            groupBody.appendChild(venueCard);
          })(group.venues[vi], group);
        }

        // IIFE to capture groupHeader/groupBody/groupSection per iteration (closure fix). Accordion: only one group open at a time; animated open/close.
        (function (gHeader, gBody, gSection) {
          gHeader.addEventListener('click', function () {
            var expanded = gHeader.getAttribute('aria-expanded') === 'true';
            if (expanded) {
              if (document.activeElement && gSection.contains(document.activeElement)) {
                try { gHeader.focus(); } catch (e) {}
              }
              wbCollapseBody(gBody, gHeader);
              var anyOpen = eventsRoot && eventsRoot.querySelector('[data-workshop-group-toggle][aria-expanded="true"]');
              if (!anyOpen) {
                __wbLive.lockedVenueRefId = '';
                __wbLive.lockedVenueGroupKey = '';
                wstUpdate(1, {});
              }
            } else {
              wbCloseAllVenueCardsExcept(eventsRoot, gSection);
              var resetCards = gBody.querySelectorAll('.wb-venue-card');
              for (var ri = 0; ri < resetCards.length; ri++) {
                resetCards[ri].removeAttribute('data-wb-date-touched');
              }
              wbExpandBody(gBody, gHeader);
              var pendingCal = gBody.querySelectorAll('.wb-venue-card[data-wb-needs-cal-fetch="1"]');
              for (var pci = 0; pci < pendingCal.length; pci++) {
                if (typeof pendingCal[pci].__wbLoadCalIfNeeded === 'function') {
                  pendingCal[pci].__wbLoadCalIfNeeded();
                }
              }
              var venueNameOnOpen = '';
              var venueLabelEl = gHeader.querySelector('.wb-group-label');
              if (venueLabelEl) venueNameOnOpen = String(venueLabelEl.textContent || '').trim();
              wstUpdate(2, wstValues(venueNameOnOpen, '', '', '', ''));
            }
            try {
              wbRefreshBookingGuideUi();
            } catch (e) {}
          });
        })(groupHeader, groupBody, groupSection);

        fragment.appendChild(groupSection);
      }

      eventsRoot.appendChild(fragment);
      wbRestoreVenueContext();

      if (groups.length === 0 && eventsPlaceholder) {
        eventsPlaceholder.classList.remove('pdp-wb-hidden');
        eventsPlaceholder.textContent = 'No events found for this location. Try another location or date range.';
      }

      var venueCardsAll = eventsRoot.querySelectorAll('.workshop-venue-card');
      for (var j = 0; j < venueCardsAll.length; j++) syncInCardSummaryForVenueCard(venueCardsAll[j]);
      var slotButtons = eventsRoot.querySelectorAll('.workshop-event-card[data-workshop-event-card]').length;
      try {
        wbRefreshBookingGuideUi();
      } catch (e) {}
      return { groupCards: groups.length, venueCards: venueCardsAll.length, slotButtons: slotButtons };
    }

    /**
     * After event list renders: find the event matching URL event_id and select it.
     * Two-pass: DOM search first, then venue data search for non-first dates.
     */
    function trySelectEventFromUrl() {
      var urlEventId = getEventIdFromUrl();
      if (window.__WB_DIAG__) console.log('[WB_RESTORE] trySelectEventFromUrl called, event_id:', urlEventId);
      if (!urlEventId || !eventsRoot) {
        if (window.__WB_DIAG__) console.log('[WB_RESTORE] abort — no event_id or no eventsRoot');
        return;
      }
      var urlNumeric = extractNumericEventIdForUrl(urlEventId) || urlEventId;
      if (window.__WB_DIAG__) console.log('[WB_RESTORE] normalized numeric id:', urlNumeric);

      /** Expand the group containing this card instantly (no animation wait). */
      function _expandGroupOf(card) {
        var groupSection = card.closest('.wb-venue-group');
        if (!groupSection) return;
        var groupHeader = groupSection.querySelector('[data-workshop-group-toggle]') ||
                          groupSection.querySelector('.wb-group-toggle');
        var groupBody = groupSection.querySelector('.wb-group-body');
        if (groupHeader && groupBody && groupHeader.getAttribute('aria-expanded') !== 'true') {
          groupBody.style.height  = 'auto';
          groupBody.style.opacity = '1';
          groupBody.setAttribute('aria-hidden', 'false');
          groupHeader.setAttribute('aria-expanded', 'true');
        }
      }

      /** Expand group, select card, update state, scroll to booking panel. */
      function _finishSelection(card) {
        if (window.__WB_DIAG__) console.log('[WB_RESTORE] _finishSelection called, card:', card ? card.dataset.eventId : 'null');
        if (!card) return;
        if (!wbIsEventBookable(card)) {
          if (window.__WB_DIAG__) console.log('[WB_RESTORE] not bookable — abort');
          return;
        }

        _expandGroupOf(card);
        setEventSelectionFromCard(card);
        if (window.__WB_DIAG__) console.log('[WB_RESTORE] setEventSelectionFromCard completed');

        // Clear so subsequent location changes don't re-trigger
        window.__WB_INITIAL_EVENT_ID__ = null;

        // Sync all venue card summaries
        var vcAll = eventsRoot.querySelectorAll('.workshop-venue-card');
        for (var v = 0; v < vcAll.length; v++) syncInCardSummaryForVenueCard(vcAll[v]);

        // Advance state so variant selector and buttons become active
        if (useLocationFirst && typeof setWbState === 'function') setWbState(2);

        validateSeatSelection();

        // Scroll booking panel into view (account for sticky header height)
        requestAnimationFrame(function () {
          var panel = booking.querySelector('[data-wb-panel]') || document.querySelector('[data-wb-panel]');
          if (!panel) return;
          function computeHeaderOffset() {
            var offset = 0;
            var headerCandidates = document.querySelectorAll('#shopify-section-header, .site-header, .header-wrapper, header');
            for (var h = 0; h < headerCandidates.length; h++) {
              var headerEl = headerCandidates[h];
              if (!headerEl) continue;
              var style = window.getComputedStyle(headerEl);
              if (style.position !== 'fixed' && style.position !== 'sticky') continue;
              var rect = headerEl.getBoundingClientRect();
              if (rect.height <= 0) continue;
              if (rect.bottom <= 0 || rect.top >= window.innerHeight) continue;
              offset = Math.max(offset, rect.height);
            }
            return offset;
          }
          function scrollWithOffset(behavior) {
            var headerOffset = computeHeaderOffset();
            var panelTop = panel.getBoundingClientRect().top + window.pageYOffset;
            var targetTop = Math.max(0, panelTop - headerOffset - 2);
            window.scrollTo({ top: targetTop, behavior: behavior });
          }
          scrollWithOffset('smooth');
          // Re-align once after layout settles (images/accordion height updates).
          setTimeout(function () { scrollWithOffset('auto'); }, 220);
        });
      }

      // ── Pass 1: DOM search (first date's slots already rendered) ──────────────
      var domCards = eventsRoot.querySelectorAll('.workshop-event-card');
      for (var i = 0; i < domCards.length; i++) {
        var dc = domCards[i];
        var dcId  = (dc.dataset.eventId            || '').toString().trim();
        var dcGid = (dc.dataset.eventMetaobjectGid || '').toString().trim();
        var dcNumeric = normalizeEventIdForMatch(dcId) || normalizeEventIdForMatch(dcGid);
        if (dcNumeric && dcNumeric === urlNumeric) {
          if (window.__WB_DIAG__) console.log('[WB_RESTORE] Pass 1 MATCH — calling _finishSelection for', dcId || dcGid);
          _finishSelection(dc);
          return;
        }
      }

      if (window.__WB_DIAG__) console.log('[WB_RESTORE] Pass 1 missed — searching venue data');

      // ── Pass 2: _wbVenue data search (handles non-first dates) ───────────────
      // Each .wb-venue-card stores _wbVenue with all events across all dates.
      // If target event is on a different date, switch the date dropdown,
      // let the existing 'change' listener rebuild slots, then select.
      var venueCardEls = eventsRoot.querySelectorAll('.wb-venue-card');
      for (var vc = 0; vc < venueCardEls.length; vc++) {
        var vcEl    = venueCardEls[vc];
        var vcVenue = vcEl._wbVenue;
        if (!vcVenue || !Array.isArray(vcVenue.events)) continue;

        for (var ei = 0; ei < vcVenue.events.length; ei++) {
          var ev = vcVenue.events[ei];
          var evNumeric = normalizeEventIdForMatch(String(ev.id                   || '')) ||
                          normalizeEventIdForMatch(String(ev.event_metaobject_gid || ''));
          if (!evNumeric || evNumeric !== urlNumeric) continue;

          if (wbIsEventSoldOut(ev) || wbShouldHideEvent(ev)) return;

          var targetDate   = String(ev.date_key || '').trim();
          var dateSelectEl = vcEl.querySelector('[data-workshop-venue-date]');

          if (dateSelectEl && targetDate && dateSelectEl.value !== targetDate) {
            dateSelectEl.value = targetDate;
            dateSelectEl.dispatchEvent(new Event('change', { bubbles: true }));
          }

          (function (_vcEl, _urlNumeric) {
            setTimeout(function () {
              var slotCards = _vcEl.querySelectorAll('.workshop-event-card');
              var matchCard = null;
              for (var s = 0; s < slotCards.length; s++) {
                var sNum = normalizeEventIdForMatch(slotCards[s].dataset.eventId            || '') ||
                           normalizeEventIdForMatch(slotCards[s].dataset.eventMetaobjectGid || '');
                if (sNum === _urlNumeric) { matchCard = slotCards[s]; break; }
              }
              _finishSelection(matchCard);
            }, 0);
          })(vcEl, urlNumeric);

          return;
        }
      }
    }

    if (typeof window !== 'undefined') window.__WB_trySelectEventFromUrl = trySelectEventFromUrl;

    // Legacy renderEventsListFromApi removed: venue-centric UI uses renderVenueCentricList

    /**
     * Venue-centric: all fetch flows must resolve to lat/lng and call fetchEventsByLatLng.
     * city_key and state_code are for display/grouping only; API is always lat/lng.
     */
    async function onLocationResolved(resolved) {
      var resolvedCityKey = (resolved.city_key != null && String(resolved.city_key).trim()) ? String(resolved.city_key).trim() : null;
      var resolvedStateCode = (resolved.state_code || resolved.state || '').toString().trim().toUpperCase();
      if (window.__WB_DIAG__) console.log('[workshop] onLocationResolved', { source: resolved.source, city_key: resolvedCityKey, state_code: resolvedStateCode, lat: resolved.lat, lng: resolved.lng });

      // 1) Only lat/lng triggers fetch. No city_key or state_code fallback.
      if (resolved.lat != null && resolved.lng != null && Number.isFinite(Number(resolved.lat)) && Number.isFinite(Number(resolved.lng))) {
        var label = [resolved.city, resolved.state || resolved.state_code].filter(Boolean).join(', ') || (resolved.lat + ', ' + resolved.lng);
        fetchEventsByLatLng(booking, Number(resolved.lat), Number(resolved.lng), getRadiusKm(booking), { label: label, source: resolved.source || 'places' });
        return;
      }

      // 2) No lat/lng: silently return. Do NOT clear UI or show error.
      //    Only handlePlaceSelect with Place + fetchFields triggers fetches.
      if (window.__WB_DIAG__) console.log('[WB_DIAG] onLocationResolved: no valid lat/lng, skipping (no UI change)');
      return;
    }

    function onLocationClear(opts) {
      window.__WORKSHOP_LOCATION__ = null;
      wbSetUserLoc(null, null);
      window.__WORKSHOP_VENUE_LIST__ = null;
      window.__WORKSHOP_PLACE_LAST_ID__ = '';
      window.__WB_LAST_CACHE_KEY__ = '';
      if (typeof window !== 'undefined') window.__WB_USER_CHOSEN_LOCATION__ = false;
      wbSetLocationUi({ clear: true });
      if (opts && opts.refetchDefault) {
        triggerDefaultPrefetch({ force: true });
      }
    }

    // Radius selector is intentionally disabled. Radius is controlled from Theme Editor.

    /** IP fallback when GPS/Wi‑Fi geolocation is unavailable (common on desktop). */
    function wbFetchApproxLocationFromIp() {
      var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timer = controller ? setTimeout(function () { controller.abort(); }, 8000) : null;
      return fetch('https://ipapi.co/json/', controller ? { signal: controller.signal } : undefined)
        .then(function (res) {
          if (!res.ok) throw new Error('ip geolocation http ' + res.status);
          return res.json();
        })
        .then(function (data) {
          var lat = Number(data.latitude);
          var lng = Number(data.longitude);
          if (!Number.isFinite(lat) || !Number.isFinite(lng)) throw new Error('ip geolocation missing coords');
          var label = [data.city, data.region_code || data.region].filter(Boolean).join(', ') || 'Your area';
          return { lat: lat, lng: lng, label: label, source: 'ip_geolocation' };
        })
        .finally(function () {
          if (timer) clearTimeout(timer);
        });
    }

    /**
     * Browser geolocation with staged accuracy + IP fallback. Wizard and PDP share this path.
     */
    function wbRunGeolocationWithFallback(onCoords, onError) {
      if (!navigator.geolocation) {
        wbFetchApproxLocationFromIp()
          .then(function (ip) {
            onCoords(ip.lat, ip.lng, ip.label, ip.source);
          })
          .catch(function () {
            onError({ code: 2 });
          });
        return;
      }
      function tryGeo(opts, onRecoverable) {
        navigator.geolocation.getCurrentPosition(
          function (pos) {
            onCoords(pos.coords.latitude, pos.coords.longitude, null, 'geolocation');
          },
          function (err) {
            var code = err && err.code;
            if (code === 1) {
              onError(err);
              return;
            }
            if (onRecoverable && (code === 2 || code === 3)) {
              onRecoverable();
              return;
            }
            onError(err);
          },
          opts
        );
      }
      tryGeo({ enableHighAccuracy: false, timeout: 22000, maximumAge: 300000 }, function () {
        tryGeo({ enableHighAccuracy: true, timeout: 22000, maximumAge: 0 }, function () {
          tryGeo({ enableHighAccuracy: false, timeout: 30000, maximumAge: 0 }, function () {
            wbFetchApproxLocationFromIp()
              .then(function (ip) {
                onCoords(ip.lat, ip.lng, ip.label, ip.source);
              })
              .catch(function () {
                onError({ code: 2 });
              });
          });
        });
      });
    }

    if (useLocBtn && !useLocBtn.dataset.wbUseLocBound) {
      useLocBtn.dataset.wbUseLocBound = '1';
      useLocBtn.addEventListener('click', function () {
        if (DEV_MODE) console.log('[WB_RADIUS] "Use my location" click fired');
        if (typeof window !== 'undefined') window.__WB_USER_CHOSEN_LOCATION__ = true;
        if (eventsRoot) eventsRoot.innerHTML = '';
        window.__WORKSHOP_VENUE_LIST__ = null;
        setLoading(booking, true);

        wbRunGeolocationWithFallback(wbFetchEventsFromResolvedCoords, function (err) {
          if (typeof window !== 'undefined') window.__WB_USER_CHOSEN_LOCATION__ = false;
          setLoading(booking, false);
          var code = err && err.code;
          var msg =
            code === 1
              ? 'Location permission denied. Allow location access in your browser, then try again.'
              : code === 2
                ? 'Could not determine your location. Search for a city instead.'
                : code === 3
                  ? 'Location request timed out. Try again.'
                  : 'Could not access your location. Try again or search for a city.';
          showWorkshopFetchError(msg);
          if (DEV_MODE) console.warn('[WB_RADIUS] geolocation error', err);
        });
      });
    }
    if (retryBtn) retryBtn.addEventListener('click', function () { onLocationClear({ refetchDefault: true }); });

    // Near-city-link handler removed: venue-centric UI does not use near locations.
    // All fetch flows use lat/lng only.

    function bindGooglePlacesPlaceElement() {
      /* PlaceAutocompleteElement bills Place Details Enterprise + Atmosphere. Unused. */
      return;
    }

    /** Watch place widget input while focused; MutationObserver covers DOM updates. */
    function startPlaceInputWatcher(placeEl) {
      if (!placeEl || placeEl.dataset.wbInputWatcherStarted) return;
      placeEl.dataset.wbInputWatcherStarted = '1';
      var lastValue = '';
      var lastProcessedKey = '';
      var checkInterval = null;

      function readCurrentValue() {
        var currentValue = '';
        try {
          var inner = placeEl.shadowRoot && placeEl.shadowRoot.querySelector('input');
          if (inner && inner.value) currentValue = inner.value.trim();
          if (!currentValue) {
            var hidden = document.getElementById('workshop-location-input');
            if (hidden && hidden.value) currentValue = hidden.value.trim();
          }
          if (!currentValue && locSummary && locSummary.textContent) currentValue = locSummary.textContent.trim();
        } catch (_) {}
        return currentValue;
      }

      function processValue(currentValue) {
        if (!(currentValue && currentValue !== lastValue && currentValue.indexOf(',') >= 0 && currentValue !== 'Location selected')) {
          return;
        }
        lastValue = currentValue;
        var fallbackParsed = parseCityStateFromFormattedAddress(currentValue);
        if (fallbackParsed && (fallbackParsed.city || fallbackParsed.state_code)) {
          var prev = window.__WORKSHOP_LOCATION__ || null;
          var prevKey = prev && prev.city_key ? String(prev.city_key).trim() : '';
          var prevState = prev && prev.state_code ? String(prev.state_code).trim().toUpperCase() : '';
          var flowRef = window.WorkshopLocationFlow;
          var cityKey = (flowRef && typeof flowRef.deriveEventCityKey === 'function')
            ? flowRef.deriveEventCityKey(fallbackParsed.state_code, fallbackParsed.city)
            : '';
          var newState = (fallbackParsed.state_code || fallbackParsed.state || '').toString().trim().toUpperCase();
          var processKey = (cityKey || '') + '|' + newState;
          if (prevKey !== cityKey || prevState !== newState) {
            if (lastProcessedKey === processKey) {
              if (window.__WB_DIAG__) console.log('[WB_DIAG] place input watcher: skipping duplicate', { city_key: cityKey, state_code: newState });
              return;
            }
            lastProcessedKey = processKey;
            if (window.__WB_DIAG__) console.log('[WB_DIAG] place input watcher: text changed, no lat/lng — skipping (only handlePlaceSelect triggers fetch)', { state_code: newState, currentValue: currentValue });
          }
        }
      }

      function stopInterval() {
        if (checkInterval) {
          clearInterval(checkInterval);
          checkInterval = null;
        }
      }

      function startInterval() {
        if (checkInterval) return;
        checkInterval = setInterval(function () {
          if (!placeEl.parentNode) {
            stopInterval();
            return;
          }
          processValue(readCurrentValue());
        }, 400);
      }

      placeEl.addEventListener('focusin', startInterval);
      placeEl.addEventListener('focusout', function () {
        setTimeout(stopInterval, 300);
      });
      
      // Also use MutationObserver for faster detection
      try {
        var observer = new MutationObserver(function(mutations) {
          var currentValue = '';
          try {
            var inner = placeEl.shadowRoot && placeEl.shadowRoot.querySelector('input');
            if (inner && inner.value) currentValue = inner.value.trim();
            if (!currentValue) {
              var hidden = document.getElementById('workshop-location-input');
              if (hidden && hidden.value) currentValue = hidden.value.trim();
            }
            if (!currentValue && locSummary && locSummary.textContent) currentValue = locSummary.textContent.trim();
          } catch (_) {}
          if (currentValue && currentValue.indexOf(',') >= 0 && currentValue !== 'Location selected') {
            // Trigger immediate check
            setTimeout(function() {
              var checkValue = '';
              try {
                var inner = placeEl.shadowRoot && placeEl.shadowRoot.querySelector('input');
                if (inner && inner.value) checkValue = inner.value.trim();
                if (!checkValue) {
                  var hidden = document.getElementById('workshop-location-input');
                  if (hidden && hidden.value) checkValue = hidden.value.trim();
                }
                if (!checkValue && locSummary && locSummary.textContent) checkValue = locSummary.textContent.trim();
              } catch (_) {}
              if (checkValue && checkValue.indexOf(',') >= 0) {
                var parsed = parseCityStateFromFormattedAddress(checkValue);
                if (parsed && (parsed.city || parsed.state_code)) {
                  var flowRef = window.WorkshopLocationFlow;
                  var cityKey = (flowRef && typeof flowRef.deriveEventCityKey === 'function')
                    ? flowRef.deriveEventCityKey(parsed.state_code, parsed.city)
                    : '';
                  var newState = (parsed.state_code || parsed.state || '').toString().trim().toUpperCase();
                  var prev = window.__WORKSHOP_LOCATION__ || null;
                  var prevKey = prev && prev.city_key ? String(prev.city_key).trim() : '';
                  var prevState = prev && prev.state_code ? String(prev.state_code).trim().toUpperCase() : '';
                  if (prevKey !== cityKey || prevState !== newState) {
                    var resolved = {
                      lat: undefined,
                      lng: undefined,
                      city: parsed.city,
                      state: parsed.state,
                      state_code: newState,
                      country: parsed.country || 'US',
                      source: 'places',
                      city_key: cityKey ? String(cityKey).trim() : undefined
                    };
                    if (window.__WB_DIAG__) console.log('[WB_DIAG] MutationObserver: text changed, no lat/lng — skipping (only handlePlaceSelect triggers fetch)', { state_code: resolved.state_code, checkValue: checkValue });
                    // Do NOT call onLocationResolved without lat/lng — it would clear UI and show error.
                  }
                }
              }
            }, 100);
          }
        });
        // Observe the hidden input and locSummary
        var hiddenInput = document.getElementById('workshop-location-input');
        if (hiddenInput) observer.observe(hiddenInput, { attributes: true, attributeFilter: ['value'] });
        if (locSummary) observer.observe(locSummary, { childList: true, characterData: true, subtree: true });
      } catch (e) {
        if (window.__WB_DIAG__) console.warn('[WB_DIAG] MutationObserver failed', e);
      }
    }

    function attachPlaceAutocompleteFocusHandler(inputEl) {
      if (!inputEl || inputEl.dataset.googleBound || !googleKey) return;
      inputEl.addEventListener('focus', function onLocFocus() {
        ensureGooglePlacesLoaded(googleKey).then(() => bindGooglePlacesPlaceElement()).catch((err) => {
          gmapsLastError = (err && err.message) || '[WB] Google Places load failed';
          if (window.__WB_DIAG__) console.warn('[WB]', gmapsLastError);
        });
        inputEl.removeEventListener('focus', onLocFocus);
      }, { once: true });
    }
    if (googleKey && locInput && !wbWizardInventorySearchActive()) {
      locInput.addEventListener('focus', function onLocFocusCheap() {
        ensureGooglePlacesLoaded(googleKey).catch(function () {});
        locInput.removeEventListener('focus', onLocFocusCheap);
      }, { once: true });
    }

    document.addEventListener('shopify:section:load', () => {
      if (!useLocationFirst) return;
      requestAnimationFrame(() => {
        const newInput = document.getElementById('workshop-location-input');
        const root = document.querySelector('.pdp-workshop-booking');
        if (!root || !newInput || newInput.closest('.pdp-workshop-booking') !== root) return;
        if (!googleKey || newInput.dataset.googleBound) return;
        setupWizardVenueInventorySearch();
        ensureGooglePlacesLoaded(googleKey).catch(function () {});
      });
    });
    window.__WORKSHOP_DIAG_GMAPS = function () {
      const kEl =
        (booking && booking.querySelector && booking.querySelector('[data-google-maps-key]')) ||
        (booking && booking.hasAttribute && booking.hasAttribute('data-google-maps-key') ? booking : null);
      const k = kEl ? (kEl.getAttribute('data-key') || (kEl.dataset && kEl.dataset.key) || '') : '';
      const scripts = Array.from(document.querySelectorAll('script[src*="maps.googleapis.com"]')).map((s) => s.src);
      const placeElementMounted = !!document.getElementById('workshop-location-place-autocomplete');
      return {
        hasKey: !!k && k.length > 0,
        keyLen: (k || '').length,
        hasGoogle: !!(typeof window !== 'undefined' && window.google),
        hasPlaces: !!(typeof window !== 'undefined' && window.google && window.google.maps && window.google.maps.places),
        scripts,
        placeElementMounted,
        lastError: gmapsLastError || null
      };
    };

    /* Waitlist modal: only [data-wb-waitlist-open] opens it — no whole-card click (see renderVenueCentricList openBtn listener). */

      if (typeof startPlaceInputWatcher === "function") S.startPlaceInputWatcher = startPlaceInputWatcher;
      global.WorkshopBookingLocation.closeAllVenueCardsExcept = wbCloseAllVenueCardsExcept;
      global.WorkshopBookingLocation.expandBody = wbExpandBody;
      global.WorkshopBookingLocation.collapseBody = wbCollapseBody;

    }
  };
})(typeof window !== "undefined" ? window : this);
